<div class="d-flex flex-column h-100">
  <div class="container my-auto">
    <div class="d-flex flex-column align-items-center">
      <h1 class="text-center mt-4">
        {{ 'pending.noAssignments' | translate }}
      </h1>
      <svg
        id="af9e1180-c9a5-4b39-ac7d-0f358d77dfea"
        class="top-svg"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="1063.44683"
        height="795.60107"
        viewBox="0 0 1063.44683 795.60107"
      >
        <defs>
          <linearGradient
            id="f9e08372-f955-474a-ab6a-b0cb6d2d47e2"
            x1="232.94435"
            y1="598.64552"
            x2="232.94435"
            y2="497.84938"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stop-color="gray" stop-opacity="0.25" />
            <stop offset="0.53514" stop-color="gray" stop-opacity="0.12" />
            <stop offset="1" stop-color="gray" stop-opacity="0.1" />
          </linearGradient>
          <linearGradient
            id="e2c3e3a3-cac1-4055-a5e1-d90d4080aa08"
            x1="479.6705"
            y1="765.96558"
            x2="479.6705"
            y2="524.0001"
            xlink:href="#f9e08372-f955-474a-ab6a-b0cb6d2d47e2"
          />
          <linearGradient
            id="ebe06cb1-039b-4158-a251-2e122d9c2c67"
            x1="640.5084"
            y1="602.47616"
            x2="640.5084"
            y2="446.79016"
            xlink:href="#f9e08372-f955-474a-ab6a-b0cb6d2d47e2"
          />
          <linearGradient
            id="be5f500e-5c68-43e8-825c-0afbeb8a08aa"
            x1="353.41858"
            y1="525.80453"
            x2="353.41858"
            y2="449.34039"
            xlink:href="#f9e08372-f955-474a-ab6a-b0cb6d2d47e2"
          />
        </defs>
        <title>{{ 'pending.imageTitle' | translate }}</title>
        <path
          d="M79.75693,320.20369c16.8298,46.2486,52.44975,86.226,108.74783,105.60426,116.99961,40.27217,380.86073,19.50032,577.78683-4.3417,101.84425-12.33036,191.38411-46.34367,256.42656-94.25949Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
          opacity="0.1"
        />
        <path
          d="M1112.43957,102.51015H1004.38928c-5.13572,0-9.33772-2.702-9.33772-6.00435s4.202-6.00435,9.33772-6.00435h18.67533c-5.1356,0-9.33761-2.702-9.33761-6.00439s4.202-6.00436,9.33761-6.00436h-13.33952c-5.13572,0-9.33767-2.702-9.33767-6.00435s4.202-6.00439,9.33767-6.00439h56.39469a216.03046,216.03046,0,0,0-43.99137-7.79646c-153.77473-12.70033-208.6775-4.29959-228.04811,4.34094a287.011,287.011,0,0,1-79.03579,22.27791C620.16228,97.89069,442.7282,113.03406,281.908,80.45947c-79.93312-16.1907-139.33874,11.16772-174.94787,56.89512h1024.242c-1.33969-13.29126-5.33936-25.56565-12.68955-36.3031A12.6681,12.6681,0,0,1,1112.43957,102.51015Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
          opacity="0.1"
        />
        <path
          d="M70.58747,223.67a198.49993,198.49993,0,0,0,4.19378,80.69032l948.663,22.31044c26.26277-19.44376,48.50848-41.15813,65.90967-64.63688Zm375.2116,57.56218H427.12368c5.13572,0,9.33766,2.70191,9.33766,6.00435s-4.20194,6.00435-9.33766,6.00435H319.07338c-5.13571,0-9.33772-2.702-9.33772-6.00435s4.202-6.00435,9.33772-6.00435h18.67533c-5.13566,0-9.33766-2.702-9.33766-6.00439s4.202-6.00436,9.33766-6.00436H324.40919c-5.13572,0-9.33766-2.702-9.33766-6.00435s4.20194-6.00439,9.33766-6.00439h108.0503c5.13571,0,9.33772,2.702,9.33772,6.00439s-4.202,6.00435-9.33772,6.00435h13.33958c5.13565,0,9.33766,2.70192,9.33766,6.00436S450.93472,281.23219,445.79907,281.23219Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
          opacity="0.1"
        />
        <path
          d="M1131.24494,137.77151,95.53013,153.97131a190.41481,190.41481,0,0,0-24.80126,68.77581H1113.0951a201.68568,201.68568,0,0,0,15.049-43.83871C1131.24873,164.56381,1132.49139,150.6933,1131.24494,137.77151ZM281.01306,190.85324H262.33768c5.13572,0,9.33766,2.70192,9.33766,6.00435s-4.20194,6.00435-9.33766,6.00435H154.28738c-5.13571,0-9.33772-2.702-9.33772-6.00435s4.202-6.00435,9.33772-6.00435h18.67533c-5.13566,0-9.33766-2.702-9.33766-6.00439s4.202-6.00435,9.33766-6.00435H159.62319c-5.13572,0-9.33766-2.702-9.33766-6.00435s4.20194-6.00439,9.33766-6.00439h108.0503c5.13571,0,9.33772,2.702,9.33772,6.00439s-4.202,6.00435-9.33772,6.00435h13.33957c5.13566,0,9.33767,2.70192,9.33767,6.00435S286.14872,190.85324,281.01306,190.85324Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
          opacity="0.1"
        />
        <path
          d="M560.82047,663.55151v29.33333h6.56731s3.39689-28.66666-.88489-33.25S560.82047,663.55151,560.82047,663.55151Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#504f60"
        />
        <path
          d="M324.88778,617.21818s192-38,194.66667-24.66667c0,0,3,4.33333,1.83333,13.16667s-3,35.16666,19,37.16666,26.83333,6.16667,27,21.33334l-188.5,61.83333-22.16667-27s-20-9.83333-20.5-9.83333-11.33333-24.16667-11.33333-24.16667l-1.83333-21.5,2.83333-18.83333Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#6e6d84"
        />
        <rect
          x="326.83106"
          y="609.65557"
          width="194.96581"
          height="1.00086"
          transform="translate(-159.38759 22.54101) rotate(-9.09469)"
          fill="#504f60"
        />
        <rect
          x="325.15661"
          y="619.64744"
          width="197.83767"
          height="1.00053"
          transform="translate(-166.36831 27.79585) rotate(-9.66459)"
          fill="#504f60"
        />
        <rect
          x="324.08486"
          y="631.88572"
          width="198.50215"
          height="1.00052"
          transform="translate(-180.36289 39.40156) rotate(-10.9151)"
          fill="#504f60"
        />
        <rect
          x="324.37983"
          y="641.38482"
          width="198.57873"
          height="1.00038"
          transform="translate(-192.48324 49.92263) rotate(-12.001)"
          fill="#504f60"
        />
        <rect
          x="328.03933"
          y="650.58317"
          width="197.32467"
          height="1.00016"
          transform="translate(-203.59387 60.25738) rotate(-12.97784)"
          fill="#504f60"
        />
        <rect
          x="333.34619"
          y="659.13487"
          width="196.62111"
          height="1.00027"
          transform="translate(-210.27782 66.73006) rotate(-13.49356)"
          fill="#504f60"
        />
        <rect
          x="345.21299"
          y="664.28039"
          width="190.86308"
          height="1.00024"
          transform="translate(-219.90751 78.43639) rotate(-14.41613)"
          fill="#504f60"
        />
        <rect
          x="354.58945"
          y="668.91077"
          width="195.68244"
          height="1.00022"
          transform="translate(-228.73889 90.74523) rotate(-15.28456)"
          fill="#504f60"
        />
        <rect
          x="364.79425"
          y="674.97428"
          width="199.95302"
          height="1.00016"
          transform="translate(-237.35853 103.17084) rotate(-16.09909)"
          fill="#504f60"
        />
        <rect
          x="370.24527"
          y="683.87074"
          width="200.40008"
          height="1.0002"
          transform="translate(-243.33324 109.66831) rotate(-16.50635)"
          fill="#504f60"
        />
        <path
          d="M326.55445,614.88484s-9.66667,2.5-10,36.33334a43.46612,43.46612,0,0,0,2.5,18.19275c3.5,9.14058,8.83333,21.97391,6.16666,29.97391,0,0-2.59779,21.5-8.7989,26.66667l5.96557,5.33333s13.58112-31.0666,28.5-26.16666,19.5,12.83333,17.83333,37.33333l-1.66666,20.83333,7.33333,4.16667s11-31,1.66667-59.83333c0,0-9.33334-13.66667-21.66667-18.16667s-18.59332-6.59123-24.83333-24.77117c0,0-2.33334-17.48017-.83334-23.77117S330.05445,615.88484,326.55445,614.88484Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#504f60"
        />
        <path
          d="M832.52581,529.78787v8.81593h1.97376s1.02091-8.61557-.26595-9.99306S832.52581,529.78787,832.52581,529.78787Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#504f60"
        />
        <path
          d="M761.61791,515.86271s57.70424-11.42063,58.50569-7.41339a5.92088,5.92088,0,0,1,.551,3.95715c-.35063,2.6548-.90162,10.56909,5.71032,11.17018s8.06457,1.85335,8.11466,6.41158L777.84723,548.5718l-6.662-8.11466s-6.01086-2.95533-6.16113-2.95533-3.40615-7.26313-3.40615-7.26313l-.551-6.46167.85154-5.66022Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#6e6d84"
        />
        <rect
          x="762.20195"
          y="513.58983"
          width="58.5956"
          height="0.3008"
          transform="translate(-139.53138 79.36873) rotate(-9.09469)"
          fill="#504f60"
        />
        <rect
          x="761.6987"
          y="516.59281"
          width="59.45872"
          height="0.3007"
          transform="translate(-143.79507 87.99945) rotate(-9.66459)"
          fill="#504f60"
        />
        <rect
          x="761.3766"
          y="520.27094"
          width="59.65842"
          height="0.3007"
          transform="translate(-152.50672 107.03369) rotate(-10.9151)"
          fill="#504f60"
        />
        <rect
          x="761.46524"
          y="523.12583"
          width="59.68144"
          height="0.30066"
          transform="translate(-159.78596 123.77258) rotate(-12.001)"
          fill="#504f60"
        />
        <rect
          x="762.56508"
          y="525.89033"
          width="59.30454"
          height="0.30059"
          transform="translate(-166.17614 139.14882) rotate(-12.97784)"
          fill="#504f60"
        />
        <rect
          x="764.16002"
          y="528.46048"
          width="59.09309"
          height="0.30062"
          transform="translate(-169.71118 147.59256) rotate(-13.49356)"
          fill="#504f60"
        />
        <rect
          x="767.72651"
          y="530.00693"
          width="57.36255"
          height="0.30062"
          transform="translate(-175.18948 162.76924) rotate(-14.41613)"
          fill="#504f60"
        />
        <rect
          x="770.54453"
          y="531.39856"
          width="58.81098"
          height="0.30061"
          transform="translate(-180.10438 177.47948) rotate(-15.28456)"
          fill="#504f60"
        />
        <rect
          x="773.61151"
          y="533.2209"
          width="60.09447"
          height="0.30059"
          transform="translate(-184.66344 191.57147) rotate(-16.09909)"
          fill="#504f60"
        />
        <rect
          x="775.24978"
          y="535.89467"
          width="60.22883"
          height="0.3006"
          transform="translate(-187.38807 198.71322) rotate(-16.50635)"
          fill="#504f60"
        />
        <path
          d="M762.11881,515.16145s-2.90525.75135-3.00543,10.91972a13.0635,13.0635,0,0,0,.75136,5.46771c1.0519,2.74713,2.6548,6.6041,1.85335,9.00845,0,0-.78075,6.46167-2.64445,8.01447l1.79291,1.6029s4.08171-9.33685,8.56547-7.86421,5.86059,3.857,5.35969,11.22027l-.50091,6.26131,2.204,1.25227s3.306-9.31684.50091-17.98249c0,0-2.80507-4.10742-6.51177-5.45986s-5.58809-1.981-7.46348-7.4448c0,0-.70127-5.25355-.25045-7.14426S763.17071,515.462,762.11881,515.16145Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#504f60"
        />
        <path
          d="M129.69856,733.9097s5.47084-.87533,8.75334,2.99073c0,0-2.40716,1.89655-7.58622-.72945Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M129.11417,733.82466s-3.48944,4.3035-1.77811,9.07766c0,0,2.845-1.13907,3.15489-6.93756Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M125.97839,726.76114s2.18834-4.01195,10.94168,1.60478c0,0-1.16711,2.699-5.03317,2.48011S126.99962,728.87653,125.97839,726.76114Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M125.41392,726.47216s-4.54055-.51764-4.981,9.87344c0,0,2.87909.59775,4.92388-2.69058S126.55691,728.52432,125.41392,726.47216Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M122.76884,718.182s2.553-7.07562,11.817-2.04244c0,0-2.11539,6.49206-10.86874,4.44961Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M119.924,707.605s4.81434-7.14856,13.34884-.51061c0,0-2.99072,6.71089-12.6194,3.06367Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M118.90278,697.53868s5.61672-6.565,14.07829,0c0,0-5.32495,5.76261-14.07829,1.67772Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M118.02744,687.76411s5.68967-6.85678,13.78651-.36472c0,0-6.41911,6.05439-13.78651,1.9695Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M118.53805,679.08371s5.98145-8.82628,13.56768-2.84483c0,0-6.41911,7.58623-13.56768,4.52256Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M119.924,668.94443s6.34617-8.75334,13.71357-2.04245c0,0-7.51329,7.58623-13.71357,3.64723Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M122.04038,659.88111s7.51229-8.22453,14.0773-4.942c0,0-7.82939,8.73545-14.39439,7.13067Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M124.66539,651.29186s8.6804-10.06635,13.71357-6.7109c0,0-6.38735,7.80506-14.3383,8.60745Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M128.45562,641.32711s7.58912-8.22672,13.1329-6.18427c0,0-6.49206,8.5345-14.15124,8.75334Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M131.8869,632.00622s8.38862-7.878,12.03584-6.49206c0,0-6.05439,8.75334-12.40056,8.24273Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M135.24235,623.39877s7.2215-9.40984,11.16051-8.6804c0,0-4.37667,8.38862-11.16051,9.62868Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M138.88332,611.79579s6.38292-7.2149,9.83061-7.19732c0,0-5.03785,9.63249-10.093,9.54959Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M141.04144,604.06847l6.16381-15.02657s.30912,13.58325-6.94886,17.814Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M143.54362,587.49718s1.02122-12.54646.36472-13.56768c0,0,4.40826,10.43106-.40672,19.11146Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M122.5307,718.01381s-6.39407-3.96212-10.53211,5.7348c0,0,5.68868,3.77633,11.28306-3.259Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M119.71988,707.2016s-7.84139-3.57664-11.646,6.54388c0,0,6.058,4.157,12.359-3.98618Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M118.53805,698.14047s-5.61672-6.565-14.07829,0c0,0,5.325,5.76261,14.07829,1.67772Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M117.836,687.76411s-5.68967-6.85678-13.78651-.36472c0,0,6.41911,6.05439,13.78651,1.9695Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M118.53805,679.33343s-3.99135-9.88686-12.6659-5.6347c0,0,4.68,8.76659,12.313,7.2749Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M120.42647,668.8947s-3.9659-10.05816-12.77263-5.39383c0,0,5.38692,9.21853,12.37291,6.948Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M122.88547,659.93293s-1.57212-11.02752-8.84532-12.01477c0,0,1.5462,11.62827,7.87408,14.00157Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M124.85155,651.31093s-.61042-13.2781-6.64131-13.7474c0,0,.20345,10.08345,5.9614,15.62488Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M129.0817,640.947s-1.79922-11.047-7.5508-12.39773c0,0,.71416,10.69929,6.9848,15.10268Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M132.56957,632.08608s-.061-11.50775-3.57714-13.199c0,0-2.18078,10.41734,2.55847,14.66871Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M135.51069,623.27054s-.49293-11.85126-4.13441-13.52083c0,0-1.24639,9.37926,3.58885,14.29645Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M139.39231,612.73928s-.02227-9.63307-2.62139-11.89835c0,0-2.58491,10.55856,1.26377,13.83712Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M140.73486,603.59424l-2.528-16.04368s-3.43684,13.14489,2.64826,18.93707Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M141.22929,587.64957s-6.4931-10.78406-6.35911-11.99069c0,0,.68926,11.30331,8.86159,16.9377Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M141.98971,584.46464s-6.12734-15.31835-8.89923-16.55841c0,0,8.75271,4.44962,9.40985,16.12074Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M138.58828,614.23828l-.41843-.12822c5.1708-16.86183,6.461-27.62517,3.63287-30.30727l.30111-.31756C145.10168,586.32825,143.886,596.96251,138.58828,614.23828Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#444053"
        />
        <path
          d="M124.35,653.70739l-.61889-.21926c.54773-1.54519,1.1399-3.11261,1.76029-4.65865,5.39711-13.45164,9.99216-25.965,12.93839-35.57287l.53881-.27078c-2.95158,9.62525-7.464,22.6195-12.86793,36.08812C125.4837,650.61167,124.89463,652.17064,124.35,653.70739Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#444053"
        />
        <path
          d="M137.397,746.52989c-.084-.09339-8.46516-9.52952-14.3071-25.64306a94.93987,94.93987,0,0,1-5.65163-29.37734c-.40006-12.53783,2.23028-26.53793,6.73752-39.25346l.48961.57325c-10.11677,28.54058-6.09738,52.99821-.76588,67.72246,5.78092,15.96566,14.0655,25.3007,14.14853,25.393Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#444053"
        />
        <path
          d="M731.35061,496.00073s34.47747-1.45168,38.10668-68.95494-32.29995-78.93526-32.29995-78.93526-11.38352-6.35691-16.43122-6.62258-21.91764,1.32835-21.91764,1.32835l18.59679-3.58653s-26.16834-9.96256-34.00556-10.75957l28.29369,5.97754s.3985-15.67443-6.376-20.855c0,0,5.77531-.431,8.85452,10.85865A21.57155,21.57155,0,0,0,727.086,338.94687c10.49607,4.09337,25.0049,10.55431,28.30989,16.09017,0,0,6.11037,6.376,5.18053-10.22823S755.263,313.98694,753.669,313.5906c0,0-12.48641-13.28125-30.02053-14.07825,0,0,10.22824-4.11786,27.49668,8.767,0,0,1.46118-6.50887-5.0477-14.21326s-16.60427-23.91015-27.62951-25.637c0,0,15.40877-.92983,27.62951,18.99529,0,0,4.51637,2.92236,4.91487-4.51636a91.6084,91.6084,0,0,1,3.05519-16.73711s3.71935,17.13561-4.11786,24.84c0,0,15.01026,19.52663,14.34609,41.44427,0,0,4.6492,9.96256,6.376-1.72685,0,0,.99957-16.09831,2.99871-29.75443a40.44145,40.44145,0,0,0-8.48183-31.19337c-3.31882-4.1309-5.631-8.14491-4.34661-10.25133l17.40128,20.72214s14.61176-33.87272,25.2385-41.1786,11.95508-8.89989,11.95508-8.89989l-17.13562,20.058,21.51914-7.57155-21.51914,9.96257s-9.96256,8.10288-15.67443,30.28619-6.24321,35.99807-6.24321,35.99807,30.6847-24.30866,36.52941-23.51165l-19.85774,15.01786a47.31024,47.31024,0,0,0-18.66418,34.52927v0s38.38908-9.82973,47.68748-11.68941l17.53411-17.93261-13.28342,17.00277,27.36384-.3985,15.67444-11.15807s-12.35358,10.36107-11.15807,11.02524,19.261,1.46117,19.261,1.46117-45.96064-.26567-51.00834,3.05519-16.3386,4.51636-16.3386,4.51636l32.54438,4.91487-38.78759-2.78952S774.524,348.2625,772.93,357.42806c0,0,5.982,15.59936,9.96257,21.78481,3.30749,5.13953,9.96256,21.7848,11.2909,36.39657s3.188,37.06074-1.85967,50.74266-6.90738,21.51914-4.38353,25.637,4.91486,9.43123-3.32086,10.4939-44.36662-.53134-44.36662-.53134S729.223,504.13022,731.35061,496.00073Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#dea3a2"
        />
        <path
          d="M750.66018,488.75169a17.35126,17.35126,0,0,1,11.70281-1.46285c6.76568,1.46285,17.12715.68754,18.0721.52662"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M772.30165,409.20917s1.64571,25.9656-1.28,31.08558Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M778.37608,440.29475s-2.1097,24.3199-3.57027,29.07416S778.37608,440.29475,778.37608,440.29475Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M780.43509,380.50072c1.49353.54857,7.8935,13.53137,6.61351,17.37135S780.43509,380.50072,780.43509,380.50072Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M764.20724,367.02423c.69463.31593,3.67123,7.7928,3.07591,10.00427S764.20724,367.02423,764.20724,367.02423Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M791.919,410.62844c-.73845,7.54069-1.14125,12.47781-.67132,18.51207a71.12952,71.12952,0,0,1-.2014,14.07994"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M711.78035,322.83237a6.036,6.036,0,0,1,1.24792,3.822c.04478,1.36665-.13366,2.73587-.04328,4.10026.09508,1.43553.77589,3.11923,2.20172,3.31109"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M736.31042,277.87663a34.70119,34.70119,0,0,1,4.80825,5.96726,14.08387,14.08387,0,0,0,1.36472,1.94281,22.29428,22.29428,0,0,0,2.63636,2.1579,12.43145,12.43145,0,0,1,4.19928,6.589"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M805.74843,239.06476a8.51114,8.51114,0,0,1-1.70458,2.27989c-.60148.57211-1.28773,1.057-1.833,1.68293a13.26137,13.26137,0,0,0-1.17588,1.73217,47.51256,47.51256,0,0,1-4.91171,6.20412"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M773.59173,277.49089c1.14425.71466,1.44273,2.24677,1.41757,3.59561a10.21006,10.21006,0,0,0,.24662,4.00714c.22815.5701.59736,1.07436.83612,1.64011a7.6588,7.6588,0,0,1,.39461,3.12046q-.03023,1.83458-.10944,3.66791c-.06355,1.47052-.20276,3.06875-1.20232,4.14919"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M783.21417,315.60133a15.64627,15.64627,0,0,0-2.98113,2.05161,5.336,5.336,0,0,0-1.73291,3.10545c-.06577.51261-.03153,1.0378-.14449,1.54212a4.89175,4.89175,0,0,1-1.01931,1.86552,25.38288,25.38288,0,0,1-2.51627,2.78472"
          transform="translate(-68.27659 -52.19946)"
          fill="none"
        />
        <path
          d="M774.53983,350.28232A18.482,18.482,0,0,1,776.942,348.613a10.07416,10.07416,0,0,1,2.47265-1.08608,26.39714,26.39714,0,0,1,4.08118-.44046,5.76311,5.76311,0,0,0,3.719-1.52747"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M828.55164,333.50167a10.87632,10.87632,0,0,0-4.73235.84237c-.73347.37756-1.37156.91792-2.09243,1.319a6.33134,6.33134,0,0,1-3.04749.79468"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M806.14129,340.16942a.90235.90235,0,0,1,1.16124.27031c.28859.33075.44735.76053.74493,1.08323a3.34711,3.34711,0,0,0,2.42008.74181"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M796.89857,305.83865l-1.55522.81374a27.309,27.309,0,0,0-4.577,2.79153"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M779.15188,321.02561c-1.02134-.24144-1.90185.84635-2.0834,1.88a29.0223,29.0223,0,0,1-.26207,3.12936,5.81319,5.81319,0,0,1-1.53072,2.29452"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M761.87173,322.92224c-.92822,2.77327,1.04153,5.802.46558,8.66923-.17546.87344-.5813,1.6853-.78651,2.55223a7.7609,7.7609,0,0,0,1.8784,6.52064"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M347.61879,577.04327s-54.49886-2.29469-60.23559-108.99774S338.44,343.27181,338.44,343.27181s17.994-10.04843,25.973-10.46837,34.64543,2.09972,34.64543,2.09972l-29.39612-5.66925s41.36454-15.74792,53.75291-17.00776l-44.7241,9.44876s-.62992-24.77673,10.07867-32.96565c0,0-9.1291-.68128-13.99644,17.16436A34.09835,34.09835,0,0,1,354.36,328.78673c-16.59124,6.47042-39.52549,16.6833-44.74972,25.43388,0,0-9.65872,10.07867-8.18891-16.16786s8.39889-48.72043,10.91855-49.34692c0,0,19.7374-20.9938,47.45374-22.25364,0,0-16.16786-6.50914-43.46426,13.85818,0,0-2.3097-10.28865,7.97894-22.467s26.24654-37.795,43.67424-40.52465c0,0-24.35678-1.46981-43.67424,30.026,0,0-7.139,4.61939-7.769-7.13906S311.71,213.74915,311.71,213.74915s-5.87923,27.08643,6.50914,39.26482c0,0-23.72687,30.86593-22.677,65.51135,0,0-7.349,15.74792-10.07867-2.72964,0,0-1.58-25.44675-4.74008-47.03311a63.92609,63.92609,0,0,1,13.40731-49.30766c5.24609-6.52976,8.901-12.87473,6.87072-16.20437L273.495,236.00621s-23.097-53.54293-39.89474-65.09141-18.8975-14.06814-18.8975-14.06814l27.08642,31.70581-34.01551-11.96842L241.7892,192.332s15.74793,12.80831,24.77673,47.87368,9.8687,56.90249,9.8687,56.90249-48.5036-38.42493-57.74238-37.1651l31.38932,23.73888a74.78381,74.78381,0,0,1,29.50264,54.58075v0s-60.682-15.538-75.38006-18.47756L176.48782,291.4389l20.99723,26.87645-43.25429-.62992L129.454,300.04776s19.52742,16.37784,17.63767,17.4277-30.446,2.3097-30.446,2.3097,72.65041-.42,80.62936,4.82936,25.82659,7.13906,25.82659,7.13906l-51.44321,7.769,61.31191-4.40942s46.40387,8.3989,48.92354,22.887c0,0-9.45578,24.65806-15.74792,34.43546-5.22819,8.12411-15.74792,34.43546-17.84764,57.53241s-5.03934,58.58227,2.93961,80.20941,10.91856,34.01551,6.92908,40.52466-7.769,14.908,5.24931,16.58781S333.5471,586.45,333.5471,586.45,350.98191,589.89363,347.61879,577.04327Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#dea3a2"
        />
        <path
          d="M317.096,565.58464a27.42726,27.42726,0,0,0-18.49874-2.31234c-10.69459,2.31234-27.07305,1.0868-28.56675.83244"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M282.88709,439.851s-2.60139,41.04408,2.0233,49.13728Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M273.28518,488.98829s3.33483,38.4427,5.64356,45.95781S273.28518,488.98829,273.28518,488.98829Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M270.03048,394.47129c-2.36083.86713-12.47733,21.38917-10.454,27.45907S270.03048,394.47129,270.03048,394.47129Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M295.682,373.16888c-1.098.49938-5.80315,12.31815-4.86212,15.81384S295.682,373.16888,295.682,373.16888Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M251.87782,442.09447c1.16728,11.91964,1.804,19.7238,1.06117,29.26221a112.435,112.435,0,0,0,.31835,22.2563"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M378.55369,303.31439a9.54105,9.54105,0,0,0-1.97259,6.04155c-.07079,2.16027.21126,4.3246.06841,6.48131-.1503,2.26915-1.22647,4.93059-3.48028,5.23386"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M339.77877,232.25241a54.85268,54.85268,0,0,0-7.60044,9.43251,22.2617,22.2617,0,0,1-2.15723,3.071,35.239,35.239,0,0,1-4.16733,3.411,19.65054,19.65054,0,0,0-6.63783,10.41527"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M230.01744,170.90211a13.45336,13.45336,0,0,0,2.69445,3.60385c.95077.90433,2.03553,1.67081,2.8974,2.66022a20.96007,20.96007,0,0,1,1.85873,2.73806,75.10346,75.10346,0,0,0,7.764,9.80691"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M280.84784,231.64267c-1.80871,1.12967-2.28052,3.55148-2.24075,5.68362s.40247,4.35426-.38984,6.33411c-.36064.90117-.94426,1.69826-1.32166,2.59254a12.10593,12.10593,0,0,0-.62376,4.93254q.04776,2.89993.173,5.79791c.10045,2.32447.32051,4.8508,1.90051,6.55866"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M265.63756,291.8842a24.73211,24.73211,0,0,1,4.71231,3.243,8.43466,8.43466,0,0,1,2.73922,4.90882c.104.81029.04985,1.64046.2284,2.43764a7.73241,7.73241,0,0,0,1.61123,2.94885,40.123,40.123,0,0,0,3.9775,4.40183"
          transform="translate(-68.27659 -52.19946)"
          fill="none"
        />
        <path
          d="M279.34917,346.70477a29.21634,29.21634,0,0,0-3.79705-2.63873,15.9245,15.9245,0,0,0-3.90855-1.71678,41.72612,41.72612,0,0,0-6.45116-.69624,9.10983,9.10983,0,0,1-5.87868-2.41448"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M193.9722,320.17945c2.55452.0688,5.20837.162,7.48046,1.33153,1.15941.59681,2.168,1.451,3.30752,2.085a10.00815,10.00815,0,0,0,4.8172,1.25616"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M229.39644,330.71922a1.42636,1.42636,0,0,0-1.83558.42727c-.45617.52284-.70712,1.2022-1.17751,1.71228-.92971,1.00819-2.45487,1.12414-3.82544,1.17259"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M244.00651,276.45224l2.45834,1.28629a43.16806,43.16806,0,0,1,7.235,4.4126"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M272.05886,300.45841c1.61445-.38164,3.00628,1.33784,3.29326,2.97176s-.04908,3.35368.41426,4.9466a9.18878,9.18878,0,0,0,2.41962,3.627"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M299.37377,303.45643c1.46724,4.38374-1.64637,9.17131-.736,13.70354.27734,1.38066.91886,2.664,1.24325,4.03434.8537,3.60649-.61259,7.44684-2.96921,10.30724"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M1043.0008,654.38846s-11.02661,1.195-5.34259-16.38856l3.35831-.42678,1.64286-3.84107s2.39-5.46285,4.01178-4.95071,3.81529,1.10964,4.1696-1.02428a7.39125,7.39125,0,0,1,4.68959-5.3775c2.40794-.76821,14.52864-8.4437,17.17471-14.76345s5.12142-7.984,5.12142-7.984,3.49964.09982,1.28036,14.11236c0,0-.76821,4.794-1.87786,5.81827s-10.58427,10.84035-10.58427,10.84035l-4.78,11.35248-1.79249,5.63357s4.43856,4.35321-1.66447,8.79178-13.99131,1.87785-13.99131,1.87785Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M1043.51161,651.99846l9.70763-17.07141,8.9869-10.24285s10.07214-11.69391,11.35249-14.08391c0,0,3.41428-6.40328,3.49964-7.98164"
          transform="translate(-68.27659 -52.19946)"
          fill="none"
          stroke="#444053"
          stroke-miterlimit="10"
        />
        <path
          d="M1056.75055,652.33989s-9.95457-1.65759-12.9618-.82879"
          transform="translate(-68.27659 -52.19946)"
          fill="none"
          stroke="#444053"
          stroke-miterlimit="10"
        />
        <path
          d="M1039.158,645.34061s4.523,2.64607,4.35359,3.41428"
          transform="translate(-68.27659 -52.19946)"
          fill="none"
          stroke="#444053"
          stroke-miterlimit="10"
        />
        <path
          d="M1047.43937,632.11027s1.26434,10.7576.36393,12.341"
          transform="translate(-68.27659 -52.19946)"
          fill="none"
          stroke="#444053"
          stroke-miterlimit="10"
        />
        <path
          d="M1058.40775,641.15812s-11.14887,4.25057-11.53076,4.92214"
          transform="translate(-68.27659 -52.19946)"
          fill="none"
          stroke="#444053"
          stroke-miterlimit="10"
        />
        <path
          d="M1055.56271,625.45242s-.75895,7.48145-1.70249,8.74408"
          transform="translate(-68.27659 -52.19946)"
          fill="none"
          stroke="#444053"
          stroke-miterlimit="10"
        />
        <path
          d="M1061.43793,632.11027s-7.62269,1.7687-8.21869,2.81678"
          transform="translate(-68.27659 -52.19946)"
          fill="none"
          stroke="#444053"
          stroke-miterlimit="10"
        />
        <path
          d="M1069.03471,622.29421l-7.50258,3.15821s1.52758-5.3775,1.18615-5.88964"
          transform="translate(-68.27659 -52.19946)"
          fill="none"
          stroke="#444053"
          stroke-miterlimit="10"
        />
        <path
          d="M1076.034,614.66243s-8.70029,2.93714-8.49,3.70535l.97853-3.70535"
          transform="translate(-68.27659 -52.19946)"
          fill="none"
          stroke="#444053"
          stroke-miterlimit="10"
        />
        <polyline
          points="1008.782 555.851 1005.282 558.401 1004.855 556.074"
          fill="none"
          stroke="#444053"
          stroke-miterlimit="10"
        />
        <path
          d="M1047.26866,582.3471s7.42606-40.71531,10.11481-43.9162l1.02428.76821s-10.3754,38.14066-10.24736,49.66387c0,0-7.25083,58.3-2.51352,76.225,0,0,.5975,3.29907-1.067,3.68317a207.27713,207.27713,0,0,1-.16347-55.77917"
          transform="translate(-68.27659 -52.19946)"
          fill="#444053"
        />
        <path
          d="M1046.93312,588.74888s4.35321-6.01767,8.57838-6.40178"
          transform="translate(-68.27659 -52.19946)"
          fill="none"
          stroke="#444053"
          stroke-miterlimit="10"
        />
        <path
          d="M1057.81614,579.65836s-3.37518,1.81-3.224,2.85752,4.05626,1.30363,4.05626,1.30363Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#444053"
        />
        <path
          d="M1059.8007,576.90559s5.69758-4.16116,7.234-1.02428-.64018,4.16115-.64018,4.16115l-4.16116,1.40839s5.69759-.32009,4.41723,5.82562c0,0-3.777,3.32893-5.95365-.3841,0,0-.38411,2.74391-1.53643,1.75606s-3.521-2.04427-1.60045-6.86155Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M1060.1848,580.36255s.89625-7.81017-1.98455-7.106-2.24062,4.28919-2.24062,4.28919l1.53643,3.585Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M1058.94722,580.78612a.5.5,0,0,0,.19608-.02805.48917.48917,0,0,0,.2076-.23261,8.55666,8.55666,0,0,0,.59461-1.33669c.04-.02906.08025.0369.08639.086l.12128.9693a.23249.23249,0,0,0,.05479.14709.22428.22428,0,0,0,.11494.04548.71046.71046,0,0,0,.36216-.00226.27925.27925,0,0,0,.19955-.27393,1.0496,1.0496,0,0,1,.51531.00984.4762.4762,0,0,1,.33429.36373.26414.26414,0,0,1-.11247.26441.7842.7842,0,0,1-.11677.04385c-.27612.10312-.40766.48708-.70163.50847-.05159.00375-.11365-.00044-.14343.04186a.12756.12756,0,0,0-.01359.08743,1.491,1.491,0,0,0,.68507.91637l.606.47279c-.0001.29353-.03409.64323-.29149.78432a.42656.42656,0,0,1-.486-.06374c-.128-.12223-.1812-.32715-.34493-.39436-.18481-.07585-.39353.08564-.45919.2743a1.98074,1.98074,0,0,0-.04323.5947,1.70046,1.70046,0,0,1-.4955,1.141.49136.49136,0,0,0-.13043.16657.74909.74909,0,0,0-.01292.2398.45109.45109,0,0,1-.26093.4008.36825.36825,0,0,1-.44485-.13253c-.12769-.20913.00859-.47066.07837-.70554.134-.451.00684-.94446.11645-1.402.05709-.23829.17657-.45812.233-.69656a.59316.59316,0,0,0,.00251-.323.65429.65429,0,0,0-.12806-.20592,2.492,2.492,0,0,0-.60446-.52184,1.09838,1.09838,0,0,1-.474-.40044.793.793,0,0,1,.1305-.74238C1058.46723,580.72858,1058.73684,580.78793,1058.94722,580.78612Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#444053"
        />
        <path
          d="M1039.9997,587.75936s2.39786,2.98633,1.84885,3.89122-4.24294-.38748-4.24294-.38748Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#444053"
        />
        <path
          d="M1039.2505,584.44955s-3.61509-6.05878-6.25644-3.7732-1.03907,4.07988-1.03907,4.07988l3.27829,2.9243s-5.11806-2.524-6.34453,3.63273c0,0,2.17333,4.54142,5.62926,1.97611,0,0-.72018,2.67544.7268,2.21724s4.04014-.50356,4.15768-5.68823Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M1037.54435,587.48058s2.23124-7.53814,4.60681-5.76287.38366,4.82394.38366,4.82394l-2.81669,2.698Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M1038.51753,588.35463a.5.5,0,0,1-.16948-.10254.48913.48913,0,0,1-.1-.29529,8.55762,8.55762,0,0,1-.02417-1.46278c-.02544-.04239-.08829.00256-.11313.0453l-.49089.84456a.23242.23242,0,0,1-.108.11393.22432.22432,0,0,1-.12356-.00312.7106.7106,0,0,1-.33241-.14378.27926.27926,0,0,1-.07645-.33018,1.04958,1.04958,0,0,0-.47807-.19258.47621.47621,0,0,0-.45.20392.26415.26415,0,0,0,0,.28734.78354.78354,0,0,0,.0903.08605c.21376.20294.18457.60775.44673.74246.046.02365.10476.04407.11562.09465a.12758.12758,0,0,1-.02171.08578,1.491,1.491,0,0,1-.989.57524l-.74267.198c-.11476.27016-.22031.60529-.03865.83584a.42654.42654,0,0,0,.47217.13149c.16562-.06239.29476-.23016.47173-.22794.19975.00251.32864.23279.31525.43211a1.98119,1.98119,0,0,1-.19291.5642,1.70043,1.70043,0,0,0,.00951,1.24394.49143.49143,0,0,1,.05486.20432.74916.74916,0,0,1-.08194.22574.45105.45105,0,0,0,.0833.47094.36825.36825,0,0,0,.46123.05211c.19934-.1425.17626-.4365.204-.68.05318-.4675.36326-.87183.44142-1.3358.04071-.24162.01677-.49069.0581-.73221a.59309.59309,0,0,1,.1241-.29827.6542.6542,0,0,1,.19842-.13939,2.49169,2.49169,0,0,1,.76046-.24372,1.0984,1.0984,0,0,0,.59288-.183.793.793,0,0,0,.17039-.73425C1038.98176,588.4895,1038.71042,588.43862,1038.51753,588.35463Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#444053"
        />
        <path
          d="M1044.64687,618.36778s2.10815-7.59013,5.19389-10.75167"
          transform="translate(-68.27659 -52.19946)"
          fill="none"
          stroke="#444053"
          stroke-miterlimit="10"
        />
        <path
          d="M1051.3658,601.0403s.17071-6.74321,4.01178-6.65785,4.18249,4.86535,3.03017,6.65785c0,0,5.58458-.5975,5.80113,4.01178s-5.37477,4.09714-5.37477,4.09714-.63975,4.78-5.16367,5.46285-3.63879-5.80428-3.63879-5.80428-5.153-.68286-5.57978-3.67035,3.14223-4.11578,3.14223-4.11578Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M1056.29652,604.93264c.10536.0474.23032.01353.34185.04368a.61482.61482,0,0,1,.277.21128c.23428.26376.481.64035.29068.93742-.19471.304-.65891.22407-.98506.06937s-.71161-.34895-1.0232-.16669l.07321,1.22959a.37039.37039,0,0,1-.04183.24376.36487.36487,0,0,1-.289.10542,8.27921,8.27921,0,0,1-.83916-.002,4.86194,4.86194,0,0,0-.08431-1.30336.43512.43512,0,0,0-.11574-.25336.39453.39453,0,0,0-.24213-.07464c-.42066-.021-1.46521.2809-1.61507-.37169-.12393-.53969.62566-.481.89218-.78294.52659-.5966.5667-1.50528,1.36116-1.984.83521-.50329.61-.25747.797.36347.06358.21107-.18122.43492-.00384.66891.20719.2733.55571-.00931.75243.16392C1056.0866,604.24554,1056.02262,604.80943,1056.29652,604.93264Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#444053"
        />
        <path
          d="M1057.94119,601.54393a1.94469,1.94469,0,0,0-1.49953.69436,5.75778,5.75778,0,0,0-.879,1.45792"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M1053.21924,606.54139a1.94469,1.94469,0,0,0-1.49952.69436,5.75781,5.75781,0,0,0-.879,1.45792"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M1052.73514,603.39771a1.94472,1.94472,0,0,0-1.09331-1.23911,5.7575,5.7575,0,0,0-1.64808-.4265"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M1057.97074,609.31459a1.94474,1.94474,0,0,0-.88151-1.39774,5.75787,5.75787,0,0,0-1.55888-.68409"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M1043.12548,567.42437s-2.88795-6.09588.579-7.75152,5.9269,2.457,5.70654,4.5765c0,0,4.71533-3.05126,6.98682.9653s-2.95016,6.08039-2.95016,6.08039,1.58413,4.555-2.146,7.20424-5.86493-3.5402-5.86493-3.5402-4.90738,1.71383-6.6353-.76035.949-5.09043.949-5.09043Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M1049.28154,568.6755c.11542-.0052.21168-.09177.32482-.11514a.61483.61483,0,0,1,.34251.06369c.328.1298.718.35472.68212.70568-.03674.3591-.48711.49708-.848.506s-.79251.00937-.98845.31255l.61973,1.06451a.37029.37029,0,0,1,.07257.23643c-.01732.10482-.11806.172-.21046.22442a8.28278,8.28278,0,0,1-.74994.37654,4.8622,4.8622,0,0,0-.6629-1.12535.43509.43509,0,0,0-.21754-.174.39457.39457,0,0,0-.24978.04255c-.385.17087-1.18118.91135-1.60918.39642-.354-.42584.34159-.71141.44335-1.10111.201-.76994-.17286-1.59909.32041-2.38461.51858-.8258.42841-.50485.87531-.03493.15191.15974.03434.46992.29817.59879.30815.15053.49182-.25886.74552-.19293C1048.78438,568.15685,1048.98151,568.689,1049.28154,568.6755Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#444053"
        />
        <path
          d="M1049.22167,564.90924a1.94471,1.94471,0,0,0-1.02539,1.29588,5.75756,5.75756,0,0,0-.12721,1.69761"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M1047.26014,571.49891a1.94471,1.94471,0,0,0-1.02539,1.29588,5.75753,5.75753,0,0,0-.12721,1.69761"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M1045.41063,568.91117a1.94468,1.94468,0,0,0-1.53456-.61307,5.75749,5.75749,0,0,0-1.66335.36239"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M1052.75163,571.83192a1.94472,1.94472,0,0,0-1.417-.85016,5.75737,5.75737,0,0,0-1.69987.09225"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M1041.29366,591.05352s6.11647,5.79438,4.80614,8.96249"
          transform="translate(-68.27659 -52.19946)"
          fill="none"
          stroke="#444053"
          stroke-miterlimit="10"
        />
        <path
          d="M1038.22747,605.94448s2.39786,2.98633,1.84885,3.89122-4.24293-.38748-4.24293-.38748Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#444053"
        />
        <path
          d="M1037.47828,602.63467s-3.6151-6.05878-6.25644-3.7732-1.03908,4.07988-1.03908,4.07988l3.2783,2.9243s-5.11806-2.524-6.34453,3.63273c0,0,2.17333,4.54142,5.62926,1.97611,0,0-.72018,2.67544.72679,2.21724s4.04015-.50356,4.15768-5.68823Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M1035.77213,605.6657s2.23123-7.53814,4.6068-5.76287.38367,4.82394.38367,4.82394l-2.81669,2.698Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M1036.74531,606.53975a.5.5,0,0,1-.16948-.10253.48918.48918,0,0,1-.1-.2953,8.55762,8.55762,0,0,1-.02417-1.46278c-.02545-.04239-.08829.00256-.11313.0453l-.49089.84456a.23251.23251,0,0,1-.108.11393.22422.22422,0,0,1-.12356-.00312.71051.71051,0,0,1-.33241-.14378.27927.27927,0,0,1-.07646-.33018,1.04965,1.04965,0,0,0-.47806-.19258.47622.47622,0,0,0-.45.20392.26414.26414,0,0,0,0,.28734.78354.78354,0,0,0,.0903.08605c.21376.20294.18456.60775.44673.74246.046.02365.10476.04407.11561.09465a.12758.12758,0,0,1-.0217.08578,1.491,1.491,0,0,1-.989.57524l-.74267.198c-.11475.27017-.22031.60529-.03865.83585a.42658.42658,0,0,0,.47217.13149c.16563-.0624.29476-.23017.47174-.22795.19975.00251.32864.23279.31525.43211a1.98121,1.98121,0,0,1-.19292.5642,1.70038,1.70038,0,0,0,.00952,1.24394.49141.49141,0,0,1,.05485.20432.74889.74889,0,0,1-.08194.22574.4511.4511,0,0,0,.0833.47094.36825.36825,0,0,0,.46123.05211c.19935-.1425.17626-.4365.204-.68.05318-.4675.36325-.87183.44142-1.3358.0407-.24162.01677-.49069.0581-.73221a.59316.59316,0,0,1,.12409-.29827.65425.65425,0,0,1,.19843-.13939,2.4916,2.4916,0,0,1,.76046-.24372,1.09836,1.09836,0,0,0,.59287-.183.793.793,0,0,0,.17039-.73425C1037.20953,606.67462,1036.9382,606.62374,1036.74531,606.53975Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#444053"
        />
        <path
          d="M1039.52144,609.23864s6.11646,5.79438,4.80614,8.96249"
          transform="translate(-68.27659 -52.19946)"
          fill="none"
          stroke="#444053"
          stroke-miterlimit="10"
        />
        <path
          d="M1050.00882,541.31407s2.39786,2.98633,1.84885,3.89121-4.24293-.38747-4.24293-.38747Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#444053"
        />
        <path
          d="M1049.25963,538.00426s-3.6151-6.05878-6.25645-3.7732-1.03907,4.07987-1.03907,4.07987l3.27829,2.92431s-5.11805-2.524-6.34452,3.63273c0,0,2.17333,4.54142,5.62925,1.97611,0,0-.72018,2.67543.7268,2.21723s4.04014-.50356,4.15768-5.68822Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M1047.55348,541.03529s2.23123-7.53814,4.6068-5.76287.38367,4.82393.38367,4.82393l-2.8167,2.698Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M1048.52665,541.90934a.49992.49992,0,0,1-.16947-.10254.48913.48913,0,0,1-.1-.29529,8.55762,8.55762,0,0,1-.02418-1.46278c-.02544-.04239-.08828.00256-.11313.0453l-.49089.84456a.23249.23249,0,0,1-.108.11393.22426.22426,0,0,1-.12357-.00313.71032.71032,0,0,1-.3324-.14378.27926.27926,0,0,1-.07646-.33017,1.04954,1.04954,0,0,0-.47806-.19258.47622.47622,0,0,0-.45.20392.26414.26414,0,0,0,.00005.28734.78362.78362,0,0,0,.0903.08605c.21376.20293.18456.60775.44672.74246.046.02364.10476.04407.11562.09464a.1276.1276,0,0,1-.0217.08579,1.491,1.491,0,0,1-.989.57524l-.74267.198c-.11475.27016-.22031.60529-.03865.83584a.42656.42656,0,0,0,.47217.13149c.16563-.06239.29476-.23016.47174-.22794.19975.00251.32864.23279.31524.4321a1.98114,1.98114,0,0,1-.19291.56421,1.70043,1.70043,0,0,0,.00951,1.24394.49119.49119,0,0,1,.05486.20432.74935.74935,0,0,1-.08194.22574.45108.45108,0,0,0,.0833.47094.36825.36825,0,0,0,.46123.0521c.19934-.14249.17626-.43649.204-.68.05317-.46749.36325-.87182.44142-1.33579.0407-.24163.01677-.49069.05809-.73221a.59323.59323,0,0,1,.1241-.29827.65445.65445,0,0,1,.19843-.1394,2.49189,2.49189,0,0,1,.76045-.24371,1.09848,1.09848,0,0,0,.59288-.183.793.793,0,0,0,.17039-.73425C1048.99088,542.0442,1048.71954,541.99333,1048.52665,541.90934Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#444053"
        />
        <path
          d="M1051.30279,544.60823s4.966,3.24472,3.65572,6.41283"
          transform="translate(-68.27659 -52.19946)"
          fill="none"
          stroke="#444053"
          stroke-miterlimit="10"
        />
        <path
          d="M1053.4101,524.45256s2.39785,2.98633,1.84884,3.89122-4.24293-.38748-4.24293-.38748Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#444053"
        />
        <path
          d="M1052.6609,521.14275s-3.6151-6.05877-6.25644-3.7732-1.03908,4.07988-1.03908,4.07988l3.2783,2.92431s-5.11806-2.524-6.34453,3.63272c0,0,2.17333,4.54142,5.62926,1.97611,0,0-.72018,2.67544.72679,2.21724s4.04015-.50356,4.15768-5.68823Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M1050.95475,524.17379s2.23124-7.53815,4.6068-5.76288.38367,4.82394.38367,4.82394l-2.81669,2.698Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M1051.92793,525.04783a.49994.49994,0,0,1-.16948-.10253.48917.48917,0,0,1-.1-.29529,8.55764,8.55764,0,0,1-.02417-1.46278c-.02545-.0424-.08829.00255-.11313.0453l-.49089.84456a.23259.23259,0,0,1-.108.11393.22432.22432,0,0,1-.12356-.00313.71041.71041,0,0,1-.33241-.14378.27927.27927,0,0,1-.07646-.33018,1.04961,1.04961,0,0,0-.47806-.19258.47623.47623,0,0,0-.45.20393.26413.26413,0,0,0,0,.28733.78354.78354,0,0,0,.0903.08605c.21376.20294.18456.60776.44673.74247.046.02364.10476.04406.11561.09464a.12756.12756,0,0,1-.0217.08578,1.491,1.491,0,0,1-.989.57524l-.74267.198c-.11475.27017-.22031.60529-.03865.83585a.42658.42658,0,0,0,.47217.13149c.16563-.06239.29476-.23016.47174-.22794.19975.0025.32864.23278.31525.4321a1.98111,1.98111,0,0,1-.19292.5642,1.70038,1.70038,0,0,0,.00952,1.24394.49141.49141,0,0,1,.05485.20432.74913.74913,0,0,1-.08193.22574.45107.45107,0,0,0,.08329.47094.36826.36826,0,0,0,.46123.05211c.19935-.14249.17626-.4365.204-.68.05318-.46749.36326-.87182.44142-1.3358.04071-.24162.01677-.49068.0581-.7322a.59316.59316,0,0,1,.12409-.29828.65425.65425,0,0,1,.19843-.13939,2.49215,2.49215,0,0,1,.76046-.24372,1.09836,1.09836,0,0,0,.59287-.183.793.793,0,0,0,.17039-.73425C1052.39215,525.1827,1052.12082,525.13182,1051.92793,525.04783Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#444053"
        />
        <path
          d="M1054.70406,527.74673s4.966,3.24471,3.65572,6.41283"
          transform="translate(-68.27659 -52.19946)"
          fill="none"
          stroke="#444053"
          stroke-miterlimit="10"
        />
        <path
          d="M1076.30713,540.9948s-2.39786,2.98633-1.84885,3.89122,4.24293-.38748,4.24293-.38748Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#444053"
        />
        <path
          d="M1077.05633,537.685s3.61509-6.05877,6.25644-3.7732,1.03907,4.07988,1.03907,4.07988l-3.27829,2.92431s5.11806-2.524,6.34452,3.63272c0,0-2.17333,4.54142-5.62925,1.97611,0,0,.72018,2.67544-.7268,2.21724s-4.04014-.50356-4.15768-5.68823Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M1078.76247,540.716s-2.23123-7.53815-4.6068-5.76288-.38366,4.82394-.38366,4.82394l2.81669,2.698Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M1077.7893,541.59007a.50006.50006,0,0,0,.16947-.10253.48918.48918,0,0,0,.1-.29529,8.55876,8.55876,0,0,0,.02417-1.46279c.02544-.04239.08828.00256.11313.0453l.49089.84457a.23253.23253,0,0,0,.108.11393.22436.22436,0,0,0,.12357-.00313.71052.71052,0,0,0,.3324-.14378.27925.27925,0,0,0,.07646-.33018,1.04965,1.04965,0,0,1,.47806-.19258.47622.47622,0,0,1,.45.20392.26416.26416,0,0,1,0,.28734.78282.78282,0,0,1-.09031.08605c-.21375.20294-.18456.60776-.44672.74247-.046.02364-.10476.04406-.11562.09464a.12762.12762,0,0,0,.0217.08578,1.491,1.491,0,0,0,.989.57524l.74267.198c.11476.27017.22031.60529.03865.83585a.42658.42658,0,0,1-.47217.13149c-.16563-.06239-.29476-.23016-.47173-.22795-.19976.00251-.32865.23279-.31525.43211a1.98108,1.98108,0,0,0,.19291.5642,1.70043,1.70043,0,0,1-.00951,1.24394.49128.49128,0,0,0-.05486.20432.74916.74916,0,0,0,.08194.22574.45105.45105,0,0,1-.0833.47094.36825.36825,0,0,1-.46123.05211c-.19934-.14249-.17626-.4365-.204-.68-.05318-.4675-.36326-.87183-.44143-1.3358-.0407-.24162-.01677-.49068-.05809-.7322a.59326.59326,0,0,0-.1241-.29828.65413.65413,0,0,0-.19843-.13939,2.49218,2.49218,0,0,0-.76045-.24372,1.0984,1.0984,0,0,1-.59288-.183.793.793,0,0,1-.17039-.73425C1077.32507,541.72494,1077.59641,541.67406,1077.7893,541.59007Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#444053"
        />
        <path
          d="M1075.01316,544.289s-22.56769,6.80357-21.25737,9.97168"
          transform="translate(-68.27659 -52.19946)"
          fill="none"
          stroke="#444053"
          stroke-miterlimit="10"
        />
        <path
          d="M1060.94119,552.73818s-.19282-6.74261,3.64727-6.86432,4.43854,4.633,3.38446,6.48494c0,0,5.54427-.8975,6.00883,3.69342s-5.14622,4.38075-5.14622,4.38075-.3813,4.80752-4.86187,5.73311-3.94621-5.59981-3.94621-5.59981-5.18229-.40425-5.76941-3.36442,2.91593-4.27908,2.91593-4.27908Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M1066.07445,556.35923c.10777.04165.23071.0011.34371.0252a.61478.61478,0,0,1,.288.196c.24815.25076.51476.61351.34076.92041-.178.314-.64588.25924-.97989.12233s-.72938-.3101-1.03069-.11132l.13934,1.22386a.37037.37037,0,0,1-.02863.24566.3649.3649,0,0,1-.283.12084,8.28284,8.28284,0,0,1-.83805.04318,4.8615,4.8615,0,0,0-.1544-1.29692.43514.43514,0,0,0-.12922-.24676.39466.39466,0,0,0-.2458-.06149c-.42118.00164-1.44795.35944-1.63275-.28414-.15283-.53223.59883-.514.8487-.82987.49368-.6241.48478-1.53362,1.2523-2.05446.80688-.54755.59526-.29.81546.32.07485.20734-.15753.44405.0322.66814.22162.26174.5544-.03924.76017.12315C1065.82782,555.68443,1065.79431,556.251,1066.07445,556.35923Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#444053"
        />
        <path
          d="M1067.53416,552.88683a1.94471,1.94471,0,0,0-1.45994.77415,5.75774,5.75774,0,0,0-.79913,1.50314"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M1063.08832,558.13142a1.94474,1.94474,0,0,0-1.45994.77415,5.75754,5.75754,0,0,0-.79914,1.50315"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M1062.43555,555.01839a1.94473,1.94473,0,0,0-1.15848-1.17841,5.7578,5.7578,0,0,0-1.66867-.33708"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M1067.98232,560.64461a1.94476,1.94476,0,0,0-.95554-1.34821,5.7577,5.7577,0,0,0-1.59346-.59912"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M1061.84355,530.95314c.02116-.24706,1.05514-16.29418,1.05514-16.29418"
          transform="translate(-68.27659 -52.19946)"
          fill="none"
          stroke="#444053"
          stroke-miterlimit="10"
          stroke-width="2"
        />
        <path
          d="M1073.92605,521.6855s-1.26609,3.61454-.447,4.28485,3.87152-1.77876,3.87152-1.77876Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#444053"
        />
        <path
          d="M1073.52988,518.31516s1.3903-6.917,4.64216-5.64185,2.33882,3.50071,2.33882,3.50071l-2.11689,3.84935s3.98494-4.08474,7.19229,1.31173c0,0-.53635,5.006-4.64945,3.73848,0,0,1.5703,2.28271.05333,2.33271s-3.97713.87106-5.81508-3.97832Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M1076.14829,520.60471s-4.61493-6.36431-6.26343-3.89909,1.24521,4.67622,1.24521,4.67622l3.55457,1.60557Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M1075.52186,521.753a.5.5,0,0,0,.12564-.15313.48916.48916,0,0,0-.00405-.31175,8.55721,8.55721,0,0,0-.4645-1.38728c.00987-.04845.0841-.027.12176.005l.7442.6328a.23248.23248,0,0,0,.13976.07145.22427.22427,0,0,0,.11546-.04411.71045.71045,0,0,0,.26553-.2463.27926.27926,0,0,0-.0379-.33679,1.04963,1.04963,0,0,1,.3866-.34083.47623.47623,0,0,1,.4922.04238.26416.26416,0,0,1,.09568.27094.78417.78417,0,0,1-.05648.11122c-.134.26255.02843.63452-.17388.84887-.03551.03762-.0841.07645-.07749.12775a.12766.12766,0,0,0,.049.07366,1.491,1.491,0,0,0,1.12416.21291l.7662-.06072c.1982.2165.40936.49732.31488.77523a.42658.42658,0,0,1-.4014.28127c-.177-.00366-.35459-.11883-.52072-.05778a.38442.38442,0,0,0-.1533.51244,1.9811,1.9811,0,0,0,.36984.46771,1.70045,1.70045,0,0,1,.40542,1.17606.49127.49127,0,0,0,.01634.21093.74921.74921,0,0,0,.15245.18555.45109.45109,0,0,1,.07835.47179.36824.36824,0,0,1-.41753.20277c-.23543-.06794-.3116-.35284-.41882-.57318-.20587-.42307-.63293-.701-.86119-1.11245-.11887-.21426-.17927-.45707-.2987-.671a.59307.59307,0,0,0-.21637-.2399.65419.65419,0,0,0-.23352-.06533,2.49188,2.49188,0,0,0-.79821.02353,1.09849,1.09849,0,0,1-.62.0249.793.793,0,0,1-.40525-.63555C1075.12907,522.03483,1075.368,521.89647,1075.52186,521.753Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#444053"
        />
        <path
          d="M1073.80335,525.22256s-19.01229,13.93278-16.72143,16.48344"
          transform="translate(-68.27659 -52.19946)"
          fill="none"
          stroke="#444053"
          stroke-miterlimit="10"
        />
        <path
          d="M1059.62937,533.14935s-3.16921-5.9545.21674-7.7701,6.03508,2.17778,5.91385,4.30527c0,0,4.56783-3.26793,7.02425.63827s-2.66326,6.21141-2.66326,6.21141,1.79492,4.47615-1.80753,7.29652-6.02372-3.26271-6.02372-3.26271-4.82207,1.94092-6.66355-.44994.71049-5.12917.71049-5.12917Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M1065.8371,534.11189c.11505-.01058.20716-.10154.3191-.13017a.61493.61493,0,0,1,.34511.04764c.33373.11436.73378.32084.71429.67308-.02.36043-.46339.51928-.82344.54507s-.79121.04634-.97279.35833l.66872,1.03443a.37036.37036,0,0,1,.08352.23279c-.01241.10551-.1099.17733-.19976.234a8.28367,8.28367,0,0,1-.73156.41112,4.86173,4.86173,0,0,0-.71468-1.0932.43513.43513,0,0,0-.22542-.16362.39458.39458,0,0,0-.24752.05415c-.37658.18865-1.13738.96548-1.58893.47107-.37344-.40886.308-.72657.39149-1.12059.16489-.77848-.24728-1.58929.20881-2.397.47948-.84909.40438-.52428.87272-.07573.1592.15248.05623.46781.32578.58423.31485.136.47921-.28153.73571-.2275C1065.31628,533.617,1065.538,534.1394,1065.8371,534.11189Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#444053"
        />
        <path
          d="M1065.60158,530.35253a1.9447,1.9447,0,0,0-.96382,1.34231,5.75774,5.75774,0,0,0-.04786,1.7017"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M1063.94963,537.02654a1.94473,1.94473,0,0,0-.96381,1.34231,5.75742,5.75742,0,0,0-.04787,1.7017"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M1061.9814,534.52791a1.94469,1.94469,0,0,0-1.56149-.54081,5.75721,5.75721,0,0,0-1.64463.4396"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M1069.45067,537.103a1.94468,1.94468,0,0,0-1.45514-.78311,5.75741,5.75741,0,0,0-1.69372.17145"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M1062.89869,508.25718s-3.31922,5.80428,0,7.42606C1062.89869,515.68324,1067.43231,512.61039,1062.89869,508.25718Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#444053"
        />
        <path
          d="M1071.46519,506.96344s-5.87637,3.18987-3.90683,6.31531C1067.55836,513.27875,1073.03048,513.05063,1071.46519,506.96344Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#444053"
        />
        <path
          d="M1073.76124,510.539s-5.87637,3.18988-3.90682,6.31532C1069.85442,516.8543,1075.32654,516.62618,1073.76124,510.539Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#444053"
        />
        <line
          x1="999.59966"
          y1="460.31696"
          x2="993.56696"
          y2="474.35948"
          fill="none"
          stroke="#444053"
          stroke-miterlimit="10"
          stroke-width="2"
        />
        <path
          d="M1070.82721,515.68324s-7.40686,4.79229-7.403,7.30417"
          transform="translate(-68.27659 -52.19946)"
          fill="none"
          stroke="#444053"
          stroke-miterlimit="10"
          stroke-width="2"
        />
        <ellipse
          cx="68.87127"
          cy="729.3612"
          rx="16.81673"
          ry="2.84286"
          fill="#158cba"
          opacity="0.1"
        />
        <path
          d="M125.85414,768.35066s9.59262-.29544,12.48359-2.35407,14.75586-4.51673,15.473-1.21515,14.41592,16.42056,3.58591,16.50792-25.16414-1.687-28.04955-3.44456S125.85414,768.35066,125.85414,768.35066Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#a8a8a8"
        />
        <path
          d="M157.58995,780.14006c-10.83.08738-25.16414-1.68693-28.04955-3.44455-2.19739-1.33852-3.073-6.14145-3.366-8.35734-.20291.00872-.32024.01248-.32024.01248s.60757,7.73652,3.493,9.49414,17.21953,3.53193,28.04955,3.44455c3.1262-.02521,4.206-1.13747,4.14675-2.78481C161.10913,779.49981,159.91682,780.1213,157.58995,780.14006Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.2"
        />
        <ellipse
          cx="754.07495"
          cy="585.83344"
          rx="8.29756"
          ry="1.4027"
          fill="#158cba"
          opacity="0.1"
        />
        <path
          d="M816.77909,631.51494s4.7331-.14578,6.15954-1.16152,7.28071-2.22861,7.63458-.59957,7.113,8.10208,1.76932,8.14519-12.41627-.83236-13.84-1.69959S816.77909,631.51494,816.77909,631.51494Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#a8a8a8"
        />
        <path
          d="M832.43789,637.332c-5.34365.04312-12.41626-.83235-13.84-1.69958-1.08422-.66044-1.51627-3.03026-1.66083-4.1236-.10011.0043-.158.00615-.158.00615s.29978,3.81729,1.72348,4.68452,8.49631,1.74269,13.84,1.69958c1.5425-.01244,2.07531-.56124,2.04606-1.37406C834.1743,637.01606,833.586,637.32271,832.43789,637.332Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.2"
        />
        <ellipse
          cx="322.86886"
          cy="470.55988"
          rx="4.69921"
          ry="0.7944"
          fill="#158cba"
          opacity="0.1"
        />
        <path
          d="M387.98957,519.068s2.68053-.08255,3.48838-.65781,4.12332-1.26214,4.32373-.33956,4.02834,4.58851,1.002,4.61292-7.03178-.47139-7.83807-.96254S387.98957,519.068,387.98957,519.068Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#a8a8a8"
        />
        <path
          d="M396.85772,522.36238c-3.0263.02441-7.03178-.47139-7.83807-.96254-.614-.374-.85872-1.71615-.94059-2.33535-.0567.00244-.08949.00349-.08949.00349s.16978,2.16187.97607,2.653,4.81177.98695,7.83808.96254c.87357-.00705,1.17532-.31785,1.15875-.77818C397.84111,522.18347,397.50794,522.35713,396.85772,522.36238Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.2"
        />
        <ellipse
          cx="265.9994"
          cy="452.00579"
          rx="2.9349"
          ry="0.49614"
          fill="#158cba"
          opacity="0.1"
        />
        <path
          d="M332.305,501.89981a6.13624,6.13624,0,0,0,2.17867-.41084c.50454-.35927,2.57523-.78827,2.70039-.21207s2.51591,2.86576.62583,2.881a16.0091,16.0091,0,0,1-4.89529-.60116C332.411,503.25,332.305,501.89981,332.305,501.89981Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#a8a8a8"
        />
        <path
          d="M337.8436,503.95733a16.0091,16.0091,0,0,1-4.89528-.60115c-.3835-.23361-.53632-1.07183-.58745-1.45855l-.05589.00218s.106,1.3502.60961,1.65694a16.00878,16.00878,0,0,0,4.89528.60115c.54559-.0044.73405-.19851.7237-.486C338.45777,503.84559,338.24969,503.95405,337.8436,503.95733Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.2"
        />
        <path
          d="M285.07494,535.74642c-.07158-.79518-.16028-1.53272-.26939-2.08589a6.19011,6.19011,0,0,0-5.12944-4.74144,14.20192,14.20192,0,0,1-3.92889-.80381l-.47232-.24448c.04591-.04866.07219-.0756.07219-.0756a3.44656,3.44656,0,0,1-1.69336-.68835,3.96787,3.96787,0,0,0,1.56411.00849c-.01442-.00532-.02771-.01217-.042-.01773a2.17455,2.17455,0,0,0,.21377-.04214,2.83415,2.83415,0,0,1-1.13908-.80283c-.06478.00957-.12849.02217-.19148.03651a6.90646,6.90646,0,0,1-1.1241-2.02986,79.11483,79.11483,0,0,1-3.37226-12.64029c-.49181-2.33405-1.20806-4.9582-3.38341-6.08178a22.98,22.98,0,0,0-3.45719-1.01144,6.862,6.862,0,0,1-3.13973-2.13915,27.16053,27.16053,0,0,0-1.73973-2.287,7.47373,7.47373,0,0,0-2.87233-1.59624,9.81368,9.81368,0,0,0-4.705-.5588c.01815-.01207.03461-.02573.053-.0376a5.75282,5.75282,0,0,0-.71958.18992c-.03152.0093-.06258.01995-.09392.02984-.03076.01077-.06182.02047-.09239.03182a4.99231,4.99231,0,0,0-.977.44322c-2.1025,1.256-2.83769,3.81065-4.1883,5.81006-.81048,1.19981-1.87717,2.23436-2.58476,3.49339A4.77025,4.77025,0,0,0,241.01,510.702c-.01274.02158-.0224.04285-.03354.06429l-.014-.04061a1.2056,1.2056,0,0,0-.12759.55309c-.02929.64243.43324,1.24269.43324,1.93544a5.35288,5.35288,0,0,1-.50512,3.41564,20.759,20.759,0,0,0-1.34452,3.257c-.03533.14647-.064.29584-.08587.44666l-.00555-.03048a4.58164,4.58164,0,0,0-.04249.65878c-.00023.0298.00051.0595.0009.08927l.00064.02573a3.10274,3.10274,0,0,0,.79156,2.12253c.31812.33283.749.61839.84183,1.06234a1.645,1.645,0,0,1-.25738,1.03732l-.81079,1.61609a7.24123,7.24123,0,0,0-.59833,1.4434c-.01991.07868-.03351.15782-.04778.23689l-.007-.03642a3.54178,3.54178,0,0,0-.0442.4413c-.00213.03359-.00236.06713-.00353.10072-.00079.04591-.00215.09174-.00123.13761a5.04627,5.04627,0,0,0,2.18392,3.89,7.41751,7.41751,0,0,0,1.2939.74187c-.0159.08784-.02981.17618-.03927.26565-.20942,1.9748,1.27278,3.73841,1.61166,5.69638a6.80019,6.80019,0,0,1-.605,3.861,14.38,14.38,0,0,1-1.0855,1.96641c-.25723.3888-.5233.77267-.78947,1.15509l.01043.00323q-.09993.144-.19991.28788a5.61247,5.61247,0,0,0,5.52394-1.32389,8.59379,8.59379,0,0,0,.68568,5.34636l-12.26361-6.352-1.23919-.922c-2.95812-.02634-10.00185,6.24289-10.00185,6.24289l-.62749-.02635c-2.89212-3.66144-9.71313-1.84389-9.71313-1.84389l-1.77348,2.84485.0046.00125-.09553.0251,3.05112,2.73726-4.92464,1.3193,12.64308,6.613c-.24761.2691-.41981.44649-.41981.44649l-1.89169,2.599s-3.12859,3.23119-4.07443,4.039-7.05746,6.357-8.80364,9.237c0,0-1.60067.77268-1.60067,1.54537s-3.05582,3.02046-3.05582,3.02046a19.70157,19.70157,0,0,0-2.65287,2.04214c-.32786.28174-.56678.52777-.58631.67a9.81927,9.81927,0,0,1-4.25412,2.34543s-2.30056,1.19483-4.01182,2.3096c-.03272-.0021-.0655-.0021-.09819-.0021a7.90291,7.90291,0,0,0-1.25919.99227q-.06856.06072-.1283.11857c-.0382.03646-.07378.07215-.10553.10717-.02838.03161-.05893.06322-.08948.09272a4.56172,4.56172,0,0,1-2.60181,1.2138s-8.58682.99887-6.03959,2.474a5.283,5.283,0,0,0,1.23978.47414c.23136.06322.478.12223.74.17491,0,0-2.42723-.12434-1.92518.89561a2.41141,2.41141,0,0,0,1.74618,1.7912c1.39038.236,24.52723.29082,24.52723.29082s-.19646-.43622-1.35328-.54792a7.40659,7.40659,0,0,0,1.08044-.019c.66139-.06744,1.06518-.24866,1.15682-.531a12.64233,12.64233,0,0,0,.127-2.549c6.03021.2986,11.95745.56237,11.95745.56237s-.17657-.44407-1.32726-.60434l-.01961-.00082c-.06455-.009-.14574-.02367-.23849-.04229a8.85383,8.85383,0,0,0,2.12364-.29925,23.79559,23.79559,0,0,0,1.63267-4.02286q.07293-.20946.14007-.40423c.19086.12516.30084.19562.30084.19562a16.197,16.197,0,0,1,1.09138-1.45825,2.2246,2.2246,0,0,0,1.255-.94829,11.50958,11.50958,0,0,1,2.45558-2.141l7.85539-4.1344.00015.00029.00256-.00058c.0762.08652.15208.17316.2289.25938l.00217.0042.203.36878a.94336.94336,0,0,0,.10479-.02529c2.3966,2.6573,4.91766,5.05331,4.91766,5.05331a44.83114,44.83114,0,0,0,5.72745,3.72361c1.79856.77338,6.42375-.70173,6.42375-.70173l4.62641-.3217.34465-.02392h0a11.47122,11.47122,0,0,0,7.50127,2.79126c3.904.00969,8.36815-.257,10.46374-1.37513,4.14716-2.21267,1.85529-10.02724,1.85529-10.02724v-1.601a2.41007,2.41007,0,0,0-.08462-.62315c.52478.24626.90313.43294.90313.43294s-.14551-3.2312-.70036-3.8634-.0272-2.38827-.0272-2.38827.21827-1.75608-.582-2.52876a7.71333,7.71333,0,0,1-.84126-2.23355,20.912,20.912,0,0,0,4.22446-.50595c2.07361-.73756,2.401-8.74529,2.401-8.74529s1.41881-9.799,1.20054-10.43116a29.21606,29.21606,0,0,1,.35135-4.62791A41.41783,41.41783,0,0,0,285.07494,535.74642Zm-36.29806,6.3081a.56316.56316,0,0,1,.22724-.35948.82753.82753,0,0,1,.41457-.0386c.00483.0001.00949-.00047.01432-.00042.00342.14843.01214.24137.01235.24327l-.00077.00155a8.82909,8.82909,0,0,0-.86609.88538C248.64111,542.54128,248.70407,542.29639,248.77688,542.05452Zm21.897-6.42434c-.00568-.03271-.01279-.06515-.01826-.09788a20.55005,20.55005,0,0,1,1.04471-2.23533C271.33547,534.0335,270.98494,534.81656,270.67393,535.63018Zm3.26131-6.17413c-.5143.76712-1.13745,1.76287-1.754,2.90958A13.57753,13.57753,0,0,1,273.93524,529.45605Zm-50.00719,22.51688-.023-.06762c.06841-.01056.11167-.01662.11167-.01662Zm-35.2474,44.25761c2.42716.09694,4.45055.05268,4.45055.05268A17.54611,17.54611,0,0,1,188.68065,596.23054Zm4.4571.04846a5.06934,5.06934,0,0,1,3.07983-.37088A8.95751,8.95751,0,0,0,193.13775,596.279Zm81.50633-36.70382.88487-15.27278s-.32737,7.797-.21826,11.16871a10.92381,10.92381,0,0,1-.66661,4.10407Z"
          transform="translate(-68.27659 -52.19946)"
          fill="url(#f9e08372-f955-474a-ab6a-b0cb6d2d47e2)"
        />
        <path
          d="M241.30609,513.21611a5.5228,5.5228,0,0,1-.48764,3.41555,21.18,21.18,0,0,0-1.298,3.25695,3.67339,3.67339,0,0,0,.63639,3.31243c.30714.33282.72312.61837.81271,1.0623a1.69111,1.69111,0,0,1-.24847,1.0373l-.78275,1.61606a7.38611,7.38611,0,0,0-.57764,1.44337,4.81309,4.81309,0,0,0,2.00819,4.77,10.40815,10.40815,0,0,0,5.13541,1.726,1.14963,1.14963,0,0,0,.90035-.15457,1.08954,1.08954,0,0,0,.28639-.64488,8.0812,8.0812,0,0,0-.0562-3.18138c-.31781-1.445-1.03768-2.85482-.85879-4.32355a8.57791,8.57791,0,0,1,.71894-2.18677,23.54681,23.54681,0,0,0,1.61229-6.19494c.22185-1.87058.1533-3.954-1.08252-5.37568-1.2046-1.38574-3.39942-2.05524-5.10443-2.5656-.65809-.197-1.26038-.32911-1.72914.27319C240.4381,511.46945,241.30609,512.25318,241.30609,513.21611Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#4b3648"
        />
        <g opacity="0.1">
          <path
            d="M241.36718,513.46667a6.994,6.994,0,0,0-.35617-2.73905c-.40215.83844.29382,1.559.29382,2.42356C241.33122,513.2558,241.35077,513.3611,241.36718,513.46667Z"
            transform="translate(-68.27659 -52.19946)"
          />
          <path
            d="M240.80579,523.8323a1.41947,1.41947,0,0,0,.16247-.85348c-.08957-.44393-.50551-.72947-.8127-1.06229a2.96417,2.96417,0,0,1-.72339-1.61175,3.46815,3.46815,0,0,0,.72339,2.83133A6.56977,6.56977,0,0,1,240.80579,523.8323Z"
            transform="translate(-68.27659 -52.19946)"
          />
          <path
            d="M247.68977,532.77208a1.08949,1.08949,0,0,1-.2864.64489,1.14962,1.14962,0,0,1-.90037.15457,10.40838,10.40838,0,0,1-5.13541-1.726,5.26945,5.26945,0,0,1-2.05987-3.285,4.89622,4.89622,0,0,0,2.05987,4.50458,10.40827,10.40827,0,0,0,5.13541,1.726,1.14962,1.14962,0,0,0,.90037-.15457,1.08949,1.08949,0,0,0,.2864-.64487,8.07523,8.07523,0,0,0,.10711-2.05779A8.01334,8.01334,0,0,1,247.68977,532.77208Z"
            transform="translate(-68.27659 -52.19946)"
          />
          <path
            d="M249.106,516.88545a23.54573,23.54573,0,0,1-1.61228,6.19494,8.57916,8.57916,0,0,0-.719,2.18677,4.35139,4.35139,0,0,0,.01723,1.11239,9.17236,9.17236,0,0,1,.70174-2.07958A23.54546,23.54546,0,0,0,249.106,518.105a12.01467,12.01467,0,0,0,.08057-2.15134C249.16963,516.26736,249.14232,516.57936,249.106,516.88545Z"
            transform="translate(-68.27659 -52.19946)"
          />
        </g>
        <path
          d="M223.86091,588.81938s-.25075.78179-.58372,1.7722a24.27659,24.27659,0,0,1-1.57622,4.02276,24.8546,24.8546,0,0,1-4.51161.472,13.9292,13.9292,0,0,1-9.50164-3.00073s1.159-.83448,2.38332-1.8017a13.67357,13.67357,0,0,0,2.77946-2.60458c.36455-.73965,2.46337-2.01454,3.72772-2.7331.569-.32453.96936-.53526.96936-.53526Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#f899a5"
        />
        <path
          d="M221.1813,595.561s-22.31328-1.02848-23.644-1.32278a2.38665,2.38665,0,0,1-1.60612-1.863c-.43976-1.04008,1.89589-.81371,1.89589-.81371l.01674.00284c.2345.03976,2.86676.47734,5.33134.79369l.00419.00019a16.35967,16.35967,0,0,0,4.29032.23994l.0065-.00394a8.3633,8.3633,0,0,1,2.98668-.2409,7.07627,7.07627,0,0,0-6.02148-4.84407c.03073-.02819.06159-.05847.09034-.08886a7.702,7.702,0,0,1,1.27339-.95266c4.54567.18779,6.953,6.45611,6.953,6.45611s.01243.00476.03745.01217c.514.15954,5.99971,1.86273,7.08546,2.01978l.01892.00083C221.01084,595.117,221.1813,595.561,221.1813,595.561Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#f3b4b4"
        />
        <rect
          x="183.66351"
          y="471.94473"
          width="7.30515"
          height="7.7266"
          fill="#4b3648"
        />
        <rect
          x="183.66351"
          y="471.94473"
          width="7.30515"
          height="7.7266"
          opacity="0.1"
        />
        <path
          d="M213.07878,551.09951l4.84727,4.50425,6.952-1.5541s.25512-6.32176-6.18664-4.47792Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#e6ebef"
        />
        <path
          d="M213.07878,551.09951l4.84727,4.50425,6.952-1.5541s.25512-6.32176-6.18664-4.47792Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M214.19387,551.36291l-1.02728-.28975,1.71214-2.84479s6.58518-1.81751,9.37729,1.84385l.60584.02634s6.80018-6.26909,9.656-6.24275l1.19636.92193-10.56262,7.32271-.50047-.21072s-1.49272.212-1.7347.52949Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#fff"
        />
        <polygon
          points="142.993 502.957 163.803 514.23 177.605 511.965 181.872 500.322 167.438 492.578 156.375 499.69 155.268 500.779 153.056 500.164 142.993 502.957"
          fill="#6e6d84"
        />
        <path
          d="M209.5147,597.54763c-.08849.28238-.47833.4636-1.11683.531a6.90453,6.90453,0,0,1-1.04311.019h-.01893a23.54879,23.54879,0,0,1-6.1806-1.39289c-.34559-.12011-.6722-.22548-.98618-.31609-.02531-.00631-.03794-.01053-.03794-.01053a13.41794,13.41794,0,0,0-2.318-.46992,4.74756,4.74756,0,0,0-2.97333.37087l-.00633.00422s-1.95343.04426-4.2967-.05268h-.00419a35.22834,35.22834,0,0,1-5.36087-.56053l-.01685-.00211c-.25289-.05268-.491-.11169-.71439-.1749a4.996,4.996,0,0,1-1.19691-.47413c-2.45915-1.47508,5.83076-2.47392,5.83076-2.47392a4.32754,4.32754,0,0,0,2.51189-1.21378c.02948-.02951.059-.06111.08638-.09272a2.83344,2.83344,0,0,1,.21072-.21073.09741.09741,0,0,1,.01477-.01475,10.05747,10.05747,0,0,1,1.00516-.78178c.099-.06955.20018-.13909.30555-.20863,1.65208-1.11474,3.87311-2.30955,3.87311-2.30955a9.40535,9.40535,0,0,0,4.107-2.34537,4.81,4.81,0,0,0,.57319-.67644l.00422-.00631.00419-.00211,4.58328-1.18428,3.16089,7.58612s.02109.40881.04427,1.02413A34.646,34.646,0,0,1,209.5147,597.54763Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#f899a5"
        />
        <path
          d="M208.39787,598.07867a6.90453,6.90453,0,0,1-1.04311.019h-.01893a23.54879,23.54879,0,0,1-6.1806-1.39289c-.34559-.12011-.6722-.22548-.98618-.31609-.02531-.00631-.03794-.01053-.03794-.01053a13.41794,13.41794,0,0,0-2.318-.46992,4.74756,4.74756,0,0,0-2.97333.37087l-.00633.00422s-1.95343.04426-4.2967-.05268h-.00419a35.22834,35.22834,0,0,1-5.36087-.56053l-.01685-.00211c-.25289-.05268-.491-.11169-.71439-.1749a5.69741,5.69741,0,0,1,.92512-.03582l.01684.00211c.236.02949,2.88485.35191,5.36088.56052h.00419a16.35937,16.35937,0,0,0,4.2967.05268l.00632-.00422a8.36346,8.36346,0,0,1,2.97334-.37086,7.07627,7.07627,0,0,0-6.22693-4.577c.02948-.0295.059-.0611.08638-.09272a.09741.09741,0,0,1,.01477-.01475,7.6786,7.6786,0,0,1,1.21589-.99251c.03159,0,.0632,0,.09482.0021,4.49054.07165,7.133,6.14476,7.133,6.14476s.01263.00422.03794.01054c.52049.137,6.07521,1.59941,7.16678,1.709h.01893A2.82285,2.82285,0,0,1,208.39787,598.07867Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M208.66127,598.64552s-22.33691-.05479-23.67923-.2908-1.6858-1.79117-1.6858-1.79117c-.48468-1.01992,1.85861-.89559,1.85861-.89559l.01685.00211c.236.0295,2.88485.35191,5.36087.56053h.00419a16.35935,16.35935,0,0,0,4.2967.05268l.00633-.00422a8.36324,8.36324,0,0,1,2.97333-.37087,7.07626,7.07626,0,0,0-6.22692-4.577c.02948-.02951.059-.06111.08638-.09272a7.70134,7.70134,0,0,1,1.23065-1.00726c4.54954-.01055,7.22788,6.14686,7.22788,6.14686s.01263.00422.03794.01053c.52048.137,6.07521,1.59941,7.16678,1.709h.01893C208.47161,598.20931,208.66127,598.64552,208.66127,598.64552Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#f3b4b4"
        />
        <path
          d="M223.86091,588.81938s-.25075.78179-.58372,1.7722a41.85645,41.85645,0,0,1-6.19111-4.931,3.58857,3.58857,0,0,1-.50786-.71436c.569-.32453.96936-.53526.96936-.53526Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M236.71517,579.14286l-.79233,2.55821-7.584,4.13443a11.22925,11.22925,0,0,0-2.37067,2.141,2.15213,2.15213,0,0,1-1.21167.94827,16.17215,16.17215,0,0,0-1.05363,1.45821,42.12221,42.12221,0,0,1-6.19533-4.93308c-.52471-.60268-.77759-1.10631-.54156-1.38868.99462-1.19481,6.94762-5.47887,6.94762-5.47887s3.635-4.74764,3.79306-4.68442a33.19958,33.19958,0,0,0,3.05763-2.672c.43411-.4025.73543-.687.73543-.687Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#bdd3e8"
        />
        <path
          d="M272.90729,527.55092l-7.38806,13.065-2.72677,5.16277-14.4347-2.10725.32874-.69119,1.22008-2.56241.55843-1.17164.08638-.158,1.59943-2.89748.08638-.12222,1.1611-1.63944,2.33485-3.29575a2.12057,2.12057,0,0,0,.76072-.2023,1.79682,1.79682,0,0,0,.87451-.99042c.82392-2.044-.687-5.972-.687-5.972s5.47886-13.38108,7.37539-6.00568a14.09158,14.09158,0,0,0,7.64724,9.08648A10.20355,10.20355,0,0,0,272.90729,527.55092Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#f899a5"
        />
        <path
          d="M248.07679,572.47059v1.26435s4.77645,4.56572,4.14427,8.28854a22.4621,22.4621,0,0,0,.70242,8.35878l4.79986-.34491-.72584-17.00482Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#bdd3e8"
        />
        <path
          d="M257.72239,590.03737l-4.79823.34559a22.45167,22.45167,0,0,1-.70379-8.35948c.63218-3.72353-4.14289-8.28784-4.14289-8.28784v-1.26435l8.92.56052.04636,1.10631Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.05"
        />
        <path
          d="M231.14571,571.97609a40.1193,40.1193,0,0,0-4.21241,4.56853c-1.6858,2.24844-4.56434,5.47886-4.56434,5.47886l-3.44323,2.03772-1.4182,1.38868c-.52471-.60268-.77759-1.10631-.54156-1.38868.99462-1.19481,6.94762-5.47887,6.94762-5.47887s3.635-4.74764,3.79306-4.68442a33.19958,33.19958,0,0,0,3.05763-2.672Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.05"
        />
        <path
          d="M209.559,592.10881c-.22547.19808-.39617.38141-.39617.38141s-.06956,2.24633-1.827-3.02181c-1.75536-5.26814-6.111-4.00379-6.111-4.00379a.0876.0876,0,0,1-.03585-.09692c.019-.14329.25288-.392.57319-.67644l.00841-.00842,4.58328-1.18428,3.16089,7.58612S209.53579,591.49349,209.559,592.10881Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M225.73988,562.145l-2.66919.07024-1.82629,2.59895s-3.0204,3.23112-3.93354,4.0389-6.81346,6.35689-8.49927,9.23681c0,0-1.54532.77266-1.54532,1.54532s-2.95016,3.0204-2.95016,3.0204-3.09064,2.10726-2.66919,2.38822c0,0,4.355-1.26435,6.111,4.00379s1.82629,3.0204,1.82629,3.0204a4.07353,4.07353,0,0,1,1.05363-.8295c.42145-.15389,2.419-3.0338,3.03577-3.10405a3.00458,3.00458,0,0,0,1.249-.56193l3.58234-3.51209,3.44185-2.037s2.87991-3.23112,4.56572-5.47886a40.257,40.257,0,0,1,4.21073-4.56867Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#bdd3e8"
        />
        <path
          d="M212.39393,579.14357s4.77644,2.318,4.56572,2.80967S212.39393,579.14357,212.39393,579.14357Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M216.16535,578.58163s.37285,2.087,2.26938,1.99174S216.16535,578.58163,216.16535,578.58163Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M209.514,584.41171a2.15645,2.15645,0,0,0,2.037,1.40483C213.30707,586.02727,209.514,584.41171,209.514,584.41171Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M227.39056,579.14357s2.318.94826,2.52871,2.28286S227.39056,579.14357,227.39056,579.14357Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M221.701,584.0612a12.84976,12.84976,0,0,1,3.42429,3.59919C225.07258,587.97648,221.701,584.0612,221.701,584.0612Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M225.81012,582.00318a1.5428,1.5428,0,0,1,1.58044.33639C228.02274,583.02443,225.81012,582.00318,225.81012,582.00318Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M242.82621,559.0544s-8.95584-2.89748-8.271,0,8.271,4.5306,8.271,4.5306Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#f899a5"
        />
        <path
          d="M272.90729,527.55092l-7.38806,13.065-2.72677,5.16277-14.4347-2.10725.32874-.69119a8.3046,8.3046,0,0,1,1.14634-1.28964,4.88657,4.88657,0,0,1,.07374-1.27277,2.47649,2.47649,0,0,1,.64481-1.32968.65355.65355,0,0,1,.05479-.05268,8.852,8.852,0,0,0,1.631-2.967c.12434-.32873.1939-.54579.1939-.54579l.9672-1.09365,3.09557-3.498.87451-.99042.82181-.92718-2.948,4.19132s-1.40552,2.52871-1.47507,2.88063a41.11411,41.11411,0,0,1-2.3896,3.44114s-3.93217,3.44326,3.09133,3.5128,11.30962-6.81276,11.30962-6.81276l5.92563-9.1771A10.20355,10.20355,0,0,0,272.90729,527.55092Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <polygon
          points="188.767 521.939 186.017 521.747 179.801 521.226 179.801 520.272 188.721 520.832 188.767 521.939"
          opacity="0.1"
        />
        <path
          d="M271.67805,526.32169a4.66992,4.66992,0,0,0,2.52871,1.47508,16.88527,16.88527,0,0,0-3.16088,4.84669s-3.94455,6.63431-1.12387,8.92071a14.35046,14.35046,0,0,0,4.46035,2.73944l-.85429,15.27245s2.08353,10.50631,2.85619,11.279.56193,2.5287.56193,2.5287-.50943,1.756.02625,2.38823.67617,3.8633.67617,3.8633a22.66252,22.66252,0,0,0-3.79306-1.61556c-.63218,0-2.38822-3.30137-2.38822-3.30137l-17.17273-1.19411-7.55241-.63218,1.19412-21.00231s-3.44186-5.64745,1.26435-9.9884a3.57733,3.57733,0,0,1,.77266-2.65514c.95271-.8356,1.82629-3.51209,1.82629-3.51209l5.75829-6.50992h0l-2.94862,4.19194s-1.40484,2.5287-1.47508,2.87991a40.93447,40.93447,0,0,1-2.38822,3.44185s-3.93354,3.44186,3.09064,3.5121,11.30894-6.81346,11.30894-6.81346Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#e6ebef"
        />
        <path
          d="M266.0587,553.997a10.41238,10.41238,0,0,0,5.05742,1.86141C273.73193,555.93154,266.0587,553.997,266.0587,553.997Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M269.21959,548.32495s1.93165-.96582,3.0204-.158S269.21959,548.32495,269.21959,548.32495Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M268.30644,551.5034s.123,1.12458,2.98528,1.26435S268.30644,551.5034,268.30644,551.5034Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M273.996,527.79677l.59706.32007a13.3131,13.3131,0,0,0,3.79306.8038,6.06592,6.06592,0,0,1,4.952,4.74132c.10536.55316.191,1.2907.26012,2.08586a42.88893,42.88893,0,0,1-.13164,8.56393,30.25043,30.25043,0,0,0-.3392,4.62782c.21072.63217-1.159,10.43091-1.159,10.43091s-.31609,8.00758-2.318,8.74512-13.17034.73753-13.17034.73753l-4.74133-8.21829,11.06309.52681a10.81454,10.81454,0,0,0,1.36972-5.68959c-.10536-3.37161.21072-11.16845.21072-11.16845s-6.68965-1.42414-5.32721-6.65061A31.66036,31.66036,0,0,1,273.996,527.79677Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#f899a5"
        />
        <path
          d="M252.92416,590.383s-4.46526,1.47508-6.20164.70172a43.1743,43.1743,0,0,1-5.52943-3.72353s-2.43389-2.39595-4.74766-5.05319c-.099-.11379-.20018-.22969-.2971-.34349l-.00211-.0042c-2.00611-2.33274-3.83522-4.79612-3.80361-5.9783a5.01129,5.01129,0,0,0-.18755-1.48561,6.19059,6.19059,0,0,0-.96089-1.94288,5.9828,5.9828,0,0,0-.81764-.92509l-7.30584-9.41311s2.10725-2.24845,2.10725-2.88063,2.52871-4.07331,5.75915-2.24633a69.79554,69.79554,0,0,1,7.92114,6.65472c4.55591,4.18079,9.21925,8.72825,9.21925,8.72825s.33085.35191.81342.90191c1.237,1.41185,3.46853,4.12389,3.64556,5.4894C252.783,580.75913,252.92416,590.383,252.92416,590.383Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#bdd3e8"
        />
        <path
          d="M248.8909,573.3732c-3.46223,3.44536-8.66506,8.06446-12.44547,8.93476a.884.884,0,0,1-.10114.02528l-.196-.36877-.00211-.0042-3.99116-7.46391-1.00935-1.88809.04846-.05479,7.66406-8.81044c4.55591,4.18079,9.21925,8.72825,9.21925,8.72825S248.40833,572.8232,248.8909,573.3732Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.05"
        />
        <path
          d="M276.85839,579.82548v1.601s2.21262,7.8144-1.79117,10.027c-2.02312,1.118-6.33293,1.38479-10.10193,1.37509a10.70069,10.70069,0,0,1-10.56184-8.80022,6.50666,6.50666,0,0,1-.04-2.26824s-1.79117-12.80158-2.21262-12.907c0,0-10.0665,11.5254-16.228,12.84835l-5.1995-9.72553,8.30988-9.54995s6.16372-9.79873,7.95489-10.69432a12.87181,12.87181,0,0,0,3.58234-3.40673s7.21735-6.02324,12.01135,4.14427,7.90221,18.38252,9.0612,21.42958c0,0,1.68581,3.456,2.73943,3.446l.03172-.00017A2.46723,2.46723,0,0,1,276.85839,579.82548Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#bdd3e8"
        />
        <circle cx="185.80728" cy="465.11405" r="11.22478" opacity="0.1" />
        <circle cx="186.01801" cy="464.6926" r="11.22478" fill="#f899a5" />
        <path
          d="M242.828,512.62515a1.841,1.841,0,0,1-.85664-.15906,1.37833,1.37833,0,0,1-.4673-.47194,4.09307,4.09307,0,0,1,.1826-4.08687c.68311-1.259,1.71292-2.29352,2.49537-3.49331,1.30391-1.99937,2.0137-4.55391,4.0435-5.80992,1.85121-1.1455,4.25787-.82779,6.309-.0984a7.15044,7.15044,0,0,1,2.773,1.5962,27.09253,27.09253,0,0,1,1.67956,2.28691,6.62194,6.62194,0,0,0,3.03119,2.1391,21.60526,21.60526,0,0,1,3.33764,1.01142c2.10013,1.12356,2.79165,3.74765,3.26645,6.08164a81.3822,81.3822,0,0,0,3.25566,12.64,4.48583,4.48583,0,0,0,2.20393,2.856,5.69972,5.69972,0,0,1-2.07466-.084,1.98708,1.98708,0,0,0-1.89268.61011,2.19888,2.19888,0,0,0-.28625.80065,19.53545,19.53545,0,0,0,.98554,11.18955,2.41333,2.41333,0,0,1-2.64329-1.17693,25.61046,25.61046,0,0,0-.19211,4.716c-1.20506-.5738-1.23828-2.22649-1.35222-3.55631a1.81655,1.81655,0,0,0-.26978-.93013,1.4764,1.4764,0,0,0-2.089.03633,10.41185,10.41185,0,0,0-1.3496,1.91967,4.91555,4.91555,0,0,1-5.13833,1.848,1.33051,1.33051,0,0,1-.6089-.30023,1.06608,1.06608,0,0,1-.08993-1.233,3.4748,3.4748,0,0,1,.90444-.95711,20.32065,20.32065,0,0,0,3.167-3.32971,3.85435,3.85435,0,0,0,.89558-1.867c.166-1.67983-1.59043-2.85873-3.15232-3.49894s-3.40567-1.3996-3.7844-3.04457c-.51422-2.2334,2.13913-4.32865,1.54286-6.54156-.36826-1.36668-1.81045-2.10239-3.105-2.67477a24.23684,24.23684,0,0,1-5.99208-3.3951,21.44426,21.44426,0,0,1-2.096-2.401C244.76807,512.46568,243.81375,512.6483,242.828,512.62515Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#4b3648"
        />
        <path
          d="M244.65258,522.77023a3.16492,3.16492,0,0,0-.76372,1.03727,2.41678,2.41678,0,0,0,.18834,1.48783,8.17437,8.17437,0,0,1-.21638,5.49592,12.75993,12.75993,0,0,0-1.28071,3.34627c-.20219,1.97476,1.2288,3.73834,1.55595,5.69627a7.0171,7.0171,0,0,1-.58408,3.86093,20.92753,20.92753,0,0,1-1.99309,3.41254,5.263,5.263,0,0,0,6.37193-2.86758,21.5693,21.5693,0,0,0,.62441-2.18391.56571.56571,0,0,1,.21936-.35947.77315.77315,0,0,1,.40026-.0386,2.3509,2.3509,0,0,0,1.66522-1.07966,5.8194,5.8194,0,0,0,1.28355-2.04706c.142-.49493.15017-1.02025.28733-1.51653a3.03912,3.03912,0,0,1,1.351-1.77646,9.29332,9.29332,0,0,0,1.404-.783,2.35127,2.35127,0,0,0,.72817-1.79682,5.10151,5.10151,0,0,0-.47835-1.929c-.37576-.88726-.85607-1.74393-1.26332-2.61987A11.21589,11.21589,0,0,1,244.65258,522.77023Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#4b3648"
        />
        <path
          d="M251.94009,568.32632a10.46291,10.46291,0,0,0,2.15567-3.6877c.79449-2.318-.23882,2.354-1.94494,4.21451Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M216.16535,549.83515s5.74635.73754,6.00975,1.05363"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <line
          x1="162.86912"
          y1="493.94799"
          x2="160.90514"
          y2="495.93801"
          opacity="0.1"
        />
        <line
          x1="160.20956"
          y1="496.0402"
          x2="158.24558"
          y2="498.03022"
          opacity="0.1"
        />
        <g opacity="0.1">
          <path
            d="M268.57907,538.75734a1.71877,1.71877,0,0,0-.26341-.863,1.4764,1.4764,0,0,0-2.089.03635,2.86337,2.86337,0,0,0-.29793.31335.9971.9971,0,0,1,.59375.38194,1.81711,1.81711,0,0,1,.26973.93014c.114,1.32982.14719,2.98252,1.35223,3.5563a25.61126,25.61126,0,0,1,.1921-4.716A2.15333,2.15333,0,0,0,268.57907,538.75734Z"
            transform="translate(-68.27659 -52.19946)"
          />
          <path
            d="M273.14815,526.25425a1.52076,1.52076,0,0,0-1.07436.59732,1.23034,1.23034,0,0,0-.062.11038c.054.00333.10845.00561.16139.01115a5.69963,5.69963,0,0,0,2.07469.08395A2.73868,2.73868,0,0,1,273.14815,526.25425Z"
            transform="translate(-68.27659 -52.19946)"
          />
          <path
            d="M259.73868,541.69843a1.33041,1.33041,0,0,1-.60887-.30023,1.06613,1.06613,0,0,1-.08993-1.233,3.47461,3.47461,0,0,1,.90443-.95711,20.3192,20.3192,0,0,0,3.167-3.32969,3.854,3.854,0,0,0,.89558-1.867c.166-1.67982-1.59042-2.85873-3.15229-3.49894s-3.40567-1.39961-3.78442-3.04458c-.51421-2.2334,2.13915-4.32864,1.54284-6.54154-.36821-1.36668-1.81041-2.1024-3.105-2.67478a24.2362,24.2362,0,0,1-5.99205-3.39511,21.44374,21.44374,0,0,1-2.096-2.401c-.69278-.78125-1.64712-.59864-2.63284-.62177a1.841,1.841,0,0,1-.85663-.15908,1.378,1.378,0,0,1-.46729-.47193,4.093,4.093,0,0,1,.18258-4.08687c.68311-1.259,1.71292-2.29352,2.49537-3.49331,1.27243-1.95108,1.98255-4.42738,3.90218-5.7132a4.93382,4.93382,0,0,0-1.65195.63491c-2.02978,1.256-2.73959,3.81057-4.04351,5.80993-.78245,1.19979-1.81226,2.23431-2.49537,3.49332a4.09309,4.09309,0,0,0-.18258,4.08686,1.37813,1.37813,0,0,0,.46729.47194,1.84108,1.84108,0,0,0,.85664.15906c.98577.02314,1.94005-.15947,2.63288.62179a21.44752,21.44752,0,0,0,2.09594,2.401,24.239,24.239,0,0,0,5.9921,3.3951c1.29455.57238,2.73676,1.30809,3.105,2.67477.59627,2.21292-2.05709,4.30816-1.54288,6.54156.37875,1.645,2.22249,2.40435,3.78441,3.04457s3.31826,1.81911,3.15235,3.499a3.855,3.855,0,0,1-.89559,1.867,20.32254,20.32254,0,0,1-3.16706,3.32971,3.47476,3.47476,0,0,0-.90443.95711,1.06611,1.06611,0,0,0,.08993,1.233,1.33034,1.33034,0,0,0,.60892.30023,4.91137,4.91137,0,0,0,3.905-.67392A4.69039,4.69039,0,0,1,259.73868,541.69843Z"
            transform="translate(-68.27659 -52.19946)"
          />
          <path
            d="M270.12978,537.66484q-.1278.95476-.18213,1.91743a2.2621,2.2621,0,0,0,1.03213-.00886q-.283-.70545-.50747-1.43224A2.18165,2.18165,0,0,1,270.12978,537.66484Z"
            transform="translate(-68.27659 -52.19946)"
          />
        </g>
        <g opacity="0.1">
          <path
            d="M243.74155,543.38694a12.66356,12.66356,0,0,0,.62142-1.24767,7.01711,7.01711,0,0,0,.58408-3.86093c-.32715-1.95793-1.75814-3.72151-1.556-5.69627a12.76031,12.76031,0,0,1,1.28072-3.34627,8.17437,8.17437,0,0,0,.21638-5.49592,3.98232,3.98232,0,0,1-.24818-1.05664,2.65546,2.65546,0,0,0-.56822.83316,2.41682,2.41682,0,0,0,.18834,1.48784,8.17443,8.17443,0,0,1-.21638,5.49592,12.76017,12.76017,0,0,0-1.28072,3.34627c-.20218,1.97475,1.22881,3.73833,1.556,5.69626A7.00673,7.00673,0,0,1,243.74155,543.38694Z"
            transform="translate(-68.27659 -52.19946)"
          />
          <path
            d="M242.53976,545.60612c-.25919.40774-.52877.80951-.79794,1.21a5.263,5.263,0,0,0,6.37192-2.86757c.0495-.1209.09287-.24384.134-.36751A5.32018,5.32018,0,0,1,242.53976,545.60612Z"
            transform="translate(-68.27659 -52.19946)"
          />
          <path
            d="M255.97691,532.89958a9.29419,9.29419,0,0,1-1.404.783,3.03908,3.03908,0,0,0-1.351,1.77646c-.01323.04792-.02439.09632-.03545.14473a2.99656,2.99656,0,0,1,.75838-.65683,9.29278,9.29278,0,0,0,1.404-.783,2.20076,2.20076,0,0,0,.69114-1.32714C256.01853,532.85735,255.99949,532.88,255.97691,532.89958Z"
            transform="translate(-68.27659 -52.19946)"
          />
          <path
            d="M251.65106,539.02259a2.3509,2.3509,0,0,1-1.66522,1.07966.77315.77315,0,0,0-.40026.0386.56576.56576,0,0,0-.21937.35947c-.08257.28426-.15228.57264-.22348.86041.07094-.00257.14426.00432.215.00588A2.351,2.351,0,0,0,251.023,540.287a5.81953,5.81953,0,0,0,1.28355-2.04707c.00632-.02194.01106-.04423.01687-.06629C252.115,538.46752,251.88242,538.74793,251.65106,539.02259Z"
            transform="translate(-68.27659 -52.19946)"
          />
        </g>
        <path
          d="M600.72955,725.09258c-7.63049,6.08554-12.41111.45414-12.41111.45414s-12.87081-9.17373-13.14656-10.44532a12.28032,12.28032,0,0,0-.73544-2.27072s-2.11452.36332-2.11452-.6358-2.2064-1.36244-3.49351-2.1799-9.37729-7.9021-9.37729-7.9021-.27584-1.54411-3.98856-2.72487c-2.61237-.83083-8.17257-6.02037-11.241-9.02538-.19151-1.22036-.81493-4.92028-1.50236-6.05222a1.67343,1.67343,0,0,0-1.20674-.53151q-.14139-.50606-.30467-1.12521a76.25333,76.25333,0,0,1-1.9821-10.42352c-.82741-7.26632-6.987-9.537-8.54988-9.537s-13.974-5.26807-13.974-5.26807l-20.13363-8.17462s-12.41111-3.902-11.95146-6.53966a2.27784,2.27784,0,0,0-.02576-.84655,9.61381,9.61381,0,0,0-2.41234-3.87293,27.21715,27.21715,0,0,0-2.43441-2.36517l-6.68908-4.14545-.51078-.31687a57.78355,57.78355,0,0,1,7.19986-8.34456s-1.47092-2.72487-3.1257-2.72487c-1.10228,0-7.25935-1.93345-11.25028-3.22523.413-4.41252,1.22732-17.84819-3.82694-20.57194l-6.06764-3.26984s.21117.46826.52639,1.2085l-.89415-.48186s.10323.229.27034.61319c-.18166-.02574-.37054-.04663-.56081-.05949a11.55143,11.55143,0,0,1-.7208-4.00519c.40328-1.26184.46963-9.90172-3.15591-14.34974l2.905-8.446a1.656,1.656,0,0,0-1.05062-2.10652l-7.53047-2.52817a2.25943,2.25943,0,0,0-2.53623,1.038l-2.13756,6.21487a25.36154,25.36154,0,0,0-2.72791-.47719c-.63534-1.14543-1.4012-2.25061-1.28562-3.51727a6.07887,6.07887,0,0,1,.771-2.08687,23.84592,23.84592,0,0,0,2.04312-6.01048,2.631,2.631,0,0,0,.02673-1.274c-.31589-1.02639-1.65351-1.3754-2.2247-2.28777a3.23123,3.23123,0,0,1-.09478-2.55671c.36934-1.34387.932-2.63355,1.23685-3.99314a5.86456,5.86456,0,0,0-.3398-4.07487,6.42742,6.42742,0,0,0-2.40469-2.27009c-.25271-1.20007-1.123-2.334-.846-3.52757.1664-.71739.73223-1.30832.83629-2.03711.18764-1.31394-1.12769-2.30808-2.28044-2.98909l-10.21029-6.03207c-.9102-.53772-1.85421-1.08293-2.82662-1.53631a10.08664,10.08664,0,0,0-5.82126-1.40253c-2.59312.3234-4.733,2.17367-6.335,4.214s-2.85026,4.35492-4.644,6.23312c-3.27712,3.43129-8.05009,5.08531-11.6099,8.22967a7.99269,7.99269,0,0,0-2.31175,3.047c-1.49453,3.95919,2.18328,8.04689,2.15866,12.27242-.02154,3.70268-2.85928,6.77484-5.80482,9.06427-1.25307.97392-2.66231,2.04184-2.91441,3.5972a8.19768,8.19768,0,0,0,.70634,3.53754,11.58619,11.58619,0,0,1-.35532,7.30817c-2.32151,1.53286-3.97827,2.57094-3.97827,2.57094s-9.56115,7.99292-14.89331,9.8095a1.04321,1.04321,0,0,0-.54375.3261c-1.47823.89815-5.51145,3.43027-6.25937,4.76033-.91935,1.63491-7.17089,7.81127-3.1258,9.99117a22.54281,22.54281,0,0,0,7.53861,2.5432s9.37729,2.90653,13.05467,4.72311a40.2648,40.2648,0,0,0,6.9446,2.41233,14.0649,14.0649,0,0,1-2.791,7.0785c-.03425-.0021-.06845-.00328-.1027-.00556a11.58625,11.58625,0,0,1-1.54435,1.679c.338.05393.67724.10777,1.01739.15954-.02379.02141-.04515.04494-.06916.06618,2.66285.42489,5.40668.8478,8.03418.24534s5.14214-2.48925,5.62043-5.11192c.515-2.82356-1.25167-6.21.67138-8.35976a4.18127,4.18127,0,0,1,2.40764-1.23649c1.27031,1.68277,10.6338,13.59895,19.13039,10.98477-1.93339,5.16661-5.384,14.17329-6.03862,14.432-.9193.36332,9.37729,3.63316,9.37729,3.63316s2.02527-.328,4.92865-.60234q-.03225.52066-.06348,1.0928c-.19859,3.56777-.33093,8.3599.28317,9.68237a6.59518,6.59518,0,0,1,.37053,1.02878,17.84956,17.84956,0,0,0,5.53765,8.936c.30006.256.59972.5084.8949.753a12.06715,12.06715,0,0,1,2.8992,3.81477,14.86276,14.86276,0,0,0,8.73141,7.53884,19.36569,19.36569,0,0,0,9.06932.545s20.67048,1.99823,32.07032,2.90652,23.81086,6.17637,23.81086,6.17637a52.83432,52.83432,0,0,1,9.80393,9.30087c.30388.39348.59545.79557.87823,1.20168l-1.76447,3.11844s8.40277,6.12876,14.06523,10.71189c.01073.29825.01205.57616.00071.82672-.27584,6.08552,7.81435,14.62343,7.81435,14.62343s2.48224,3.45152,3.76926,5.17725-2.20641,2.8157-2.20641,2.8157,5.7919,1.63493,3.49352,7.72045-.64356,10.082-.64356,10.082l3.40154,16.25837h7.079l-1.37908-11.26279c2.48224-.18165,9.10155,9.99117,9.10155,9.99117s17.28362-2.634,20.40933-3.54231,2.57421-6.72136-3.40154-5.44975a10.271,10.271,0,0,1-9.56116-2.81569s-4.229-4.90476-6.61922-17.43913a91.0864,91.0864,0,0,0-3.07567-10.86668c3.28143,4.98318,5.09708,12.2858,5.837,12.68324,1.01462.545,13.69488,14.89595,13.69488,14.89595l5.00132-4.90478-8.58681-9.99117s7.81444.09084,11.03212,2.27072,7.44672,1.08994,7.44672,1.08994,9.745-7.72045,12.13528-10.627S608.36,719.007,600.72955,725.09258Z"
          transform="translate(-68.27659 -52.19946)"
          fill="url(#e2c3e3a3-cac1-4055-a5e1-d90d4080aa08)"
        />
        <path
          d="M457.82971,595.5393s-4.16557-1.26779-3.98446.90556-2.17334,4.16557-2.17334,4.16557l3.80335,9.96115,8.51226-3.0789-2.71668-8.51226Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#575989"
        />
        <path
          d="M457.82971,595.5393s-4.16557-1.26779-3.98446.90556-2.17334,4.16557-2.17334,4.16557l3.80335,9.96115,8.51226-3.0789-2.71668-8.51226Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M435.98673,542.03088a8.04409,8.04409,0,0,1,3.35728,2.84542,5.91212,5.91212,0,0,1,.33474,4.06261c-.30022,1.35551-.8545,2.64132-1.21834,3.98115a3.25732,3.25732,0,0,0,.09341,2.549c.56262.90963,1.88017,1.25759,2.19129,2.2809a2.654,2.654,0,0,1-.02628,1.27018,23.97234,23.97234,0,0,1-2.01253,5.99242,6.10753,6.10753,0,0,0-.75938,2.08057c-.18242,2.02322,1.86381,3.63322,2.03936,5.657a6.44137,6.44137,0,0,1-.82239,3.13925,6.781,6.781,0,0,1-2.042,2.944,5.18476,5.18476,0,0,1-4.32413.38029c-1.4392-.40637-2.78221-1.11528-4.2329-1.47851a17.24978,17.24978,0,0,1-3.9946-1.02473c-2.06494-1.09225-2.92964-3.55478-3.53612-5.8107a9.21836,9.21836,0,0,1-.38879-4.641,15.51054,15.51054,0,0,1,1.24621-2.7659,21.52822,21.52822,0,0,1,1.6783-3.41035c.70641-.97717,1.74123-1.781,2.04089-2.94889.34587-1.348-.3967-2.70409-1.01836-3.94921a26.675,26.675,0,0,1-1.40353-3.37077,6.014,6.014,0,0,1-.41513-2.93065c.36058-2.04378,2.47189-3.28814,4.47472-3.832,1.47884-.40154,3.02086-.57747,4.46327-1.11089a6.739,6.739,0,0,1,1.905-.72093A4.55218,4.55218,0,0,1,435.98673,542.03088Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#353045"
        />
        <path
          d="M541.86562,686.27635l-16.7891,2.25665-.0543.00725s-16.75285-20.01287-17.02452-20.10342-18.92619-6.70114-18.92619-6.70114l-12.67783-3.71279-1.72056-8.2406,16.8434-.63389,5.52391.815,19.83176,8.15s12.22505,5.25225,13.7645,5.25225,7.6067,2.26389,8.4217,9.50837a76.84275,76.84275,0,0,0,1.95244,10.3922C541.49615,685.139,541.86562,686.27635,541.86562,686.27635Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#ffd5d7"
        />
        <path
          d="M541.86562,686.27635l-16.7891,2.25665-.0543.00725s-16.75285-20.01287-17.02452-20.10342-18.92619-6.70114-18.92619-6.70114l-12.67783-3.71279-1.72056-8.2406,16.8434-.63389,5.52391.815,19.83176,8.15s12.22505,5.25225,13.7645,5.25225,7.6067,2.26389,8.4217,9.50837a76.84275,76.84275,0,0,0,1.95244,10.3922C541.49615,685.139,541.86562,686.27635,541.86562,686.27635Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.05"
        />
        <path
          d="M491.24485,649.60119l.815,1.35834s-5.81166,3.12089-5.35084,4.3224l-8.41367-3.41684Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M541.86562,686.27635l-16.7891,2.25665c-1.08667-3.86855-1.956-6.69389-1.956-6.69389l11.59117,1.99223a29.70553,29.70553,0,0,1,6.29912-.56507C541.49615,685.139,541.86562,686.27635,541.86562,686.27635Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M534.71171,684.918s6.9728-1.35834,7.78781,0,1.53945,6.42947,1.53945,6.42947,13.67394,32.0568,16.0284,44.55352,6.52,17.38674,6.52,17.38674a10.05064,10.05064,0,0,0,9.41781,2.80724c5.88614-1.26778,6.42948,4.5278,3.35057,5.43336S559.25236,765.06,559.25236,765.06s-6.52-10.14227-8.965-9.96116l1.35834,11.22894h-6.97281l-3.35057-16.20951s-1.63-3.98446.63389-10.05171-3.44113-7.69726-3.44113-7.69726,3.44113-1.08667,2.17335-2.80723-3.7128-5.16169-3.7128-5.16169-7.96892-8.51226-7.69725-14.57951-6.15781-26.89511-6.15781-26.89511Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#636892"
        />
        <path
          d="M534.71171,684.918s6.9728-1.35834,7.78781,0,1.53945,6.42947,1.53945,6.42947,13.67394,32.0568,16.0284,44.55352,6.52,17.38674,6.52,17.38674a10.05064,10.05064,0,0,0,9.41781,2.80724c5.88614-1.26778,6.42948,4.5278,3.35057,5.43336S559.25236,765.06,559.25236,765.06s-6.52-10.14227-8.965-9.96116l1.35834,11.22894h-6.97281l-3.35057-16.20951s-1.63-3.98446.63389-10.05171-3.44113-7.69726-3.44113-7.69726,3.44113-1.08667,2.17335-2.80723-3.7128-5.16169-3.7128-5.16169-7.96892-8.51226-7.69725-14.57951-6.15781-26.89511-6.15781-26.89511Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.05"
        />
        <path
          d="M548.74788,734.36155s2.445,16.39063,5.61446,17.56786S548.74788,734.36155,548.74788,734.36155Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M542.13729,721.41205c.27167.27167,7.78781,10.05171,10.77616,10.14227S542.13729,721.41205,542.13729,721.41205Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M530.27446,682.20133s-8.24059,21.46176-11.95338,14.85118a26.41034,26.41034,0,0,0-2.02486-3.04269,52.28331,52.28331,0,0,0-9.65686-9.27292s-12.22505-5.25225-23.454-6.15781-31.58952-2.89779-31.58952-2.89779l-2.64063-2.26389c-.27167-14.67007,29.34012-21.55232,29.34012-21.55232s22.639,9.32726,31.15125,12.04394,9.96115,6.7917,9.96115,6.7917l8.49413,8.99039Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#ffd5d7"
        />
        <path
          d="M530.27446,682.20133s-8.24059,21.46176-11.95338,14.85118a26.41034,26.41034,0,0,0-2.02486-3.04269l1.35408-2.42191a40.44888,40.44888,0,0,1,7.28328-9.49405,17.71439,17.71439,0,0,1,2.9683-2.40274Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M520.585,689.08358s7.6067-9.32726,9.68948-8.33114,11.59116,8.05948,11.59116,8.05948,9.52925,9.96115,13.18633,11.13838,3.92875,2.71667,3.92875,2.71667,7.96892,7.06337,9.2367,7.87837,3.44113,1.17723,3.44113,2.17334,2.08279.63389,2.08279.63389a12.34224,12.34224,0,0,1,.72444,2.2639c.27167,1.26779,12.9495,10.41394,12.9495,10.41394s4.70891,5.61446,12.22505-.45278,5.61447,1.99223,3.26,4.89-11.95339,10.595-11.95339,10.595-4.16557,1.08667-7.335-1.08667-10.86671-2.2639-10.86671-2.2639l8.458,9.96116-4.92634,4.89s-12.49013-14.30784-13.48954-14.85118-3.98775-14.03617-9.96445-16.75285c0,0-17.02451-6.52-22.54843-11.13838S515.42329,698.317,515.42329,698.317Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#636892"
        />
        <path
          d="M577.09189,721.41205c-.54334-.27166-12.58728,1.90168-10.05171,3.21474S577.09189,721.41205,577.09189,721.41205Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M564.05183,715.61647c-.54334.36223-6.97281,1.90168-5.3428,3.62224S564.05183,715.61647,564.05183,715.61647Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M497.04043,649.96342s-4.34668.09055-18.38285,2.98834-27.06172,22.72954-27.06172,22.72954a18.8556,18.8556,0,0,1-8.93338-.54332,14.69338,14.69338,0,0,1-8.60053-7.51619,12.01836,12.01836,0,0,0-2.85568-3.80331c-.29079-.24389-.586-.49555-.88151-.75075a17.82912,17.82912,0,0,1-5.45462-8.90917,6.62919,6.62919,0,0,0-.365-1.02569c-.60489-1.3185-.47454-6.09623-.27892-9.65327.12318-2.311.27892-4.104.27892-4.104l46.72686-8.79115,2.64788,1.66259,6.58883,4.133a26.95632,26.95632,0,0,1,2.39792,2.35808,9.60478,9.60478,0,0,1,2.37616,3.86129,2.29886,2.29886,0,0,1,.02538.844C484.81538,646.07314,497.04043,649.96342,497.04043,649.96342Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#dce6f2"
        />
        <path
          d="M426.85958,561.30915s-4.5278,6.33892,1.08667,17.93008-23.72565-6.70114-23.72565-6.70114,11.04782-16.66229,9.41781-19.7412S426.85958,561.30915,426.85958,561.30915Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#ffd5d7"
        />
        <circle cx="354.41742" cy="501.6841" r="14.30784" opacity="0.1" />
        <circle cx="354.41742" cy="500.59743" r="14.30784" fill="#ffd5d7" />
        <path
          d="M425.22957,571.20993s4.70891,7.486-9.68948,3.32039,11.31949,28.43456,11.31949,28.43456l10.14227-10.50449L433.01738,573.987Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M425.22957,571.93438s4.70891,7.486-9.68948,3.32039,11.31949,28.43456,11.31949,28.43456l10.14227-10.50449-3.98447-18.47341Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#dce6f2"
        />
        <path
          d="M473.87987,632.247a13.57264,13.57264,0,0,0-1.199,2.0502c-1.63,3.62224-5.61447,2.71668-5.61447,2.71668-6.52,3.98446-23.72566,2.89779-23.72566,2.89779s3.80335,6.33891-3.44112,4.16557c-4.45175-1.33661-11.16377-1.02872-15.67343-.59768.12318-2.311.27892-4.104.27892-4.104l46.72686-8.79115Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M480.4687,623.61164s-6.15781,5.97669-7.78781,9.59893-5.61447,2.71668-5.61447,2.71668c-6.52,3.98446-23.72566,2.89779-23.72566,2.89779s3.80335,6.33891-3.44112,4.16557-20.46565,0-20.46565,0-10.14226-3.26-9.2367-3.62224,7.24447-17.93007,7.24447-17.93007a7.44282,7.44282,0,0,0,.50712-3.01008,6.21446,6.21446,0,0,0-1.45614-3.82146,9.01927,9.01927,0,0,0-3.39766-2.40517c-7.06337-3.0789-19.56009-10.86671-19.56009-10.86671s-31.87569-4.70891-26.62344-6.52,14.67006-9.78,14.67006-9.78,14.85117-9.41782,17.749-13.40228,8.87449-5.25225,8.87449-5.25225l8.28768,6.15781,15.07575,13.40228v-.00725l.72445-8.14279s1.63-5.43335,3.80335-6.88225c2.09729-1.39818,10.2582,1.41629,10.83408,1.61913l.03263.01088s8.33115,24.08788,7.96892,28.43456a10.43549,10.43549,0,0,0,1.20986,4.535c.51433,1.13376,1.14822,2.32912,1.81833,3.49547a88.55224,88.55224,0,0,0,4.94073,7.54512s12.85895,4.34669,14.489,4.34669S480.4687,623.61164,480.4687,623.61164Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#575989"
        />
        <polygon
          points="363.292 535.28 361.662 542.434 345.996 533.922 347.492 521.063 362.567 534.465 362.567 534.458 363.292 535.28"
          opacity="0.1"
        />
        <polygon
          points="364.016 534.556 362.386 541.71 346.72 533.198 348.216 520.339 363.292 533.741 363.292 533.734 364.016 534.556"
          fill="#575989"
        />
        <path
          d="M457.96011,609.7276c-5.93686,1.23517-32.46249,6.80617-40.01123,9.42506a6.21446,6.21446,0,0,0-1.45614-3.82145c7.50889-3.43752,30.60428-13.30087,39.649-9.09908C456.65611,607.36589,457.29,608.56125,457.96011,609.7276Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M457.96011,608.2787c-5.93686,1.23517-32.46249,6.80618-40.01123,9.42507a6.2145,6.2145,0,0,0-1.45614-3.82146c7.50889-3.43752,30.60428-13.30086,39.649-9.09908C456.65611,605.917,457.29,607.11235,457.96011,608.2787Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M457.96011,609.00315c-5.93686,1.23517-32.46249,6.80617-40.01123,9.42507a6.21446,6.21446,0,0,0-1.45614-3.82146c7.50889-3.43752,30.60428-13.30087,39.649-9.09908C456.65611,606.64144,457.29,607.8368,457.96011,609.00315Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#575989"
        />
        <circle cx="383.39532" cy="560.18324" r="1.8564" fill="#feffff" />
        <circle cx="389.68352" cy="573.17801" r="1.8564" fill="#feffff" />
        <circle cx="368.72526" cy="563.89603" r="1.8564" fill="#feffff" />
        <circle cx="376.2414" cy="577.47942" r="1.8564" fill="#feffff" />
        <circle cx="378.65378" cy="545.8754" r="1.8564" fill="#feffff" />
        <path
          d="M425.41069,617.95189s-7.6067,18.6998-5.79558,21.23537S425.41069,617.95189,425.41069,617.95189Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M431.84016,617.95189c-1.06967-.26742,4.52779,5.02586,5.16169,9.8706s4.52779,8.91976,4.52779,8.91976l-3.89232-9.50837S433.10794,618.26884,431.84016,617.95189Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M456.10371,616.0955c.54877.815,8.06492,2.26389,8.87992,10.6856Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M405.57893,602.69322c.90556.815,11.13839,7.69725,14.76062,7.83308S405.57893,602.69322,405.57893,602.69322Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M421.78845,606.49657s1.53945,2.17334,3.0789,2.17334S421.78845,606.49657,421.78845,606.49657Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M389.91276,606.04379s8.33114.54333,10.86671,1.53945a41.64666,41.64666,0,0,0,7.69494,1.29152A15.60179,15.60179,0,0,1,419.122,614.624c2.3746,3.011,3.572,6.72378-1.13693,9.531-9.41782,5.61447-20.82787-10.32337-20.82787-10.32337l-9.96115-1.4489Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#ffd5d7"
        />
        <path
          d="M485.24278,642.5994c-6.54536.21733-28.52149.8621-31.71266-.06157-.30788-.08693,19.42243-.99612,24.04079-1.90168a17.9955,17.9955,0,0,0,5.29571-1.898A9.60478,9.60478,0,0,1,485.24278,642.5994Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M448.78676,646.88451s-10.87935,7.96893-6.12517,8.05948S448.78676,646.88451,448.78676,646.88451Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M393.89722,605.27587c-3.26-.2282-6.88225,14.89464-6.88225,14.89464a50.06912,50.06912,0,0,1-9.59893-3.0789c-3.62224-1.81112-12.85895-4.70891-12.85895-4.70891a22.01215,22.01215,0,0,1-7.42558-2.53556c-3.98446-2.17335,2.17334-8.33115,3.0789-9.96116s6.70114-5.07113,6.70114-5.07113l4.5278-.90556,20.46564,3.62224-13.22117,3.0789,1.64814.5071,4.43361,1.35834Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#575989"
        />
        <path
          d="M384.76557,602.47587,380.85716,612.926c-7.87836,6.1578-7.24447-2.40155-7.24447-2.40155l6.71927-9.407Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#575989"
        />
        <path
          d="M384.76557,602.47587,380.85716,612.926c-7.87836,6.1578-7.24447-2.40155-7.24447-2.40155l6.71927-9.407Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <circle cx="307.82678" cy="560.18324" r="1.8564" fill="#feffff" />
        <path
          d="M434.94025,545.66139a2.563,2.563,0,0,0,2.10213-2.46952c-.01118-1.41583-1.21671-2.71573-.90039-4.09582.16394-.71524.72128-1.30438.82379-2.031.18482-1.31-1.1108-2.30116-2.24625-2.98013L424.66229,528.071c-2.39425-1.43169-5.02608-2.91715-7.79378-2.56778-2.55427.32242-4.662,2.16713-6.24,4.20137s-2.80753,4.34183-4.57441,6.21436c-3.228,3.421-7.92936,5.07005-11.43585,8.205a7.95967,7.95967,0,0,0-2.27707,3.03782c-1.47216,3.9473,2.15051,8.02271,2.12629,12.23553-.02122,3.69158-2.81639,6.75451-5.71781,9.037-1.23428.971-2.6224,2.03572-2.87074,3.5864a8.25941,8.25941,0,0,0,.69578,3.5269c1.73383,5.92409-2.04632,12.1909-6.89494,16.01084-1.44284,1.13672-3.08726,2.27137-3.6188,4.0296-.78044,2.58153,1.15877,5.10378,2.81187,7.23465,2.89567,3.73256,5.32672,7.982,6.02947,12.65352s-.564,9.81969-4.08326,12.97113c2.62292.42361,5.32558.84526,7.91371.24461s5.06505-2.48176,5.53619-5.09657c.50722-2.81506-1.23292-6.19135.66131-8.33464,1.44129-1.63079,3.99234-1.32468,6.15-1.61012a10.04962,10.04962,0,0,0,8.44426-9.21706c.14078-3.19231-1.27461-6.21356-2.37756-9.21259s-1.89764-6.41182-.56961-9.31819c2.13879-4.6807,9.11259-6.63131,9.41366-11.7687.17681-3.01713-2.21487-6.09575-.98045-8.85447.82956-1.85393,2.95078-2.67728,4.53938-3.94282,2.49549-1.988,3.70019-5.12816,5.34688-7.861a37.25949,37.25949,0,0,1,4.70817-6.03949c.56758-.61138,1.6439-2.21077,2.49844-2.40312C433.09327,544.81043,433.86116,545.82724,434.94025,545.66139Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M434.21581,545.29917a2.563,2.563,0,0,0,2.10212-2.46952c-.01118-1.41583-1.21671-2.71573-.90038-4.09582.16393-.71524.72127-1.30438.82378-2.031.18482-1.31-1.1108-2.30115-2.24625-2.98012l-10.05724-6.01393c-2.39425-1.43169-5.02608-2.91715-7.79377-2.56778-2.55428.32242-4.662,2.16713-6.24,4.20137s-2.80754,4.34182-4.57442,6.21436c-3.228,3.421-7.92936,5.07-11.43585,8.205a7.95971,7.95971,0,0,0-2.27707,3.03781c-1.47216,3.9473,2.15052,8.02272,2.1263,12.23554-.02123,3.69157-2.8164,6.7545-5.71781,9.037-1.23428.971-2.6224,2.03572-2.87075,3.5864a8.25936,8.25936,0,0,0,.69578,3.52689c1.73384,5.9241-2.04632,12.19091-6.89494,16.01085-1.44284,1.13672-3.08725,2.27137-3.6188,4.0296-.78044,2.58152,1.15877,5.10378,2.81187,7.23465,2.89568,3.73256,5.32672,7.982,6.02947,12.65351s-.564,9.8197-4.08326,12.97113c2.62293.42362,5.32558.84526,7.91371.24462s5.06505-2.48177,5.53619-5.09657c.50722-2.81506-1.23292-6.19135.66131-8.33464,1.44129-1.63079,3.99234-1.32468,6.15-1.61012A10.04963,10.04963,0,0,0,408.8,604.07135c.14078-3.19231-1.27461-6.21357-2.37756-9.21259s-1.89764-6.41183-.56961-9.3182c2.1388-4.6807,9.11259-6.6313,9.41366-11.76869.17681-3.01713-2.21486-6.09575-.98044-8.85447.82956-1.85393,2.95077-2.67728,4.53937-3.94283,2.49549-1.988,3.70019-5.12815,5.34688-7.861a37.25992,37.25992,0,0,1,4.70817-6.03949c.56758-.61137,1.6439-2.21077,2.49845-2.40311C432.36882,544.4482,433.13671,545.465,434.21581,545.29917Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#353045"
        />
        <path
          d="M425.1692,569.67048c.43851,1.13058.07822,1.31324.332,2.32427a7.71414,7.71414,0,0,1,.2113,2.86761c-.13217,1.35579.72162,2.97022.04328,4.12915a2.58634,2.58634,0,0,0-.27083.5281,1.55868,1.55868,0,0,0,.675,1.58842,4.00581,4.00581,0,0,1,1.28476,1.17135c.66341,1.28856-.60848,3.12244-.01779,4.458a2.55129,2.55129,0,0,0,.91776.99388,11.69087,11.69087,0,0,0,2.925,1.53222c.68356-1.0727-.07614-2.64167.51732-3.77761a5.07408,5.07408,0,0,1,1.22673-1.24363,6.68685,6.68685,0,0,0,1.74287-3.73751c.2502-1.39383.28835-2.81765.56276-4.207.44918-2.27413,1.52107-4.40626,1.76459-6.70873a.98961.98961,0,0,0-.07471-.62218.75729.75729,0,0,0-.62067-.26795c-2.104-.18175-4.41391.381-6.43817.00747C428.05028,568.35569,426.80921,567.92065,425.1692,569.67048Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#353045"
        />
        <path
          d="M447.29259,573.25166c-.63026,2.9159-2.72751,10.98988-7.21184,14.59038-5.52391,4.43724-9.68949,15.93785-9.68949,15.93785l1.26779,2.98834a9.05615,9.05615,0,0,1-2.71668-1.26778c-1.26779-.90556,2.98834-18.83564,2.98834-18.83564l.72445-8.15s1.63-5.43336,3.80335-6.88225C438.5558,570.23435,446.71671,573.04881,447.29259,573.25166Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M446.93037,572.52721c-.63027,2.9159-2.72751,10.98988-7.21185,14.59038-5.52391,4.43725-9.68948,15.93785-9.68948,15.93785l1.26778,2.98835a9.05644,9.05644,0,0,1-2.71668-1.26779c-1.26778-.90556,2.98835-18.83563,2.98835-18.83563l.72445-8.15s1.63-5.43335,3.80335-6.88225C438.19358,569.5099,446.35449,572.32437,446.93037,572.52721Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#575989"
        />
        <rect
          x="440.45347"
          y="564.47874"
          width="11.1452"
          height="23.55087"
          rx="1.69947"
          transform="translate(614.6522 1213.17388) rotate(-161.23154)"
          fill="#464a5f"
        />
        <rect
          x="440.85151"
          y="564.47874"
          width="11.1452"
          height="23.55087"
          rx="1.69947"
          transform="translate(615.42712 1213.30195) rotate(-161.23154)"
          fill="#9c9ca1"
        />
        <circle cx="379.89892" cy="519.4823" r="1.7514" fill="#939498" />
        <path
          d="M459.81469,606.94935v.63389l-6.78444-3.48459-.69544-3.423-1.20624-5.95134s-13.7645-20.194-4.6111-20.462c9.1534-.27167,9.22946,15.20977,8.68612,16.93033-.3876,1.23155,2.14434,8.7803,3.615,12.96761C459.39817,605.81921,459.81469,606.94935,459.81469,606.94935Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#ffd5d7"
        />
        <path
          d="M465.79863,619.80829s2.35446-18.65452-3.62223-21.91454l-5.97669-3.26s4.89,10.95829,2.89779,11.36528-7.78782-4.66414-7.78782-4.66414v11.77227Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M459.81469,606.94935v.63389l-6.78444-3.48459-.69544-3.423c1.84366,1.467,5.02762,3.79247,6.40046,3.51357a.3248.3248,0,0,0,.08331-.029C459.39817,605.81921,459.81469,606.94935,459.81469,606.94935Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M466.16086,619.08384s2.35445-18.65452-3.62224-21.91454l-5.97669-3.26s4.89,10.95829,2.89779,11.36528-7.78781-4.66414-7.78781-4.66414V612.3827Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#575989"
        />
        <circle cx="364.01635" cy="550.04097" r="1.8564" fill="#feffff" />
        <path
          d="M435.208,538.871c.16387-.71523.72127-1.30437.82376-2.031.18483-1.31-1.11081-2.30115-2.24621-2.98013l-.23187-.13866a1.80139,1.80139,0,0,1,.12363.94544c-.1025.7266-.6599,1.31574-.82376,2.031-.31633,1.38009.8892,2.68.90034,4.09582a2.56292,2.56292,0,0,1-2.10207,2.46953c-1.07915.16583-1.847-.851-2.83694-.62815-.85454.19235-1.93086,1.79173-2.49843,2.4031a37.263,37.263,0,0,0-4.7082,6.0395c-1.64663,2.7328-2.85136,5.87294-5.34687,7.861-1.58862,1.26555-3.70978,2.08888-4.53938,3.94283-1.23444,2.75872,1.15733,5.83734.98046,8.85447-.301,5.13739-7.27489,7.088-9.41366,11.76869-1.328,2.90637-.53334,6.31917.5696,9.3182s2.51841,6.02027,2.37763,9.21258a10.04981,10.04981,0,0,1-8.44435,9.21708c-2.1576.28542-4.70864-.0207-6.14993,1.61011-1.89425,2.14329-.15405,5.51958-.6613,8.33464-.47109,2.6148-2.94811,4.49591-5.53621,5.09655a13.71076,13.71076,0,0,1-4.038.2548,11.50161,11.50161,0,0,1-1.52119,1.67394c2.62294.42362,5.3256.84527,7.91369.24461s5.06512-2.48176,5.53621-5.09656c.50725-2.81506-1.23294-6.19134.66131-8.33464,1.44129-1.6308,3.99233-1.32469,6.14993-1.61011a10.04978,10.04978,0,0,0,8.44434-9.21707c.14079-3.19232-1.27468-6.21356-2.37762-9.21259s-1.89761-6.41183-.5696-9.3182c2.13876-4.68069,9.11263-6.6313,9.41366-11.76869.17686-3.01713-2.21491-6.09574-.98047-8.85447.8296-1.85394,2.95077-2.67728,4.53939-3.94283,2.4955-1.988,3.70023-5.12815,5.34686-7.861a37.263,37.263,0,0,1,4.70821-6.0395c.56756-.61136,1.64389-2.21075,2.49842-2.40309.98993-.22283,1.75779.794,2.837.62814a2.56289,2.56289,0,0,0,2.10206-2.46953C436.09717,541.551,434.89164,540.25111,435.208,538.871Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M669.62106,494.15611s.32685-.97938-.12918-1.48613c-.458-.50678-.94726-1.04391-.94726-1.04391l-4.82636-6.99037s-1.1743-1.39313-.97858-2.215-1.10971-1.7082-1.10971-1.7082.70849-.87688.29358-1.40073a5.72844,5.72844,0,0,1-1.07644-1.61331c0-.26178-2.50573-3.97869-5.76829-4.88416.03352-.02428.06655-.04993.10034-.07343a5.195,5.195,0,0,0-.57148-.0949,16.314,16.314,0,0,1-5.50942-1.2508c-.03593.03684-.07329.07595-.11093.11555-.09221-.03747-.18443-.075-.2805-.11555-.57149-.24293-1.21539-.5409-1.97869-.91673-.73548-.36044-1.58245-.791-2.58181-1.31069a6.915,6.915,0,0,1-1.26009-2.324c-.03407-.10547-.06564-.21515-.09618-.32636a7.16838,7.16838,0,0,0,3.65235-6.20846,7.00413,7.00413,0,0,0-.961-3.54927c-.04018-.06885-.08477-.13484-.1272-.20226.01384-.01661.02864-.03209.04183-.04949a1.5549,1.5549,0,0,0,.11714-.18016,2.72,2.72,0,0,0,.17435-.39281c.02478-.06747.04821-.13545.07148-.2031l.28356-.82452.28355-.82451a5.4108,5.4108,0,0,0,.34706-1.54505,2.05735,2.05735,0,0,0-.08072-.66252,1.59568,1.59568,0,0,0-.12977-.30727,1.55789,1.55789,0,0,0-.09134-.14547c-.47771-.6755-1.50448-.95795-1.72306-1.74913a1.46936,1.46936,0,0,1-.04505-.38381c-.001-.13851.00756-.27831.00949-.41763.00054-.03429.00015-.06848-.0005-.10266-.00044-.02145-.00081-.04288-.00189-.06427a1.53835,1.53835,0,0,0-.01643-.17008,1.304,1.304,0,0,0-.04566-.18528l-.01458-.04322a1.376,1.376,0,0,0-.07047-.16651l-.00212-.00459a1.50056,1.50056,0,0,0-.10218-.16788l-.0164-.02282a2.76661,2.76661,0,0,0-1.44533-.92234,5.67818,5.67818,0,0,0-3.90257.25266,1.28606,1.28606,0,0,1-.54937.16253c-.31015-.00945-.5484-.25523-.81655-.40662-.8636-.48763-1.94484.02924-2.77411.57a4.23257,4.23257,0,0,0-1.1045.92766c-.27236.35956-.42568.79118-.67722,1.16471-.7972,1.18384-2.38469,1.56451-3.53562,2.43249a5.745,5.745,0,0,0-2.11,3.97015,11.02209,11.02209,0,0,0,.59767,4.51972,4.93009,4.93009,0,0,0,.1746.48,15.497,15.497,0,0,0,.77847,5.03391c.19571.72758-2.3486,3.03743-2.3486,3.03743l-7.83,6.75764s-.03143-.19432-1.03436-.12314-2.88681,2.34878-2.88681,2.34878l.151.013c-.09544.10978-.151.17678-.151.17678l.40831.03517c-1.21465,1.04821-2.64819,2.30736-3.39192,3.03955-.2062.19721-.37784.3682-.49851.49984-1.04382,1.13881-.35881,4.27052-.35881,4.27052s-.16309,1.92965,2.87051,2.1827c0,0,3.52289.69595,5.25171,0a20.61534,20.61534,0,0,1,5.01424-.8699s-1.34456,4.50776-1.24671,5.83637a41.70185,41.70185,0,0,1-.89834,6.05084l-3.00032,15.77623s-2.80951,5.48216,5.65435,6.29261l-.006.14731-.00392.1082s.21673.03215.539.06818c-.01472.17908-.03014.36858-.04576.56384a31.60078,31.60078,0,0,0-.16832,3.22661,1.48081,1.48081,0,0,0,.52256.60168l.32684,2.78436a21.40135,21.40135,0,0,0,.61847,3.09756,9.54468,9.54468,0,0,1,.914,3.16586,9.46369,9.46369,0,0,0,.48929,2.59268s.29358,1.93028.39144,2.40478,0,5.18725,0,5.18725a9.01885,9.01885,0,0,0,1.92541.68995l.05841.23627c.30924,1.25461.74176,3.00076.97662,3.908.39143,1.51841,1.23889,4.17562,1.23889,4.17562s.09786,3.44866.685,4.113.456,7.18017,2.93575,11.166A80.7104,80.7104,0,0,1,641.131,580.7995c-.04027,1.28032-.10013,2.67537-.18869,3.86677a2.78976,2.78976,0,0,0-.6787,1.228,13.98793,13.98793,0,0,1-2.11961,3.82638,13.007,13.007,0,0,1-2.64217,1.77273,1.37776,1.37776,0,0,0-.39339.2031c-.80635.57321-1.75166,2.08211.16441,2.67429a6.91739,6.91739,0,0,0,2.91592.03992,3.76688,3.76688,0,0,0-.0115.594s-.97858,2.40289-1.40328,3.32152c-.15461.334-.503.81615-.81223,1.3267-.54017.89208-.957,1.86765-.00391,2.27951.29358.12527,5.35088-.0949,7.04578.44225,1.69686.53712,2.90442-1.23371,2.90442-1.23371a9.308,9.308,0,0,1,.52062-2.56231,3.97632,3.97632,0,0,0-.11156-2.12765v-.0038c-.135-.5618-.27988-1.00025-.27988-1.00025a30.37291,30.37291,0,0,1-.41426-4.57223l2.49584-1.81825a2.24708,2.24708,0,0,0,.87512-2.35754c-.02656-.10767-.05444-.21923-.08359-.334a19.48921,19.48921,0,0,0-1.638-4.61995,4.24233,4.24233,0,0,1,.42845-1.07027c.78286-1.1388,2.21941-8.19368,2.57758-9.26985a10.29315,10.29315,0,0,0,.26135-1.13651c.44955-2.22126,1.13359-7.62935.02474-10.132l-.55582-6.10587a38.48205,38.48205,0,0,1,.03327-6.48362,29.89125,29.89125,0,0,0,.37381-3.52266l.00473-.08341,3.38081.16506V528.32021l.29357-5.546.02993-.56038.00138.00046a3.67414,3.67414,0,0,0,.458.12717,2.75271,2.75271,0,0,0,.77375-2.42526,10.00309,10.00309,0,0,0-.11355-1.634,3.95767,3.95767,0,0,0,1.09091-1.92085l7.0796-6.39676s.00978-.019.0274-.05692c.16049-.32078.96292-1.93788,1.2702-2.79008.28444-.78812.09657-5.0252.02464-6.44018.46267.04071,1.02477.08471,1.55871.11223a6.30025,6.30025,0,0,0,1.79275-.05315c.58715-.25245,1.33675-2.02518,1.92389-3.09946C670.59964,496.56089,669.62106,494.15611,669.62106,494.15611Zm-37.02231-24.8s.1659-1.57355.18416-3.51731l1.05337-.34714q.23735.22277.494.42519c.02641.14279.05205.28853.07562.43915a10.3227,10.3227,0,0,1-.042,3.841,5.152,5.152,0,0,0-1.77429,1.97451,1.47175,1.47175,0,0,1-1.20366.8598,3.71705,3.71705,0,0,1-.82592.06643s-.51227.08371-1.28531.21786Zm6.97442,75.5369c-.04278-.11946-.08179-.22742-.11622-.32218.03021-.01838.06012-.03436.09037-.05306V543.789h.00392C639.55505,544.08017,639.56172,544.46084,639.57317,544.893Z"
          transform="translate(-68.27659 -52.19946)"
          fill="url(#ebe06cb1-039b-4158-a251-2e122d9c2c67)"
        />
        <path
          d="M651.27534,474.97514s-3.53542,4.51527-6.36716,8.07338c-1.8254,2.29076-3.3576,4.18426-3.46921,4.22209a1.63761,1.63761,0,0,1-.34428-.01515c-1.42437-.12673-6.83816-.88148-9.301-1.22955-.75475-.10592-1.23144-.174-1.23144-.174s.07755-2.12806.40481-4.71011c.38777-3.09846,1.135-6.84575,2.52718-8.342a4.266,4.266,0,0,0,.89473-1.52465,9.65563,9.65563,0,0,0,.22133-4.46041,16.79525,16.79525,0,0,0-.64315-2.71634s8.98514-5.29651,8.51224-.47291a9.19561,9.19561,0,0,0,.32725,3.67539,6.21821,6.21821,0,0,0,2.03726,3.13441l.03784.02648Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#bb7683"
        />
        <path
          d="M642.8066,467.30087a7.19432,7.19432,0,0,1-8.19634-.48614,16.79525,16.79525,0,0,0-.64315-2.71634s8.98514-5.29651,8.51224-.47291A9.19561,9.19561,0,0,0,642.8066,467.30087Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M646.24366,460.78807a7.18378,7.18378,0,1,1-.92879-3.5373A7.18735,7.18735,0,0,1,646.24366,460.78807Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#bb7683"
        />
        <path
          d="M645.31487,457.25077a1.32539,1.32539,0,0,1-.08323.12672,2.39386,2.39386,0,0,1-2.1867.681,2.77271,2.77271,0,0,1-2.38532-1.26929c-.37076-.78881-.2686-1.63246-1.28818-1.74974-.88527-.10213-2.07132-.72069-2.9301-.367a2.0837,2.0837,0,0,0-1.01769,1.84621,5.60792,5.60792,0,0,1-.34428,2.17535c-.32346.61856-.95715,1.02905-1.28629,1.64572a3.91452,3.91452,0,0,0-.19484,2.31722,4.18664,4.18664,0,0,1-.14564,2.32477,1.68638,1.68638,0,0,1-.10216.17972,7.189,7.189,0,1,1,11.96443-7.9107Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M640.65983,456.41139a2.77163,2.77163,0,0,0,2.38422,1.26878,2.39892,2.39892,0,0,0,2.1883-.68032,2.741,2.741,0,0,0,.35082-.77343l.54811-1.6435a3.04944,3.04944,0,0,0,.04372-2.65134c-.46171-.67321-1.45408-.95471-1.66535-1.74322a10.77855,10.77855,0,0,1-.05256-1.13462,2.15938,2.15938,0,0,0-1.63991-1.50754,5.33446,5.33446,0,0,0-3.77185.25181,1.21591,1.21591,0,0,1-.531.162c-.29975-.00944-.53-.25438-.7892-.40528-.83467-.486-1.8797.02914-2.6812.56808a4.12471,4.12471,0,0,0-1.06751.92455c-.26322.35834-.41141.78848-.65453,1.16076-.77049,1.17985-2.30482,1.55926-3.41721,2.4243a5.78028,5.78028,0,0,0-2.03931,3.95677,11.30294,11.30294,0,0,0,.57766,4.50449,3.15355,3.15355,0,0,0,.34508.819c.45241.689,1.35411.98262,1.79476,1.6792.35444.5603.38708,1.34423.92524,1.73144a1.41471,1.41471,0,0,0,1.94412-.719,4.19584,4.19584,0,0,0,.14643-2.32593,3.909,3.909,0,0,1,.195-2.31748c.32772-.61682.963-1.02661,1.28595-1.64592a5.62912,5.62912,0,0,0,.34485-2.17466,2.07824,2.07824,0,0,1,1.01758-1.84541c.85762-.35487,2.04476.264,2.92895.36611C640.39064,454.77874,640.28842,455.62188,640.65983,456.41139Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#663d5c"
        />
        <g opacity="0.1">
          <path
            d="M630.20458,462.64609c-.44066-.69659-1.34237-.99019-1.79477-1.6792l-.00977-.017c.01433.04794.02835.096.043.14384a3.1537,3.1537,0,0,0,.34508.819c.4524.689,1.35411.98261,1.79477,1.67919.02574.04071.0494.08288.07208.12569A7.19805,7.19805,0,0,0,630.20458,462.64609Z"
            transform="translate(-68.27659 -52.19946)"
          />
          <path
            d="M644.13133,449.24256a1.30405,1.30405,0,0,0,.33478.56333,5.10136,5.10136,0,0,0-.009-.75214,1.45591,1.45591,0,0,0-.36141-.74016A4.05071,4.05071,0,0,0,644.13133,449.24256Z"
            transform="translate(-68.27659 -52.19946)"
          />
          <path
            d="M638.99266,453.71523c-.88418-.10206-2.07132-.721-2.92894-.36611a2.07828,2.07828,0,0,0-1.01759,1.84541,5.62881,5.62881,0,0,1-.34485,2.17466c-.323.61932-.95822,1.02911-1.28594,1.64592a3.90906,3.90906,0,0,0-.195,2.3175,4.19582,4.19582,0,0,1-.14643,2.32592,1.41471,1.41471,0,0,1-1.94412.719,1.27684,1.27684,0,0,1-.37523-.449c.213.50518.31685,1.08058.75355,1.39478a1.41471,1.41471,0,0,0,1.94412-.719,4.19567,4.19567,0,0,0,.14643-2.32593,3.90907,3.90907,0,0,1,.195-2.3175c.32772-.6168.963-1.0266,1.28595-1.64592a5.629,5.629,0,0,0,.34485-2.17466,2.07824,2.07824,0,0,1,1.01758-1.8454c.85762-.35486,2.04476.264,2.92895.3661a1.0077,1.0077,0,0,1,.7506.38858C639.91185,454.40279,639.83351,453.8123,638.99266,453.71523Z"
            transform="translate(-68.27659 -52.19946)"
          />
          <path
            d="M646.175,451.93159c-.03-.04373-.06241-.08566-.09651-.12633a4.70171,4.70171,0,0,1-.32553,1.83188l-.54812,1.64347a2.74109,2.74109,0,0,1-.35081.77345,2.399,2.399,0,0,1-2.1883.68031,2.968,2.968,0,0,1-2.26661-1.06315,5.53246,5.53246,0,0,0,.26071.74018,2.77164,2.77164,0,0,0,2.38422,1.26877,2.399,2.399,0,0,0,2.18831-.6803,2.74191,2.74191,0,0,0,.35081-.77345l.54812-1.64348A3.04953,3.04953,0,0,0,646.175,451.93159Z"
            transform="translate(-68.27659 -52.19946)"
          />
        </g>
        <rect
          x="629.58397"
          y="456.38079"
          width="4.73606"
          height="10.00774"
          rx="0.55841"
          transform="translate(-183.12147 175.66101) rotate(-18.76846)"
          fill="#464a5f"
        />
        <rect
          x="629.41482"
          y="456.38079"
          width="4.73606"
          height="10.00774"
          rx="0.55841"
          transform="translate(-183.13047 175.60659) rotate(-18.76846)"
          fill="#9c9ca1"
        />
        <circle cx="562.76202" cy="407.24219" r="0.74424" fill="#939498" />
        <path
          d="M630.53068,545.28s.91428,3.84627,1.2926,5.35956,1.198,4.16154,1.198,4.16154.09458,3.43643.66207,4.09849.44137,7.15659,2.83741,11.129S642.0695,582.923,642.0695,582.923l.40985,3.02658,4.03544-4.6975L643.17294,564.07s-1.95466-6.96743-1.35565-9.14278-2.49062-10.62454-2.49062-10.62454Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#bb7683"
        />
        <path
          d="M646.63916,580.75144l-4.03481,4.69876-.41047-3.02658s-3.15143-8.92271-5.5481-12.89509-2.26993-10.46629-2.83741-11.12835-.66207-4.09911-.66207-4.09911-.81907-2.64825-1.19739-4.16154c-.227-.90419-.645-2.64446-.94391-3.89484-.2024-.84365-.34994-1.4641-.34994-1.4641l8.796-.97795s.09836.2667.25347.71693c.72828,2.08645,2.73149,8.11877,2.23778,9.90823-.59964,2.17535,1.35628,9.14216,1.35628,9.14216Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.05"
        />
        <path
          d="M647.864,589.10176l-3.52514,2.64812c-1.70245,1.82919-6.71522,3.34248-8.89057,2.64825-1.85189-.59018-.93824-2.094-.1589-2.66527a1.31706,1.31706,0,0,1,.38022-.20242,12.5617,12.5617,0,0,0,2.55367-1.76675,14.05879,14.05879,0,0,0,2.04862-3.81349c.28374-1.41871,2.30208-2.58582,2.30208-2.58582s2.71068-2.64825,3.94023-2.11294c.80393.35184,1.63434,3.22142,2.11482,5.16787q.04224.17154.08078.33283A2.27551,2.27551,0,0,1,647.864,589.10176Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#575988"
        />
        <path
          d="M647.864,589.10176l-3.52514,2.64812c-1.70245,1.82919-6.71522,3.34248-8.89057,2.64825-1.85189-.59018-.93824-2.094-.1589-2.66527.75286,1.17468,3.50137.96282,3.50137.96282l4.886-2.17535,4.95224-4.101q.04224.17154.08078.33283A2.27551,2.27551,0,0,1,647.864,589.10176Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M642.34434,582.69663s-3.15143-8.92271-5.54809-12.89509-2.26994-10.4663-2.83742-11.12836-.66206-4.0991-.66206-4.0991-.81907-2.64826-1.19739-4.16154c-.227-.9042-.645-2.64447-.94392-3.89484-.2024-.84366-.34994-1.46411-.34994-1.46411l8.25061-.91731-.02211-.06064-8.796.97795s.14754.62045.34994,1.46411c.29888,1.25037.71692,2.99064.94391,3.89484.37832,1.51328,1.19739,4.16154,1.19739,4.16154s.09459,3.437.66207,4.0991.44075,7.156,2.83741,11.12836,5.5481,12.89509,5.5481,12.89509l.41047,3.02657.49009-.57071Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.05"
        />
        <rect
          x="585.07952"
          y="436.56984"
          width="9.83637"
          height="11.36139"
          fill="#caa8b1"
        />
        <path
          d="M663.90183,507.439c-.297.84933-1.07254,2.461-1.22765,2.78068-.017.03782-.02649.05673-.02649.05673l-7.06326,6.5809-.17025.15891-.0435-.14566c-.37266-1.25224-3.03226-10.175-3.35005-10.66111a7.306,7.306,0,0,1-.05108-2.75041c.02838-.27995.05108-.46154.05108-.46154l-.2251-6.17043,1.04038-2.01267,9.70585,3.072,1.36007,2.67284S664.23286,506.49314,663.90183,507.439Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#caa8b1"
        />
        <path
          d="M662.67418,510.21963c-.017.03782-.02649.05673-.02649.05673l-7.06326,6.5809-.21375.01325-2.41559.14566-1.75164-14.21167s.28753.261.7661.65449c1.39034,1.14633,4.40178,3.42192,6.70576,3.72081A5.4885,5.4885,0,0,1,662.67418,510.21963Z"
          transform="translate(-68.27659 -52.19946)"
          fill="none"
        />
        <path
          d="M662.67418,510.21963c-.017.03782-.02649.05673-.02649.05673l-7.06326,6.5809-.21375.01325-2.41559.14566-1.75164-14.21167s.28753.261.7661.65449c1.39034,1.14633,4.40178,3.42192,6.70576,3.72081A5.4885,5.4885,0,0,1,662.67418,510.21963Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M663.40528,506.636a4.557,4.557,0,0,1-2.10441-.7207,18.10049,18.10049,0,0,0-2.24629-1.50194l2.29358,2.53S663.0979,507.51083,663.40528,506.636Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M657.68316,508.24383s.14188,2.57732,1.70245,2.601S657.68316,508.24383,657.68316,508.24383Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M659.291,508.24383s1.18226,2.1517,1.74974,1.868S659.291,508.24383,659.291,508.24383Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M626.36914,487.27486l-1.64822.61052a19.374,19.374,0,0,0-4.84631.867c-1.67092.69359-5.07581,0-5.07581,0s5.927-7.72408,6.02162-7.7556,6.27384-2.30934,6.27384-2.30934Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#ff748e"
        />
        <path
          d="M626.78581,487.10819l-1.64823.61052a19.37389,19.37389,0,0,0-4.8463.867c-1.67092.69359-5.07582,0-5.07582,0s5.92705-7.72407,6.02163-7.7556,6.27384-2.30934,6.27384-2.30934Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.03"
        />
        <path
          d="M649.95121,571.50965c-.34617,1.07255-1.7346,8.10365-2.49125,9.23862s-1.63814,7.661-1.63814,7.661l-.17024.12109-.367.25723s-5.42136-.25347-4.79145-1.22955a2.85345,2.85345,0,0,0,.23835-.91363c.40858-2.65392.45587-9.71152.45587-9.71152l.06242-11.19267s1.42627-3.61107.44075-6.27258a13.89267,13.89267,0,0,1-.88149-4.91819s.157-2.58581-.53721-3.6262c-.56182-.84554-.66775-5.2965-.68855-6.93654-.00379-.37832-.00379-.6072-.00379-.6072l.8815-1.31468,9.64721.66206s-.0227.77748-.07946,1.7857a30.68439,30.68439,0,0,1-.36129,3.51081,39.54378,39.54378,0,0,0-.03216,6.46175l.53721,6.08531C651.43234,563.50248,650.29738,570.439,649.95121,571.50965Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#bb7683"
        />
        <path
          d="M639.57951,545.01957v.07186a11.30722,11.30722,0,0,1-8.69951,1.65326c-.2024-.84365-.34994-1.4641-.34994-1.4641l8.796-.97795S639.4244,544.56934,639.57951,545.01957Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.05"
        />
        <path
          d="M653.76658,520.59508l-.12673,2.44775-.28374,5.52728-13.7766,2.23966V544.7131a11.01741,11.01741,0,0,1-10.90891.8815s.09458-4.69686,0-5.16976-.37832-2.39668-.37832-2.39668a9.69045,9.69045,0,0,1-.4729-2.58394,9.7396,9.7396,0,0,0-.88338-3.1552,21.92008,21.92008,0,0,1-.59776-3.08712l-.31589-2.775a1.46016,1.46016,0,0,1-.50506-.59965c-.05486-.1797.05864-1.83675.16268-3.21574.07944-1.02337.15322-1.89161.15322-1.89161l12.86294-2.42692Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#575989"
        />
        <path
          d="M639.16034,532.48955v10.89a1.59422,1.59422,0,0,1-.65128-1.4414c-.05743-1.45088-.17183-4.886-.37738-6.43148a5.89818,5.89818,0,0,1,.78325-3.21763Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.05"
        />
        <path
          d="M631.28733,528.06632a3.59354,3.59354,0,0,0,2.67978,1.797C636.01635,530.24167,631.28733,528.06632,631.28733,528.06632Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M629.30114,530.90374s4.3507.72511,5.39108.69359"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M630.62526,534.088a11.54735,11.54735,0,0,0,3.85675-.599"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M630.12083,541.49675s6.30537-2.40676,7.062-3.66247"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M631.6026,544.58638c.22068-.03153,5.7694-3.37337,6.24231-4.25612"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M650.10822,542.72691s-.0227.77748-.07946,1.7857l-10.44546-.52588h-.00379v-.6072l.8815-1.31468Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M641.57016,530.24045s5.31544-1.31146,6.43433-.46657S641.57016,530.24045,641.57016,530.24045Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M636.26857,520.94126s1.07191,10.02653,1.95466,10.68809,4.63444-10.68809,4.63444-10.68809Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M636.45773,520.56294s1.07191,10.02653,1.95466,10.68809,4.63444-10.68809,4.63444-10.68809Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#575989"
        />
        <path
          d="M653.76658,520.59508l-.12673,2.44775a8.99328,8.99328,0,0,1-2.71068-1.56625,1.61923,1.61923,0,0,0-.13242-.10024,3.75536,3.75536,0,0,0-3.39921-.16081,6.52079,6.52079,0,0,0-.94581.41993s-13.93548.47291-13.93548.09459c0-.28-1.97107.14565-3.29708.51264a10.17853,10.17853,0,0,0-1.05173.33669l-.0019.00189a6.60838,6.60838,0,0,1-2.44018.03595l-.04539-.00568c.07944-1.02337.15322-1.89161.15322-1.89161l12.86294-2.42692Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M654.11275,522.23322a3.46568,3.46568,0,0,1-.44264-.12675,8.9373,8.9373,0,0,1-2.74094-1.5757,1.61923,1.61923,0,0,0-.13242-.10024,3.75539,3.75539,0,0,0-3.39921-.1608,6.51948,6.51948,0,0,0-.94581.41993s-13.93548.4729-13.93548.09458c0-.27995-1.97107.14566-3.29708.51264a10.18354,10.18354,0,0,0-1.05173.33669l-.0019.00189a6.60815,6.60815,0,0,1-2.44018.036c-.31211-.036-.52208-.0681-.52208-.0681l.00378-.10783.68855-17.48414,1.98619-15.57364.72637-6.526,2.35885-1.1482,2.37018-1.15387a6.14469,6.14469,0,0,0,.90419,1.00445,5.29616,5.29616,0,0,0,6.68306.61288,9.53227,9.53227,0,0,0,.98742-.67153c1.06876-.82287,2.07321.10784,2.99631,2.11481,3.60162,7.81993,5.95668,31.96631,5.95668,31.96631l3.56379,2.3002s.123.454.23834,1.10091C654.90534,519.38636,655.11341,521.57305,654.11275,522.23322Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M654.11275,522.61154a3.4664,3.4664,0,0,1-.44264-.12674,8.93761,8.93761,0,0,1-2.74094-1.57571,1.61682,1.61682,0,0,0-.13242-.10023,3.75536,3.75536,0,0,0-3.39921-.16081,6.52079,6.52079,0,0,0-.94581.41993s-13.93548.4729-13.93548.09458c0-.27995-1.97107.14566-3.29708.51264a10.18354,10.18354,0,0,0-1.05173.33669l-.0019.0019a6.60838,6.60838,0,0,1-2.44018.036c-.31211-.036-.52208-.0681-.52208-.0681l.00378-.10783.68855-17.48414L627.8818,488.816l.72637-6.52606,2.35885-1.14819,2.37018-1.15388a6.1442,6.1442,0,0,0,.90419,1.00445,5.29615,5.29615,0,0,0,6.68306.61288,9.53069,9.53069,0,0,0,.98742-.67153c1.06876-.82287,2.07321.10784,2.99631,2.11481,3.60162,7.81993,5.95668,31.96631,5.95668,31.96631l3.56379,2.3002s.123.454.23834,1.10091C654.90534,519.76468,655.11341,521.95137,654.11275,522.61154Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#fff"
        />
        <path
          d="M654.667,518.41594a8.28235,8.28235,0,0,1-3.87024,2.39292,17.01244,17.01244,0,0,1-3.1779.732s-.08323-.33668-.22131-.89283c-.51452-2.05994-1.80838-7.12-2.55368-9.00784a21.5893,21.5893,0,0,1-1.19928-5.16977,27.10735,27.10735,0,0,0-1.40168-7.43971c-.60909-1.77242-.95337-6.80412-1.14821-11.77527-.07755-1.95968-.13241-3.91184-.17024-5.65022-.07756-3.577-.08512-6.25178-.08512-6.25178l1.135-1.797a3.68559,3.68559,0,0,1,.51262-2.304,5.94636,5.94636,0,0,1,1.15767-1.44711c.44264.23645.85312.45588,1.23712.6564l6.39364,4.51338s-3.53542,4.51527-6.36716,8.07338c3.60162,7.81993,5.95668,31.96631,5.95668,31.96631l3.56379,2.3002S654.55161,517.769,654.667,518.41594Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M653.73443,506.408c-.18916,3.65649,2.1432,9.77206,2.1432,9.77206-.37833,4.3507-7.88046,5.17165-7.88046,5.17165s-1.82918-7.504-2.775-9.90068a21.58889,21.58889,0,0,1-1.19929-5.16976,27.10735,27.10735,0,0,0-1.40168-7.43971c-1.34115-3.90995-1.40357-23.67727-1.40357-23.67727l1.135-1.797a3.68544,3.68544,0,0,1,.51262-2.304,5.94619,5.94619,0,0,1,1.15766-1.44711c.96662.5183,1.78568.9477,2.49693,1.30711.73773.37455,1.36006.67153,1.91241.91363a15.36957,15.36957,0,0,0,5.32489,1.24659,4.88122,4.88122,0,0,1,.55234.09458c3.28952.75286,5.85643,4.67227,5.85643,4.94089a5.72933,5.72933,0,0,0,1.04039,1.60786c.401.52209-.28374,1.396-.28374,1.396s1.2617.88337,1.07254,1.70245.9458,2.2075.9458,2.2075l-7.06326,5.35894S653.92359,502.74964,653.73443,506.408Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#ff748e"
        />
        <circle cx="574.03725" cy="426.48796" r="0.39014" fill="#767d9f" />
        <circle cx="574.03725" cy="431.68885" r="0.39014" fill="#767d9f" />
        <circle cx="575.41017" cy="444.07187" r="0.39014" fill="#767d9f" />
        <circle cx="576.40327" cy="450.40876" r="0.39014" fill="#767d9f" />
        <circle cx="577.37272" cy="457.10033" r="0.39014" fill="#767d9f" />
        <circle cx="574.81754" cy="437.77851" r="0.39014" fill="#767d9f" />
        <path
          d="M646.51983,471.30163a8.936,8.936,0,0,1-1.98241,1.68732c-.35751,0-1.21819-.9912-1.67218-1.54732a5.94619,5.94619,0,0,1,1.15766-1.44711C644.98952,470.51282,645.80858,470.94222,646.51983,471.30163Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M646.51983,470.92331a8.936,8.936,0,0,1-1.98241,1.68732c-.35751,0-1.21819-.9912-1.67218-1.54732a5.94619,5.94619,0,0,1,1.15766-1.44711C644.98952,470.1345,645.80858,470.5639,646.51983,470.92331Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#ff748e"
        />
        <path
          d="M636.1103,477.05591s-.94959,2.27561-1.86891,3.93645a7.31918,7.31918,0,0,1-.99877,1.48678,10.29926,10.29926,0,0,0-1.449,3.54677c-.38022,1.38846-.6318,2.63124-.6318,2.63124-.53721.82095-.53721,11.0035-.53721,11.0035.91553,3.90994-.75665,15.00613-.75665,15.00613l-.49939,5.38543-.14943,1.623-.02838.30644c-.35373.01513-.69611.02649-1.02335.03025l-.0019.0019a23.48782,23.48782,0,0,1-2.43072-.08512c-.18159-.01512-.35751-.034-.52776-.05486l.68855-17.48414L627.8818,488.816l.72637-6.52606,2.35885-1.14819c.38777-3.09846,1.135-6.84575,2.52718-8.342a4.266,4.266,0,0,0,.89473-1.52465,6.97491,6.97491,0,0,1,.56371-.44641s.24212.46724.52965,1.02715c.30833.60152.66962,1.31087.84933,1.66839C636.67779,474.2185,636.1103,477.05591,636.1103,477.05591Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M635.732,476.86675s-1.8273,4.38285-2.86768,5.42323-2.08078,6.178-2.08078,6.178c-.53721.821-.53721,11.0035-.53721,11.0035.91554,3.90994-.75664,15.00613-.75664,15.00613l-.6772,7.31486c-12.50165.577-9.06459-6.33689-9.06459-6.33689l2.89983-15.72306a42.7667,42.7667,0,0,0,.86825-6.03045c-.09458-1.32413,1.205-5.8167,1.205-5.8167s-2.29263-11.91714-2.05618-12.46c.23645-.54479,8.2285-1.89161,8.2285-1.89161a3.48667,3.48667,0,0,0,.79826-.06621,1.42565,1.42565,0,0,0,1.16334-.8569,5.11037,5.11037,0,0,1,1.71948-1.97107s.24212.46725.52965,1.02716c.30833.60152.66962,1.31087.84933,1.66839C636.29947,474.02934,635.732,476.86675,635.732,476.86675Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#ff748e"
        />
        <path
          d="M635.104,472.045c-1.239,1.11793-2.57071,5.1376-2.57071,5.1376l-.84176-3.33678a1.42566,1.42566,0,0,0,1.16334-.85691,5.11031,5.11031,0,0,1,1.71948-1.97106S634.81644,471.48513,635.104,472.045Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M635.104,471.66672c-1.239,1.11792-2.57071,5.13759-2.57071,5.13759l-.84176-3.33678a1.42565,1.42565,0,0,0,1.16334-.8569,5.11037,5.11037,0,0,1,1.71948-1.97107S634.81644,471.10681,635.104,471.66672Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#ff748e"
        />
        <path
          d="M620.41845,516.02307s.16552,1.91526,4.09061.733S620.41845,516.02307,620.41845,516.02307Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M669.02431,497.99034c-.56748,1.07066-1.292,2.83742-1.85945,3.089a5.90825,5.90825,0,0,1-1.73271.053c-1.17469-.06244-2.49126-.21-2.49126-.21s2.96037-6.44281-1.07065-8.09229l-.00189-.00189h-3.65648l-2.33424-2.4364,6.14773-5.89615.91553.53721,4.66472,6.96681s.4729.53532.91553,1.04039c.44075.505.12485,1.48112.12485,1.48112S669.5918,496.91782,669.02431,497.99034Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#ff748e"
        />
        <path
          d="M646.87545,491.05382s1.77054-13.89575,7.0557-17.68655a4.8816,4.8816,0,0,0-.55234-.09458,15.36979,15.36979,0,0,1-5.32489-1.24658,13.83351,13.83351,0,0,0-3.7397,10.279c.38777,7.09354,0,8.74869,0,8.74869h.62061c1.12769,2.28448,5.914,11.77417,8.57163,13.76735l.28251-2.41395s-6.89855-7.96055-7.495-11.3534Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M647.63209,490.86466s1.77055-13.89575,7.05571-17.68655a4.88178,4.88178,0,0,0-.55235-.09458,15.36962,15.36962,0,0,1-5.32489-1.24659,13.83356,13.83356,0,0,0-3.7397,10.279c.38778,7.09354,0,8.74869,0,8.74869h.62061c1.1277,2.28448,5.914,11.77417,8.57164,13.76735l.2825-2.41395s-6.89854-7.96055-7.495-11.3534Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M645.07,490.36812s5.78821,11.994,8.81478,14.2639l.28252-2.41394s-8.11754-9.36723-7.50276-12.11006Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#6e6d84"
        />
        <path
          d="M654.30947,473.17811c-5.28515,3.7908-7.0557,17.68655-7.0557,17.68655h-2.56123s.38777-1.65515,0-8.74869a13.83356,13.83356,0,0,1,3.7397-10.279,15.36957,15.36957,0,0,0,5.32489,1.24659A4.88122,4.88122,0,0,1,654.30947,473.17811Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#6e6d84"
        />
        <polygon
          points="583.093 452.214 582.928 461.861 584.559 462.689 583.093 452.214"
          opacity="0.1"
        />
        <path
          d="M654.9643,484.05487c1.08735-.2601,3.87748-1.18226,3.97206-2.10442S654.9643,484.05487,654.9643,484.05487Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M655.12949,485.87554a24.71456,24.71456,0,0,0,3.996-1.98722C659.66935,483.32187,654.6093,484.74058,655.12949,485.87554Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M630.909,475.79484s-1.50714,2.97241-.599,3.28273S630.909,475.79484,630.909,475.79484Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M642.44782,508.24383s-12.1063,7.14871-9.55262,7.55856S642.44782,508.24383,642.44782,508.24383Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M649.699,523.36882s3.1842.599,3.0581,1.57635"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M664.63388,495.484l-.14187,3.68109s-.89851,1.55868-1.55112,1.75729a.853.853,0,0,1-.24212.01515l-.00757-.0019c-1.2844-.06809-6.13449-1.4868-6.56956-2.29263-.4729-.87392-7.63643-4.01778-7.63643-4.01778s-6.02856-9.1516-1.51329-11.37425,4.30342,8.63142,4.30342,8.63142a32.77961,32.77961,0,0,1,4.60229.94581c.43506.28374,4.45852.08511,5.6559.01891.21186-.01136.33482-.01891.33482-.01891l1.27684.23455Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#bb7683"
        />
        <path
          d="M664.63388,495.484l-.14187,3.68109s-.89851,1.55868-1.55112,1.75729a.853.853,0,0,1-.24212.01515l-.00757-.0019c-.08323-.00757-.12863-.01325-.12863-.01325s2.93957-6.39742-1.029-8.07527c.21186-.01136.33482-.01891.33482-.01891l1.27684.23455Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M665.62131,501.13233c-1.17469-.06244-2.49126-.21-2.49126-.21s2.96038-6.44281-1.07064-8.09229l-.0019-.00189,3.16845-.30834C669.17185,495.13591,666.43659,499.89142,665.62131,501.13233Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M665.43215,501.13233c-1.17469-.06244-2.49126-.21-2.49126-.21s2.96037-6.44281-1.07065-8.09229l-.00189-.00189,3.16845-.30834C668.98269,495.13591,666.24743,499.89142,665.43215,501.13233Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#ff748e"
        />
        <path
          d="M617.95519,477.7495l9.13907-8.1333s2.45909-2.30208,2.26993-3.02719-2.2384-7.12507,1.198-7.50339,2.30146,10.71912,2.30146,10.71912L623.05882,481.848Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#bb7683"
        />
        <path
          d="M612.2136,486.38785s-.66207-3.12115.34679-4.25612,5.58025-5.10734,5.58025-5.10734,2.29541,3.56253,6.368,3.04286l-4.57092,6.09992s-2.01772,2.64825-4.94971,2.396S612.2136,486.38785,612.2136,486.38785Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M612.02443,486.577s-.66206-3.12116.3468-4.25613,5.58025-5.10734,5.58025-5.10734,3.90933,3.94085,6.14773,4.41375l-4.3507,4.729s-2.01772,2.64825-4.94971,2.396S612.02443,486.577,612.02443,486.577Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#ff748e"
        />
        <path
          d="M619.81725,479.12085l-4.08053-.36249s1.82067-2.26993,2.79012-2.34087.99971.12274.99971.12274l-1.28685,1.14523Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M619.81725,478.93169l-4.08053-.36249s1.82067-2.26993,2.79012-2.34087.99971.12274.99971.12274l-1.28685,1.14523Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#ff748e"
        />
        <path
          d="M620.57941,479.90335s-1.05947,3.70226,2.58188,3.96236l1.15814-3.6093A6.41548,6.41548,0,0,1,620.57941,479.90335Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M620.76857,479.71419s-1.05947,3.70226,2.58188,3.96236l1.15814-3.6093A6.41548,6.41548,0,0,1,620.76857,479.71419Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#ff748e"
        />
        <path
          d="M650.22773,560.27913l-.53722-6.08532a39.54366,39.54366,0,0,1,.03216-6.46174,30.68434,30.68434,0,0,0,.36129-3.51082c.05676-1.00822.07946-1.78569.07946-1.78569l-9.64721-.66206-.025.03722,9.10468.62484s-.02269.77747-.07945,1.78569a30.68434,30.68434,0,0,1-.36129,3.51082,39.54366,39.54366,0,0,0-.03216,6.46174l.53721,6.08532c1.25982,2.932.12486,9.86851-.22131,10.93917-.34617,1.07255-1.73461,8.10365-2.49125,9.23862s-1.63814,7.661-1.63814,7.661l-.49222.34664c.32018.02214.52249.03168.52249.03168l.53721-.37832s.8815-6.52606,1.63814-7.661,2.14508-8.16607,2.49125-9.23862C650.35258,570.14764,651.48754,563.21113,650.22773,560.27913Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <polygon
          points="583.125 475.173 585.08 476.371 585.08 492.103 570.884 491.388 569.906 479.831 572.232 477.001 583.125 475.173"
          fill="#575989"
        />
        <path
          d="M641.02912,536.29482s5.99009,4.88666,7.81865,5.20193"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M645.82182,588.031a2.75636,2.75636,0,0,0-.17024.49941l-.367.25723s-5.42136-.25347-4.79145-1.22955a2.85345,2.85345,0,0,0,.23835-.91363c1.26738-.29508,3.41814,1.16523,3.41814,1.16523Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M646.23042,598.59184a9.53261,9.53261,0,0,0-.50318,2.55367s-1.16712,1.76487-2.80714,1.22955c-1.63814-.53534-6.52605-.31591-6.8098-.44076-.92121-.41047-.51829-1.38276.00378-2.27183.29888-.50883.63559-.9893.785-1.32223.41048-.91553,1.35628-3.31032,1.35628-3.31032a5.71269,5.71269,0,0,1,1.32413-3.6262l.62991-4.09912c1.06119-1.07066,3.94023.88339,3.94023.88339l1.67217.2213c-.85122,1.85947.03027,7.06139.03027,7.06139s.14.437.2705.99688v.00379A4.08127,4.08127,0,0,1,646.23042,598.59184Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#575988"
        />
        <path
          d="M646.23042,598.59184a9.53261,9.53261,0,0,0-.50318,2.55367s-1.16712,1.76487-2.80714,1.22955c-1.63814-.53534-6.52605-.31591-6.8098-.44076-.92121-.41047-.51829-1.38276.00378-2.27183,2.21887.123,7.18434.35565,8.289-.06241,1.41681-.53532,1.73461-2.38153,1.71947-3.12871A4.08127,4.08127,0,0,1,646.23042,598.59184Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <circle cx="575.18425" cy="540.28434" r="0.32487" fill="#605b89" />
        <circle cx="571.30292" cy="540.28434" r="0.32487" fill="#605b89" />
        <circle cx="575.18425" cy="542.04576" r="0.32487" fill="#605b89" />
        <circle cx="571.22076" cy="542.04576" r="0.32487" fill="#605b89" />
        <circle cx="574.20963" cy="546.03641" r="0.32487" fill="#605b89" />
        <circle cx="570.89589" cy="546.03641" r="0.32487" fill="#605b89" />
        <circle cx="574.3667" cy="545.14056" r="0.32487" fill="#605b89" />
        <circle cx="570.97805" cy="545.14056" r="0.32487" fill="#605b89" />
        <circle cx="574.53451" cy="544.10896" r="0.32487" fill="#605b89" />
        <circle cx="571.30292" cy="544.10896" r="0.32487" fill="#605b89" />
        <circle cx="574.85938" cy="543.07736" r="0.32487" fill="#605b89" />
        <circle cx="571.30292" cy="543.07736" r="0.32487" fill="#605b89" />
        <path
          d="M640.27247,590.0796a2.57986,2.57986,0,0,0,3.65712.4151"
          transform="translate(-68.27659 -52.19946)"
          fill="none"
          stroke="#000"
          stroke-miterlimit="10"
          opacity="0.1"
        />
        <path
          d="M639.57951,592.48381s4.20619,1.05468,3.88132,1.76141c0,0-3.69822-.53187-3.96348,0s3.63861,1.0316,3.63861,1.0316-3.209.49973-3.55645,0,3.23158,1.0316,3.23158,1.0316-3.23158-.32487-3.23158,0,3.06377,1.0316,3.06377,1.0316-2.86241-.30025-3.06377,0,2.85053.41379,2.90671.89586-3.31374-.32487-3.31374,0,4.28835-5.75207,4.28835-5.75207"
          transform="translate(-68.27659 -52.19946)"
          fill="none"
          stroke="#605b89"
          stroke-miterlimit="10"
          opacity="0.2"
        />
        <ellipse
          cx="758.00488"
          cy="762.9842"
          rx="20.48962"
          ry="2.81319"
          fill="#158cba"
          opacity="0.1"
        />
        <ellipse
          cx="836.48988"
          cy="770.94246"
          rx="20.48962"
          ry="2.81319"
          fill="#158cba"
          opacity="0.1"
        />
        <ellipse
          cx="928.93588"
          cy="760.17101"
          rx="20.48962"
          ry="2.81319"
          fill="#158cba"
          opacity="0.1"
        />
        <ellipse
          cx="805.07648"
          cy="793.60131"
          rx="14.56508"
          ry="1.99976"
          fill="#158cba"
          opacity="0.1"
        />
        <ellipse
          cx="886.53495"
          cy="791.60155"
          rx="14.56508"
          ry="1.99976"
          fill="#158cba"
          opacity="0.1"
        />
        <path
          d="M905.20728,822.51113S876.47183,728.30884,909.705,690.578c24.86148-28.22619,53.07911-24.84861,65.71794-21.35577a23.347,23.347,0,0,1,15.07515,12.525c4.417,9.53439,3.619,25.00664-27.57,43.06347-52.22355,30.23469-55.47191,71.71368-55.47191,71.71368Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M970.924,682.582s-84.7071,26.48658-65.71672,139.92913"
          transform="translate(-68.27659 -52.19946)"
          fill="none"
          stroke="#565987"
          stroke-miterlimit="10"
        />
        <path
          d="M921.44906,692.07719s11.66359,7.861,7.95572,19.6725"
          transform="translate(-68.27659 -52.19946)"
          fill="none"
          stroke="#565987"
          stroke-miterlimit="10"
        />
        <path
          d="M962.4283,699.07364s-7.13114-7.25423-15.80937-3.2523"
          transform="translate(-68.27659 -52.19946)"
          fill="none"
          stroke="#565987"
          stroke-miterlimit="10"
        />
        <path
          d="M928.94526,735.55517s-12.52195-6.35452-15.75895,1.60405"
          transform="translate(-68.27659 -52.19946)"
          fill="none"
          stroke="#565987"
          stroke-miterlimit="10"
        />
        <path
          d="M897.961,748.79846s9.40163-.74962,9.57335,3.7481"
          transform="translate(-68.27659 -52.19946)"
          fill="none"
          stroke="#565987"
          stroke-miterlimit="10"
        />
        <path
          d="M904.04519,823.26075S937.7,754.79543,946.94528,756.29467c4.39152.71214,6.41518,5.03245,7.32962,9.37249a27.55371,27.55371,0,0,1-1.83306,16.66542C947.66741,793.28746,934.83961,814.09322,904.04519,823.26075Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M946.6954,769.28809s-35.32572,51.22406-42.15046,53.47292"
          transform="translate(-68.27659 -52.19946)"
          fill="none"
          stroke="#565987"
          stroke-miterlimit="10"
        />
        <line
          x1="881.66717"
          y1="725.08457"
          x2="873.42135"
          y2="725.08457"
          fill="none"
          stroke="#565987"
          stroke-miterlimit="10"
        />
        <line
          x1="871.79126"
          y1="743.82508"
          x2="858.86677"
          y2="744.37791"
          fill="none"
          stroke="#565987"
          stroke-miterlimit="10"
        />
        <line
          x1="863.92615"
          y1="728.83267"
          x2="865.32901"
          y2="735.56498"
          fill="none"
          stroke="#565987"
          stroke-miterlimit="10"
        />
        <line
          x1="850.18311"
          y1="749.3223"
          x2="850.43299"
          y2="755.44026"
          fill="none"
          stroke="#565987"
          stroke-miterlimit="10"
        />
        <path
          d="M905.04469,823.26075s-33.65477-68.46532-42.90008-66.96608c-4.39153.71214-6.41519,5.03245-7.32962,9.37249a27.55363,27.55363,0,0,0,1.83305,16.66542C861.42247,793.28746,874.25027,814.09322,905.04469,823.26075Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M862.39448,769.28809s35.32572,51.22406,42.15046,53.47292"
          transform="translate(-68.27659 -52.19946)"
          fill="none"
          stroke="#565987"
          stroke-miterlimit="10"
        />
        <line
          x1="790.86954"
          y1="725.08457"
          x2="799.11536"
          y2="725.08457"
          fill="none"
          stroke="#565987"
          stroke-miterlimit="10"
        />
        <line
          x1="800.74545"
          y1="743.82508"
          x2="813.66994"
          y2="744.37791"
          fill="none"
          stroke="#565987"
          stroke-miterlimit="10"
        />
        <line
          x1="808.61055"
          y1="728.83267"
          x2="807.2077"
          y2="735.56498"
          fill="none"
          stroke="#565987"
          stroke-miterlimit="10"
        />
        <line
          x1="822.3536"
          y1="749.3223"
          x2="822.10372"
          y2="755.44026"
          fill="none"
          stroke="#565987"
          stroke-miterlimit="10"
        />
        <path
          d="M962.83194,839.25033a5.83274,5.83274,0,0,0,1.91564-2.891,2.57032,2.57032,0,0,0-1.33859-2.94457c-1.2294-.47014-2.54313.38206-3.53915,1.24252s-2.13756,1.84273-3.44112,1.6605a5.23869,5.23869,0,0,0,1.62014-4.90306,2.04813,2.04813,0,0,0-.45058-.99567c-.68245-.7296-1.91962-.41627-2.73675.1585-2.59867,1.82789-3.32377,5.35779-3.33791,8.5349a16.146,16.146,0,0,1-.04781-3.51579,3.607,3.607,0,0,0-1.32029-3.11012,3.97744,3.97744,0,0,0-2.01371-.47332,4.1655,4.1655,0,0,0-3.26691.92852,3.2481,3.2481,0,0,0,.12818,4.01137,12.65932,12.65932,0,0,0,3.38136,2.70817,7.49743,7.49743,0,0,1,2.41641,2.30479,2.28114,2.28114,0,0,1,.17914.41176h7.32314A20.407,20.407,0,0,0,962.83194,839.25033Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M834.58978,811.67635a5.83275,5.83275,0,0,0,1.91565-2.891,2.57032,2.57032,0,0,0-1.3386-2.94457c-1.2294-.47014-2.54312.38206-3.53915,1.24252s-2.13755,1.84273-3.44111,1.6605a5.23868,5.23868,0,0,0,1.62013-4.90306,2.048,2.048,0,0,0-.45057-.99566c-.68245-.72961-1.91962-.41628-2.73675.15849-2.59867,1.82789-3.32378,5.35779-3.33792,8.5349a16.14658,16.14658,0,0,1-.0478-3.51579,3.607,3.607,0,0,0-1.32029-3.11012,3.97733,3.97733,0,0,0-2.01371-.47331,4.16549,4.16549,0,0,0-3.26692.92851,3.2481,3.2481,0,0,0,.12819,4.01137,12.65927,12.65927,0,0,0,3.38135,2.70817,7.49746,7.49746,0,0,1,2.41642,2.30479,2.28184,2.28184,0,0,1,.17914.41176H830.061A20.40637,20.40637,0,0,0,834.58978,811.67635Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M877.33036,839.25033a5.8328,5.8328,0,0,0,1.91564-2.891,2.57032,2.57032,0,0,0-1.33859-2.94457c-1.2294-.47014-2.54313.38206-3.53915,1.24252s-2.13756,1.84273-3.44112,1.6605a5.23869,5.23869,0,0,0,1.62014-4.90306,2.04813,2.04813,0,0,0-.45058-.99567c-.68245-.7296-1.91962-.41627-2.73675.1585-2.59867,1.82789-3.32378,5.35779-3.33791,8.5349a16.146,16.146,0,0,1-.04781-3.51579,3.607,3.607,0,0,0-1.32029-3.11012,3.97744,3.97744,0,0,0-2.01371-.47332,4.1655,4.1655,0,0,0-3.26691.92852,3.2481,3.2481,0,0,0,.12818,4.01137,12.65943,12.65943,0,0,0,3.38135,2.70817,7.49736,7.49736,0,0,1,2.41642,2.30479,2.28184,2.28184,0,0,1,.17914.41176h7.32314A20.407,20.407,0,0,0,877.33036,839.25033Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M998.54329,783.51132s2.74538,3.5901-1.26709,9.01045-7.321,9.996-5.98351,13.3749c0,0,6.0539-10.06637,10.9815-10.20716S1003.96365,789.56522,998.54329,783.51132Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M998.54329,783.51132a4.44676,4.44676,0,0,1,.561,1.12591c4.80775,5.64877,7.36908,10.92024,2.74757,11.05228-4.30479.123-9.46884,7.82065-10.70555,9.76465a4.17093,4.17093,0,0,0,.14642.44251s6.0539-10.06637,10.9815-10.20716S1003.96365,789.56522,998.54329,783.51132Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M1003.64687,788.08694c0,1.26352-.14182,2.28781-.31677,2.28781s-.31678-1.02429-.31678-2.28781.177-.66874.352-.66874S1003.64687,786.82342,1003.64687,788.08694Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#ffd037"
        />
        <path
          d="M1005.3982,789.59545c-1.10943.6047-2.07667.97038-2.1604.81677s.74777-.76835,1.85719-1.37305.67191-.16462.75564-.011S1006.50763,788.99075,1005.3982,789.59545Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#ffd037"
        />
        <path
          d="M984.04209,783.51132s-2.74537,3.5901,1.2671,9.01045,7.321,9.996,5.9835,13.3749c0,0-6.0539-10.06637-10.98149-10.20716S978.62174,789.56522,984.04209,783.51132Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#158cba"
        />
        <path
          d="M984.04209,783.51132a4.44657,4.44657,0,0,0-.561,1.12591c-4.80776,5.64877-7.36909,10.92024-2.74758,11.05228,4.30479.123,9.46885,7.82065,10.70556,9.76465a4.17327,4.17327,0,0,1-.14643.44251s-6.0539-10.06637-10.98149-10.20716S978.62174,789.56522,984.04209,783.51132Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M978.93851,788.08694c0,1.26352.14183,2.28781.31678,2.28781s.31677-1.02429.31677-2.28781-.177-.66874-.352-.66874S978.93851,786.82342,978.93851,788.08694Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#ffd037"
        />
        <path
          d="M977.18719,789.59545c1.10942.6047,2.07667.97038,2.16039.81677s-.74776-.76835-1.85719-1.37305-.67191-.16462-.75563-.011S976.07776,788.99075,977.18719,789.59545Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#ffd037"
        />
        <path
          d="M979.81279,805.4269s7.67572-.23641,9.989-1.88366,11.80719-3.61415,12.381-.97232,11.53518,13.13922,2.86933,13.20912-20.13557-1.34984-22.44438-2.75623S979.81279,805.4269,979.81279,805.4269Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#a8a8a8"
        />
        <path
          d="M1005.2068,814.86041c-8.66584.06992-20.13556-1.34983-22.44438-2.75622-1.75829-1.071-2.459-4.9142-2.69338-6.68729-.16236.007-.25625.01-.25625.01s.48616,6.19052,2.795,7.59691,13.77854,2.82615,22.44438,2.75623c2.50149-.02018,3.36555-.91017,3.3181-2.22832C1008.02274,814.3481,1007.06869,814.8454,1005.2068,814.86041Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.2"
        />
        <path
          d="M1020.99554,453.79936l-2.179,4.63325a3.96046,3.96046,0,0,1-.52826,1.03083,24.25935,24.25935,0,0,0-1.12255,2.91275l-2.33863,3.60424v.00184l-.15958.24579-.91711-.25312-.642-2.40284.03854-.697.00548-.088a14.39715,14.39715,0,0,1,1.76636-1.627s.25129.02934.73369-1.14273c.4824-1.17389.91711-1.42518.91711-1.42518l.25129-.84925,2.70732-4.31042s2.26893-3.25392,2.88706-1.81038C1023.0352,453.06567,1020.99554,453.79936,1020.99554,453.79936Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#ffd2c6"
        />
        <path
          d="M994.6359,458.66922a3.1705,3.1705,0,0,0-.2531.774c-.01469.06787-.02936.13939-.04586.21277-.15042.77221-.25314,1.74434-.30448,2.30745-.02569.2843-.03854.46589-.03854.46589s-5.47329-.36684-4.525-1.284a2.02594,2.02594,0,0,0,.50074-.90978q.04127-.1458.07153-.29714a5.07781,5.07781,0,0,0,.08623-.69333c.00365-.0587.00548-.11739.00732-.17609a7.27348,7.27348,0,0,0-.055-1.13355s1.781-.011,3.12183.14308C994.104,458.18315,994.80833,458.36107,994.6359,458.66922Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#d38884"
        />
        <path
          d="M1011.94182,486.709a.50352.50352,0,0,1-.07337.22194c-.25129.36685-1.67282,7.86332-1.67282,7.86332a4.24364,4.24364,0,0,1-.4127,1.97363,28.77617,28.77617,0,0,0-.66582,2.843,48.49544,48.49544,0,0,1-.41086,5.93738,6.16611,6.16611,0,0,0,.09538,2.52206,3.85436,3.85436,0,0,0,.72818,2.0525c.02017.02751.03853.055.055.07887.09171.13206.15226.20727.15226.20727a1.21971,1.21971,0,0,0,.321.39618c.02017.01652.04218.033.06419.04953a3.67463,3.67463,0,0,0,1.28579.54294c.01467.00366.02936.00549.044.00917.18343.04034.30265.05686.30265.05686l.11373.62-1.21426.25129-2.31479.15958s-2.72933.20727-2.10936-1.00882a2.12881,2.12881,0,0,0,.11189-.2568h.00183c.022-.0587.044-.11922.06238-.18159a6.2974,6.2974,0,0,0,.121-2.58808l-.52826-4.149a16.74479,16.74479,0,0,1,.686-8.14028,1.99022,1.99022,0,0,1,.16325-1.21426,8.16173,8.16173,0,0,0,0-2.77334s-.15958-2.45419-.36685-3.66845a7.39333,7.39333,0,0,1-.08253-1.54442,7.79466,7.79466,0,0,1,.08253-.90428l5.22754-.69333A3.99719,3.99719,0,0,1,1011.94182,486.709Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#ffd2c6"
        />
        <path
          d="M1011.86845,512.08365l-1.21426.25129-2.31479.15958s-2.72933.20727-2.10936-1.00882a2.12881,2.12881,0,0,0,.11189-.2568h.00183c.022-.0587.044-.11922.06238-.18159a4.23735,4.23735,0,0,1,1.383.27881,1.27186,1.27186,0,0,0,1.36284-.4824l.37784-.72085.055-.10455c.09171.13206.15226.20727.15226.20727a1.237,1.237,0,0,0,.38518.44571l-.06419.13389-.36685.77222s.46957.04769,1.11155.1504a.49848.49848,0,0,0,.60528-.33015c.01467.00366.02936.00549.044.00917.18343.04034.30265.05686.30265.05686Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M1012.99283,512.65593c-.09172.4127-2.64861.53926-2.64861.53926s-1.42153-.13756-1.8214.19443c-.4017.332-1.57192.25312-1.61777.25312s-.664-.02384-.90612-1.13354c-.23476-1.0822.3155-1.27113.343-1.2803h.00183a4.15649,4.15649,0,0,1,1.44537.28064,1.27186,1.27186,0,0,0,1.36284-.4824l.43285-.8254c.09171.13206.15226.20727.15226.20727a1.23688,1.23688,0,0,0,.38518.44571l-.431.90611s.46957.04769,1.11155.15041a.5321.5321,0,0,0,.6493-.50441.59629.59629,0,0,0,.00551-.06971s.39987.11556.89327.25313A.92184.92184,0,0,1,1012.99283,512.65593Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#626696"
        />
        <path
          d="M1017.80766,492.17315c-.06054.36684-.12288,1.31514-.12288,1.31514a7.52894,7.52894,0,0,1-.33567,2.68164l-.27514,1.07852a21.7722,21.7722,0,0,1-.7557,4.73779s-.5888,3.11818-.8951,4.46451a3.70711,3.70711,0,0,0,.15958,2.24876c.01466.03669.02384.055.02384.055.00551.02569.011.04953.01834.07521a1.05592,1.05592,0,0,0,.033.10822,1.63069,1.63069,0,0,0,.30079.51174,1.4375,1.4375,0,0,0,.16511.16876l.00916.00917a3.29887,3.29887,0,0,0,.974.59979h.00183l.00184.00183q.0798.033.15409.06053a4.35017,4.35017,0,0,0,.48605.15224h.00184c.03486.00917.055.01284.055.01284l-.12288.72085-1.61963-.41453-2.1699-.70435-1.06751-.61079s.011-.0587.033-.17058l.00367-.01835c.00916-.04769.01834-.10455.03117-.16875a23.01473,23.01473,0,0,0,.37418-5.543,19.23138,19.23138,0,0,1,.9923-6.54083,3.956,3.956,0,0,0,.18343-1.40685,9.57092,9.57092,0,0,1-.48973-2.90358s-.73369-1.49856-1.34083-3.08884a8.10076,8.10076,0,0,1-.43652-1.60677,5.59728,5.59728,0,0,1-.088-1.1739s4.923-4.49385,5.46414-.14307c.01834.14674.03486.288.05136.42553C1018.0828,491.08545,1017.86637,491.81914,1017.80766,492.17315Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#ffd2c6"
        />
        <path
          d="M1017.80766,510.45486l-.12288.72085-1.61963-.41453-2.1699-.70435-1.06751-.61079s.011-.0587.033-.17058l.00367-.01835c.00916-.04769.01834-.10455.03117-.16875l.15225-.01467.01283-.00184a2.01658,2.01658,0,0,1,.908.1229c.354.13206.81623.2843.91161.2201a1.1472,1.1472,0,0,1,.51908-.09171l.2256-.4934.033-.07521a1.63063,1.63063,0,0,0,.30079.51175,1.6,1.6,0,0,0,.17427.17792l-.00916.17426-.01285.24761a3.19265,3.19265,0,0,0,.77954.35952.452.452,0,0,0,.21643.00183h.00183l.00184.00183q.0798.033.15409.06053a4.35017,4.35017,0,0,0,.48605.15224h.00184C1017.78749,510.45119,1017.80766,510.45486,1017.80766,510.45486Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M1016.997,511.99194c-.45123-.13023-1.54261-.3375-1.71869-.17609a5.88767,5.88767,0,0,1-1.68931,0,.92017.92017,0,0,1-.77955-.45855,4.68575,4.68575,0,0,1-.06054-2.07084l.11191-.011.18709-.01835.01283-.00184a2.01658,2.01658,0,0,1,.908.1229c.354.13206.81623.28431.91161.2201a1.14735,1.14735,0,0,1,.51908-.09171l.25863-.5686a1.63069,1.63069,0,0,0,.30079.51174,1.60013,1.60013,0,0,0,.17427.17793l-.022.42187a3.19278,3.19278,0,0,0,.77954.35951.3149.3149,0,0,0,.37419-.11923.28489.28489,0,0,0,.02749-.06236l.00184.00183a2.66646,2.66646,0,0,0,.64014.21277h.00184a1.16963,1.16963,0,0,1,1.24728.89877C1019.41261,512.04513,1017.44816,512.12033,1016.997,511.99194Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#626696"
        />
        <path
          d="M1011.94182,486.709c-.10089.02935-.1926.05686-.27881.08438a4.06385,4.06385,0,0,1-.675.14306,28.18451,28.18451,0,0,1-4.58923.033,7.79466,7.79466,0,0,1,.08253-.90428l5.22754-.69333A3.99719,3.99719,0,0,1,1011.94182,486.709Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M1016.5017,485.43972s-1.91862.29714-3.47954.63831c-.52089.11372-1.00332.23295-1.35915.3485a4.06377,4.06377,0,0,1-.675.14307,30.394,30.394,0,0,1-4.82769.01835c-.84741-2.75134,1.03083-6.21436,1.03083-6.21436a3.50791,3.50791,0,0,1,.3907-1.12254l.00734-.02752.26779-.9813h7.12963l.088.42187.18161.85841,1.11885,5.31558Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#626696"
        />
        <path
          d="M1017.6059,487.107l-.0422.01835-.83456.37051a17.06977,17.06977,0,0,1-4.5507.50258,5.59728,5.59728,0,0,1-.088-1.1739s4.923-4.49385,5.46414-.14307C1017.57288,486.82823,1017.5894,486.96946,1017.6059,487.107Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M1017.738,486.68149l-.17426.077-.83456.3705a17.29881,17.29881,0,0,1-4.60206.50259c-.10824,0-.18893,0-.23479-.00184a1.07305,1.07305,0,0,1-.8254-.50075c0-.055-.04218-.32648-.07886-.55943-.03119-.18709-.05871-.3485-.05871-.3485a21.82445,21.82445,0,0,1-2.77334-1.4362c-.70067-.47689-.52459-3.86471-.38886-5.5687.0477-.587.08988-.974.08988-.974l7.21766.42187,1.0125.05869.57962.1284.15407.033a23.83935,23.83935,0,0,0,.62,3.27775c.20543.25129.0697,1.10054.04585,1.58294a2.99031,2.99031,0,0,1-.06786.61813,3.80621,3.80621,0,0,1,.22744,1.3243A2.6398,2.6398,0,0,0,1017.738,486.68149Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#626696"
        />
        <path
          d="M985.15848,484.7152c-1.86539-.06237-.48972-3.94358-.27513-4.46817s-.31916-1.79937-.31916-1.79937-.62912-3.69964-.62912-3.94358a9.8227,9.8227,0,0,0-.2128-1.49857,2.4985,2.4985,0,0,1,.244-1.46738,5.28276,5.28276,0,0,0,.18342-1.68014v-1.74252l.41453-.55026,1.06386,1.00515.29529.2788.5191,1.94795L986.259,473.587l-.09171,2.72014.642,3.76016S987.02387,484.77573,985.15848,484.7152Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#d38884"
        />
        <polygon
          points="917.463 416.833 915.873 416.175 915.873 415.916 916.288 415.366 917.351 416.371 917.463 416.833"
          opacity="0.1"
        />
        <path
          d="M985.00563,465.05783a7.389,7.389,0,0,0-.44109,1.55909,6.97653,6.97653,0,0,1-.41488,1.498l1.77308.73369Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#4c4981"
        />
        <path
          d="M985.00563,465.05783a7.389,7.389,0,0,0-.44109,1.55909,6.97653,6.97653,0,0,1-.41488,1.498l1.77308.73369Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.05"
        />
        <path
          d="M999.07657,503.66273l-.14672.31182s-.1596,1.03816-.1596,1.062c0,.022-.45856.71719-.45856.71719l-1.15373.24578-.48973-.05869a6.54272,6.54272,0,0,0-.13022-.84742c-.01836-.07887-.03667-.15958-.05871-.24211a6.39777,6.39777,0,0,0-.8052-1.82505,14.98627,14.98627,0,0,0-1.16108-2.38449,9.81663,9.81663,0,0,1-1.3445-3.729,19.515,19.515,0,0,0-.04769-2.63578c-.04951-.84008-.10452-1.54625-.10452-1.54625l2.90355-1.71867.33751.53376.00184.0055.20176.31732s-.00184.06053-.011.16141c0,.011-.00183.02385-.00183.03669a5.262,5.262,0,0,1-.25864,1.26928s-.21828,1.55909,0,1.83422a33.11742,33.11742,0,0,1,1.062,5.65308c.00551.05319.00918.10455.01286.15407a3.41935,3.41935,0,0,0,1.03083,1.9883l.00551.00551c.03119.033.06419.066.09719.09905A6.82839,6.82839,0,0,0,999.07657,503.66273Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#d38884"
        />
        <path
          d="M996.66823,505.94084l.48974.05869,1.15373-.24578s.45855-.69517.45855-.71718c0-.02385.15958-1.062.15958-1.062l.14674-.31182.01834-.03852a6.39811,6.39811,0,0,1-.79422-.653l-.0055-.0055c-.02751-.02568-.05319-.05136-.08071-.07887a1.43455,1.43455,0,0,1-.71351,1.46187c-.42554.21828-.77587.387-1.02166.50258Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M999.27833,503.80764l-.16506.35033s-.1596,1.03817-.1596,1.062c0,.022-.45856.71719-.45856.71719l-1.15373.24578-.66213-.07887c-.00734-.1339-.022-.32283-.05687-.5521-.02018-.1394-.04769-.29348-.08437-.45856.24578-.11372.642-.30264,1.14639-.56127a1.43449,1.43449,0,0,0,.71349-1.46187,6.78891,6.78891,0,0,0,.60347.53559C999.12243,503.69941,999.21962,503.76728,999.27833,503.80764Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#ceddf9"
        />
        <path
          d="M999.27833,503.80764l-.16506.35033s-.1596,1.03817-.1596,1.062c0,.022-.45856.71719-.45856.71719l-1.15373.24578-.66213-.07887c-.00734-.1339-.022-.32283-.05687-.5521a2.21156,2.21156,0,0,1,.42.05686s1.57559.3375,1.6508-.90977c.044-.708.19077-.985.30814-1.0932C999.12243,503.69941,999.21962,503.76728,999.27833,503.80764Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M999.16258,503.72547s-.39263-.08781-.46906,1.15794-1.6508.90947-1.6508.90947-.7719-.19107-.77954.12992a3.00092,3.00092,0,0,0,.20635.86362,2.701,2.701,0,0,0,.19106.91711c.14521.17578.0535.833.0535.833s.06114.48913,1.27631,0a3.5343,3.5343,0,0,0,1.98708-1.57437c.03057-.04586-.107-.18343.68019-.4662s3.04176-2.09408,2.866-2.98062a.7503.7503,0,0,0-.53329-.635.91876.91876,0,0,0-.70487.09446,5.89881,5.89881,0,0,1-.65721.30366,3.20916,3.20916,0,0,1-.93929.22389,3.52754,3.52754,0,0,0-.72878.14009A1.53929,1.53929,0,0,1,999.16258,503.72547Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#cc8294"
        />
        <path
          d="M990.24845,495.1611a2.15078,2.15078,0,0,0-.442.50991c-.44575.67867-.7117,1.627-1.01433,2.036a3.92188,3.92188,0,0,0-.49342,1.55909,33.2934,33.2934,0,0,1-1.92593,4.93039,16.08548,16.08548,0,0,0-.92811,2.38449,1.88263,1.88263,0,0,0-.277,1.32247c.00734.05137.01283.09171.0165.11923.00549.03118.00916.04769.00916.04769l-.00916.0165-.53009.90061-1.68564-.233-.87126-.59245a2.82581,2.82581,0,0,0,.18893-.35951,16.05749,16.05749,0,0,0,.79786-2.89623,19.94139,19.94139,0,0,0,.43474-2.61377,19.83211,19.83211,0,0,1,.13756-2.01765s1.3188-4.0573,1.73333-4.72312a1.8927,1.8927,0,0,0,.31916-.87126.68974.68974,0,0,0-.00918-.18893l.57046-.56677S990.98214,494.57782,990.24845,495.1611Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#d38884"
        />
        <path
          d="M985.19332,507.887s-.00551.05135-.00916.13573v.06419l-.53009.90061-1.68564-.233-.87126-.59245a2.82581,2.82581,0,0,0,.18893-.35951,3.44505,3.44505,0,0,1,1.394.22195s1.04735.19992,1.48757-.12107A.10084.10084,0,0,0,985.19332,507.887Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M984.78062,510.29345l-1.70949.41454-1.57008-1.15923.08069-.653a1.19582,1.19582,0,0,0,.288-.26229,1.04127,1.04127,0,0,0,.22744-.4714c.09171-.48056,1.58292.04586,1.58292.04586s1.08954.20727,1.51323-.13757a2.66964,2.66964,0,0,0,.08072.9428.70822.70822,0,0,0,.25129.376C985.96187,509.68632,984.78062,510.29345,984.78062,510.29345Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#ceddf9"
        />
        <path
          d="M984.78062,510.29345l-1.70949.41454-1.57008-1.15923.08069-.653a1.19582,1.19582,0,0,0,.288-.26229c.1137-.00184.23844,0,.343.00917.26414.02385.88227,1.14823.88227,1.14823,1.55174.10271,2.014-.40354,2.17906-.77771a.70822.70822,0,0,0,.25129.376C985.96187,509.68632,984.78062,510.29345,984.78062,510.29345Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M983.095,509.97338s-.61905-1.12346-.88272-1.14639a5.86353,5.86353,0,0,0-.66491,0,8.74294,8.74294,0,0,1-.94,1.7769,3.1684,3.1684,0,0,0-.61905.91712s1.81607,1.754,3.57339,1.42152a3.62876,3.62876,0,0,1,1.60829.40124c.81394.42416,4.20725.10317,4.62-.642.30952-.55887.432-.96542.15959-1.26343a.73114.73114,0,0,0-.63807-.21641,2.40821,2.40821,0,0,1-2.227-.9849,19.916,19.916,0,0,0-1.67373-1.42025C985.28458,508.81553,985.51386,510.13387,983.095,509.97338Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#cc8294"
        />
        <path
          d="M996.461,492.05209l-.01283.01468a5.80994,5.80994,0,0,1-1.07855.99415,10.6581,10.6581,0,0,0-1.10053.4879s-.45856.61263-.82541.642a1.42512,1.42512,0,0,0-.32282.08622c-.04951-.84008-.10452-1.54625-.10452-1.54625l2.90355-1.71867.33751.53376.00184.0055c.077.21644.16322.41454.19076.47873Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M985.89217,480.24631a3.1296,3.1296,0,0,0,0,3.42889,11.48718,11.48718,0,0,0,2.32335,2.93475l3.85187,7.97888a6.31218,6.31218,0,0,1,1.37567-.58084c.36684-.03057.8254-.642.8254-.642a10.86848,10.86848,0,0,1,1.10053-.48912,6.03286,6.03286,0,0,0,1.09193-1.00883s-.41938-.91711-.32767-1.16167-.27513-.856-.27513-.856a5.0652,5.0652,0,0,1-.24456-.94769,2.57213,2.57213,0,0,0-.39742-.8254,2.59512,2.59512,0,0,1-.39741-.94768,8.99911,8.99911,0,0,0-.58084-1.6508l-.15285-5.80837Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#ceddf9"
        />
        <path
          d="M996.461,491.86867a6.09162,6.09162,0,0,1-1.09138,1.00882,10.66029,10.66029,0,0,0-1.10053.4879s-.45856.61264-.82541.642a2.95454,2.95454,0,0,0-.752.26964c-.32833.15041-.62366.31182-.62366.31182L988.21612,486.61a8.40329,8.40329,0,0,1-.93543-.9593,13.16886,13.16886,0,0,1-1.38852-1.97545,3.30718,3.30718,0,0,1-.43838-2.379,2.7531,2.7531,0,0,1,.43838-1.04917l2.74032-.19259,5.45314-.38336.04586,1.71683.1064,4.09032s.08987.20544.19994.47507a5.20285,5.20285,0,0,1,.38149,1.17573,2.59327,2.59327,0,0,0,.39622.9483,2.57732,2.57732,0,0,1,.398.8254,5.0981,5.0981,0,0,0,.244.94829s.36685.6108.27514.85475C996.04094,490.95156,996.461,491.86867,996.461,491.86867Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.05"
        />
        <path
          d="M990.24845,495.1611a2.15078,2.15078,0,0,0-.442.50991,9.30943,9.30943,0,0,1-4.09767-.99047.68974.68974,0,0,0-.00918-.18893l.57046-.56677S990.98214,494.57782,990.24845,495.1611Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M995.155,482.05557s-.244.85475-.33568,1.22159-.27513,2.17173-.27513,2.17173l-.10636.50441-1.74618,8.32371-.3797,1.81038c-.67314.36684-2.35332-.61264-2.35332-.61264a9.36167,9.36167,0,0,1-4.37276-1.03817,6.2871,6.2871,0,0,0,.3063-1.92593,1.47085,1.47085,0,0,1,.55027-1.1629,14.48094,14.48094,0,0,1,.39617-3.11818s.12293-.94646.58148-1.19225c.45856-.24394-.06054-.61079-.18342-.8254a.94124.94124,0,0,1,.044-.56127,4.36861,4.36861,0,0,1,.1394-.41636,5.78847,5.78847,0,0,1-1.34633-3.99861,6.62066,6.62066,0,0,1,.033-.7392l2.52573-.442,5.51369-.9648.56128,1.73151v.00366l.14124.43471Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#ceddf9"
        />
        <path
          d="M994.6359,458.66922a3.1705,3.1705,0,0,0-.2531.774c-.01469.06787-.02936.13939-.04586.21277a2.32186,2.32186,0,0,1-1.54136.34768c-.23479,0-.36487-.44856-.5868-.49442,0,0-.333-1.20009-.42839-.18851-.64014-.13207-1.19261.36826-1.64566-.06829l-.00732-.00733c.00365-.0587.00548-.11739.00732-.17609a7.27348,7.27348,0,0,0-.055-1.13355s1.781-.011,3.12183.14308C994.104,458.18315,994.80833,458.36107,994.6359,458.66922Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M995.89787,456.61123a3.40662,3.40662,0,0,1-4.09216,3.33645h-.00184a3.40577,3.40577,0,1,1,4.094-3.33645Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#d38884"
        />
        <path
          d="M994.03246,461.96349c-.02569.2843-.03854.46589-.03854.46589s-5.47329-.36684-4.525-1.284a2.02594,2.02594,0,0,0,.50074-.90978l2.37347.38886s.67135.52092,1.19225,1.00882A2.09338,2.09338,0,0,0,994.03246,461.96349Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M994.8487,481.44294a1.77159,1.77159,0,0,1-.71721-.055,1.30891,1.30891,0,0,1-.29161-.12839c-.45856-.27514-1.98648.06236-1.98648.06236s-4.15817.27514-4.3416,0c-.10456-.15774-.83641-.13389-1.438-.0862-.244.02018-.46774.044-.62.06052a2.7531,2.7531,0,0,1,.43838-1.04917l2.74032-.19259,5.51369-.9648.56128,1.73151v.00366C994.77163,481.17882,994.8487,481.44294,994.8487,481.44294Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M992.34252,460.80854l-2.98389-.48913a.88551.88551,0,0,1-.56227.48913,7.31741,7.31741,0,0,0-2.96533,2.10936l-.79483,1.10053s-.642.79483-.428,1.43681a24.3311,24.3311,0,0,1,.45856,2.81248l.3057,2.41506a6.87109,6.87109,0,0,1,.39742,2.50677,25.70642,25.70642,0,0,0,.09171,3.97415l-.61141,3.97415s2.07879-.27513,2.26221,0,4.341,0,4.341,0,1.52852-.33627,1.98707-.06114a1.65476,1.65476,0,0,0,1.00883.18343,4.51833,4.51833,0,0,1-.15286-1.95651,7.733,7.733,0,0,0,.15286-1.98708,9.15256,9.15256,0,0,0,.15285-2.20106c-.15285-.33628.33627-1.55909.33627-1.55909l1.62023-8.52914s-.19614-1.52852-1.061-2.04822a18.373,18.373,0,0,1-2.36285-1.16168C993.01507,461.32824,992.34252,460.80854,992.34252,460.80854Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#4c4981"
        />
        <path
          d="M993.71819,469.2154v1.00882l.94318,2.53735.34078,2.35392a11.71989,11.71989,0,0,1,.61141,2.26221,19.37108,19.37108,0,0,0,1.49794,3.39331s.40832.94768.20416,1.1311-1.97724,4.21872.2544,4.09644,1.52852-4.341,1.52852-4.341l-.3057-1.83422s-.428-4.58556-.428-4.92184c0,0-.55027-1.9565-.61141-2.38449s-.45855-2.59848-.45855-2.59848l-.33628-1.40624Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#d38884"
        />
        <polygon
          points="924.379 420.195 921.055 422.098 920.023 423.657 921.399 422.259 924.379 420.195"
          opacity="0.1"
        />
        <path
          d="M991.64705,476.04024a6.6323,6.6323,0,0,1-2.224.9859c-.71076,0-2.36156,1.69665-2.36156,1.69665a21.70915,21.70915,0,0,1,2.52206-1.466A14.54608,14.54608,0,0,0,991.64705,476.04024Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M987.77225,476.56758s-1.42152,1.284-1.05468,1.42152,2.26985-1.42152,2.26985-1.42152Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M994.05447,471.982s-1.10054,1.49031-.80248,1.46738,1.14639-.87126,1.14639-.87126Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M994.215,473.44966s-1.19225,1.35248-1.14639,1.6964S994.215,473.44966,994.215,473.44966Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M994.513,474.12577s-.80247,1.433-.45855,1.73105S994.513,474.12577,994.513,474.12577Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M993.48127,470.44586s-.59612,1.00882-.16049,1.0776.47881,0,.47881,0Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M993.64177,466.75448a10.56746,10.56746,0,0,1-.61082,1.79938,8.26726,8.26726,0,0,1-.23843-.90244A6.26521,6.26521,0,0,1,993.64177,466.75448Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M995.4613,454.94391a1.48445,1.48445,0,0,1-.23111.35584,2.67578,2.67578,0,0,0-.41452.47507,2.58079,2.58079,0,0,0-.14856.81073c-.044.27146-.21647.57411-.4916.58328a1.07907,1.07907,0,0,1-.40352-.12107.4058.4058,0,0,0-.40169.01284.44432.44432,0,0,0-.12838.30266,4.06024,4.06024,0,0,0-.04037.71535c.00183.09537.00734.18892.0165.2843a1.60663,1.60663,0,0,1-.055.90977,1.0938,1.0938,0,0,1-.56494.45306,3.33116,3.33116,0,0,1-.79239.22194h-.00184a8.7,8.7,0,0,1-1.56276.05135.3965.3965,0,0,1-.13941-.022.21187.21187,0,0,1-.06052-.03852,5.15616,5.15616,0,0,0,.09355-.86942,3.40559,3.40559,0,1,1,5.32657-4.12517Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M994.03635,452.05216a2.98145,2.98145,0,0,0-.91411.20287,9.22345,9.22345,0,0,1-1.93353-.14656,3.56949,3.56949,0,0,0-1.58882.47408,3.82032,3.82032,0,0,0-1.061.74257,1.72624,1.72624,0,0,0-.50419,1.16568,1.90524,1.90524,0,0,1-.02285.75022,2.417,2.417,0,0,1-.23143.35347,1.0373,1.0373,0,0,0-.10828.87485,2.82222,2.82222,0,0,0,.52194.78077c.41791.53932.68093,1.18144,1.05615,1.75128a5.2307,5.2307,0,0,0,.55078.69878.367.367,0,0,0,.11768.09417.38.38,0,0,0,.13916.02143,5.56559,5.56559,0,0,0,2.3569-.2737,1.09374,1.09374,0,0,0,.56515-.4527,1.61712,1.61712,0,0,0,.05535-.91065,4.25207,4.25207,0,0,1,.02257-.99958.45576.45576,0,0,1,.1286-.30215.41122.41122,0,0,1,.40305-.0123,1.04814,1.04814,0,0,0,.40195.12032c.2762-.00955.44885-.31056.49292-.58339a2.55565,2.55565,0,0,1,.14866-.81022,2.6164,2.6164,0,0,1,.41448-.47442,1.9462,1.9462,0,0,0,.3445-1.72381A1.90484,1.90484,0,0,0,994.03635,452.05216Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#1e1637"
        />
        <circle cx="941.73563" cy="406.39272" r="2.95769" fill="#ffd2c6" />
        <path
          d="M1008.56776,459.82658s.20635,2.8009-.36684,3.44288a25.96382,25.96382,0,0,1-2.06351,1.85715l.45856,1.903,2.59084.29806,3.02647-3.23282-.68783-.84833a4.94182,4.94182,0,0,1-.09171-2.68255C1011.86936,459.66979,1008.56776,459.82658,1008.56776,459.82658Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#ffd2c6"
        />
        <path
          d="M1014.82705,465.98043v.00184l-.15958.24579-.91711-.25312-.642-2.40284.03854-.697.1889-.27147s1.00883.02385.96481.941A8.02717,8.02717,0,0,0,1014.82705,465.98043Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M1016.82085,479.25105s-.73.16324-1.56458.27146a4.50109,4.50109,0,0,1-2.19558-.066c-.664-.39252-4.2609-.28064-5.29357-.24028-.07337.00184-.132.0055-.17791.00733l.26779-.9813h7.12963l.088.42187,1.0125.05869.57962.1284C1016.76216,479.08964,1016.82085,479.25105,1016.82085,479.25105Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M1013.15332,462.788s1.00882.02293.963.94a8.464,8.464,0,0,0,.55026,2.49913l-.22927.52734s-.321,1.284-.06879,1.60495,1.16932.321.642,2.95768a9.43369,9.43369,0,0,0,.1608,2.61377c.27483.642.27483,2.17814.68753,2.82012a15.37582,15.37582,0,0,1,.963,2.13229s-2.98062.6649-3.76016.20635-5.57146-.22928-5.57146-.22928.02293-.80247,0-.89418a.76093.76093,0,0,1,.11464-.58466c.1605-.21782.4127-.58466.27514-.90565s.34391-.79314.09171-1.29075-.55977-.59586-.4977-.86773a1.17065,1.17065,0,0,0-.28185-.86773c-.18342-.22954-1.42152-2.65255-1.42152-2.65255l-.20635-1.1308s-1.59572-1.16931-1.56594-1.71958a3.23283,3.23283,0,0,1,.603-1.31259l1.53616-1.50753s.84833.91711,1.67373.59612a14.95857,14.95857,0,0,0,2.59868-1.85715s.63414-.34392.68-.59612.43563-.02293.43563-.02293.57319-.31443.68783-.20307a1.97761,1.97761,0,0,0,.619.20307Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#ffcde5"
        />
        <path
          d="M1004.48661,467.5646l-.48833.38213a6.492,6.492,0,0,0-.6122,2.49913,33.142,33.142,0,0,1-.61905,3.87153l-.963,1.72285a43.71453,43.71453,0,0,0-1.78837,4.20607,10.97327,10.97327,0,0,1-1.14639,2.37421s-3.187,2.86378-.963,3.38075,2.29277-2.28022,2.29277-2.28022a3.019,3.019,0,0,0,.60311-.963c.08473-.38978,2.90485-5.37657,2.90485-5.37657s.98589-1.34128.77954-2.052a21.40309,21.40309,0,0,0,1.284-3.77544,13.342,13.342,0,0,0-.20635-1.88773l.20635-1.582Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#ffd2c6"
        />
        <path
          d="M1011.08982,473.885a22.8043,22.8043,0,0,1-2.68255,1.2381c-.43563.062,1.903-.25221,1.903-.25221Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M1012.924,474.80214s-2.98061,1.00882-4.2875.8254C1008.63654,475.62754,1011.89229,476.24659,1012.924,474.80214Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M1013.10746,475.13123s-2.68295,1.68856-4.26477,1.41342c0,0,3.69158.73369,4.26477.34392l-1.6508-.45856S1013.29089,475.46032,1013.10746,475.13123Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M1010.01627,453.38813a2.77967,2.77967,0,0,0-2.25661.42744c-.45944.36129-.76481.91363-1.28311,1.18378a7.527,7.527,0,0,1-.83793.29473,2.41936,2.41936,0,0,0-1.47678,2.6032c.081.4538.29377.874.39878,1.32285a5.17086,5.17086,0,0,1-.1806,2.43384,25.64344,25.64344,0,0,1-2.54773,6.32046.659.659,0,0,0-.126.42405.59652.59652,0,0,0,.15587.27127,5.9887,5.9887,0,0,0,4.40265,1.70031,3.4057,3.4057,0,0,0,1.74521-.2894,2.64353,2.64353,0,0,0,.85079-.78147,4.14415,4.14415,0,0,0,.789-2.6637,7.45069,7.45069,0,0,1-.10783-2.29122.6119.6119,0,0,1,.13743-.28066c.17446-.17806.46423-.13124.71185-.16a1.56913,1.56913,0,0,0,1.18712-1.46081,16.428,16.428,0,0,0-.09163-2.02681,4.2461,4.2461,0,0,1,.79956-2.495,2.70212,2.70212,0,0,0,.58521-.9984,1.65579,1.65579,0,0,0-.42729-1.22079,5.996,5.996,0,0,0-1.13236-1.74247A3.05432,3.05432,0,0,0,1010.01627,453.38813Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M1009.83284,453.20471a2.77964,2.77964,0,0,0-2.25661.42744c-.45943.36129-.7648.91362-1.2831,1.18377a7.52646,7.52646,0,0,1-.83793.29474,2.41936,2.41936,0,0,0-1.47678,2.6032c.081.45379.29377.874.39878,1.32284a5.17089,5.17089,0,0,1-.1806,2.43385,25.64308,25.64308,0,0,1-2.54774,6.32046.659.659,0,0,0-.126.424.59643.59643,0,0,0,.15587.27126,5.98865,5.98865,0,0,0,4.40265,1.70032,3.40567,3.40567,0,0,0,1.7452-.2894,2.64357,2.64357,0,0,0,.8508-.78147,4.14422,4.14422,0,0,0,.789-2.6637,7.45069,7.45069,0,0,1-.10783-2.29122.61188.61188,0,0,1,.13742-.28066c.17447-.17807.46423-.13124.71186-.16a1.56918,1.56918,0,0,0,1.18712-1.46081,16.428,16.428,0,0,0-.09163-2.02681,4.246,4.246,0,0,1,.79956-2.495,2.70216,2.70216,0,0,0,.58521-.99841,1.6558,1.6558,0,0,0-.42729-1.22078,5.99576,5.99576,0,0,0-1.13236-1.74247A3.0543,3.0543,0,0,0,1009.83284,453.20471Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#985c7e"
        />
        <path
          d="M997.31081,466.55444a3.92151,3.92151,0,0,0,0,1.25278c-.03117.33565,0,2.20107,0,2.20107a10.59852,10.59852,0,0,0-3.57674.30631l-.3063-.91711a2.26054,2.26054,0,0,1-.38153-.75387,8.26644,8.26644,0,0,1-.23844-.90243,18.77111,18.77111,0,0,1-.30081-1.92044c-.12655-.97214,1.31879-2.01764,2.412-2.59909s2.05434,1.89474,2.05434,1.89474A3.04834,3.04834,0,0,1,997.31081,466.55444Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M997.31081,466.371a3.92151,3.92151,0,0,0,0,1.25278c-.03117.33565,0,2.20106,0,2.20106a10.59871,10.59871,0,0,0-3.57674.30632l-.3063-.91712a2.26038,2.26038,0,0,1-.38153-.75386,8.26644,8.26644,0,0,1-.23844-.90243,18.77111,18.77111,0,0,1-.30081-1.92044c-.12655-.97214,1.31879-2.01765,2.412-2.59909s2.05434,1.89474,2.05434,1.89474A3.04831,3.04831,0,0,1,997.31081,466.371Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#4c4981"
        />
        <path
          d="M1008.84269,481.87154s.58906,2.75134,1.56713,3.50031Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M995.37031,453.39317a2.11074,2.11074,0,0,0-.22634-.49095c.016.04187.03072.0834.04292.12411a1.94617,1.94617,0,0,1-.3445,1.72381,2.61585,2.61585,0,0,0-.41447.47441,2.55511,2.55511,0,0,0-.14867.81023c-.04407.27283-.21672.57384-.49291.58339a1.04787,1.04787,0,0,1-.40195-.12032.41131.41131,0,0,0-.40307.01229.45589.45589,0,0,0-.12859.30216,4.25206,4.25206,0,0,0-.02257.99958,1.61721,1.61721,0,0,1-.05535.91065,1.09378,1.09378,0,0,1-.56515.4527,5.56581,5.56581,0,0,1-2.35691.2737.37979.37979,0,0,1-.13913-.02143.36675.36675,0,0,1-.11769-.09417,5.23229,5.23229,0,0,1-.5508-.69878c-.37522-.56984-.63822-1.212-1.05614-1.75128-.11443-.1477-.24119-.29019-.34662-.44384l.0081.02991a2.82247,2.82247,0,0,0,.52195.78077c.41791.53932.68091,1.18144,1.05613,1.75128a5.23182,5.23182,0,0,0,.5508.69878.36688.36688,0,0,0,.11769.09418.38024.38024,0,0,0,.13913.02143,5.566,5.566,0,0,0,2.35691-.2737,1.0938,1.0938,0,0,0,.56515-.45271,1.61712,1.61712,0,0,0,.05535-.91065,4.25305,4.25305,0,0,1,.02257-.99957.45587.45587,0,0,1,.12859-.30216.41128.41128,0,0,1,.40307-.01229,1.04807,1.04807,0,0,0,.402.12031c.27618-.00955.44884-.31056.4929-.58338a2.55511,2.55511,0,0,1,.14867-.81023,2.61556,2.61556,0,0,1,.41447-.47441A1.94619,1.94619,0,0,0,995.37031,453.39317Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.2"
        />
        <g opacity="0.1">
          <path
            d="M1004.15264,458.33012c-.03089-.10791-.06641-.21455-.10335-.32082C1004.08037,458.11709,1004.11566,458.2238,1004.15264,458.33012Z"
            transform="translate(-68.27659 -52.19946)"
          />
          <path
            d="M1012.51744,455.92887a.96508.96508,0,0,1-.01272.26,2.7026,2.7026,0,0,1-.58522.99841,4.24594,4.24594,0,0,0-.79958,2.495,16.41993,16.41993,0,0,1,.09164,2.0268,1.56917,1.56917,0,0,1-1.18712,1.46081c-.24763.02874-.53739-.01809-.71185.16a.61177.61177,0,0,0-.13741.28066,7.44943,7.44943,0,0,0,.10783,2.29122,4.14437,4.14437,0,0,1-.78906,2.6637,2.64351,2.64351,0,0,1-.85082.78147,3.40561,3.40561,0,0,1-1.7452.2894,6.04763,6.04763,0,0,1-4.34871-1.64275.42279.42279,0,0,0-.02638.22144.59642.59642,0,0,0,.15589.27126,5.98863,5.98863,0,0,0,4.40263,1.70032,3.40565,3.40565,0,0,0,1.7452-.2894,2.6437,2.6437,0,0,0,.85081-.78147,4.14441,4.14441,0,0,0,.78906-2.6637,7.45007,7.45007,0,0,1-.10783-2.29122.61185.61185,0,0,1,.13741-.28067c.17446-.17806.46422-.13123.71186-.16a1.56916,1.56916,0,0,0,1.18711-1.46081,16.41813,16.41813,0,0,0-.09164-2.02681,4.246,4.246,0,0,1,.79959-2.495,2.70263,2.70263,0,0,0,.58521-.99841A1.14136,1.14136,0,0,0,1012.51744,455.92887Z"
            transform="translate(-68.27659 -52.19946)"
          />
        </g>
        <path
          d="M383.7966,478.84374a1.01544,1.01544,0,0,0-.68911.60734l-.10765-.01764-.419-.06778s-2.21855-.183-2.63295-.15477a.82425.82425,0,0,1-.67312-.38071l-1.6496-1.39519-.12775-.10809c.17856-.067.28916-.1024.28916-.1024s-4.42641-5.49791-5.38038-5.60937a7.43256,7.43256,0,0,1-2.54811-1.40349c-.00586-.029-.01187-.05786-.0173-.087-.0345-.18522-.06014-.37359-.07914-.56l.23453.144h0c-.00043-.06524.00335-.13037.00665-.19551h0a3.55153,3.55153,0,0,1,.65983-1.88671,8.86929,8.86929,0,0,0,1.41759-1.8803,2.73643,2.73643,0,0,0,.14489-.987,3.29178,3.29178,0,0,0-.46081-1.71766,2.15137,2.15137,0,0,0-1.44835-.99947c-.15718-.02406-.31774-.02751-.47248-.06385-.92255-.21664-1.26082-1.45255-2.1578-1.75624a1.82116,1.82116,0,0,0-1.28568.12683c-.40382.17474-.7683.42671-1.16253.6216a7.20068,7.20068,0,0,0-1.19841.61136c-.03764.02845-.07646.06186-.11554.09748h0q-.03558.03243-.07131.06826h0a2.50576,2.50576,0,0,0-.3826.49894l-.0166.02815c-.0112.01993-.02154.04013-.03207.06031l-.02393.04639c-.00882.018-.01691.03614-.02512.0543s-.01628.036-.0238.05419c-.00708.0171-.01357.03419-.02.05135-.00731.01937-.01428.0387-.02076.05811l-.01541.04924c-.006.02021-.01131.04034-.01626.0605l-.01085.04732c-.00426.0208-.00757.04143-.01064.06208-.00223.015-.00461.03007-.00618.045-.00225.02144-.00315.0426-.004.06379-.00054.0139-.00156.02788-.00145.04165.00018.023.00217.04554.00423.06808.00106.01152.00124.02323.00281.03462a.70546.70546,0,0,0,.0202.09787l.00024.00118a1.91778,1.91778,0,0,0,.42883.602c-.01814.017-.03687.03334-.05469.05065a3.90967,3.90967,0,0,0-1.1339,3.51779,3.741,3.741,0,0,0-.65427-.39678,5.71392,5.71392,0,0,0-2.4358-.55877,16.737,16.737,0,0,1-3.3078-.53327,1.33473,1.33473,0,0,1,.10823.29835c-.08361-.04891-.17534-.10055-.275-.15377a8.03955,8.03955,0,0,0-2.5803-.86535s-.57238.08021-.64907-1.12406a5.12555,5.12555,0,0,0-.20207-1.10832,18.8959,18.8959,0,0,1-.681-3.36356l-.185-1.77991s.86416-4.60814.34515-6.56727a1.36177,1.36177,0,0,0-.47908-1.58506c-2.175-1.60042-4.36917,4.6318-4.36917,4.6318l-.81563.79148a1.75848,1.75848,0,0,0-.69164-.26429,3.88711,3.88711,0,0,0-.7441,1.67573,8.11076,8.11076,0,0,1-2.2665,2.61125c-.7091.6207-1.39445,1.26618-2.07784,1.91437-.506.4799-1.63246,1.16721-4.08874,1.556-.3855.061-.7362.118-1.05608.17138a3.29255,3.29255,0,0,0,.12345-.89241,3.34312,3.34312,0,0,0-2.62313-3.24822.81415.81415,0,0,0,.00322-.23674.98272.98272,0,0,0-.24757-.4527,4.82568,4.82568,0,0,0-1.85-1.60179,2.41846,2.41846,0,0,0-.99849-.15994l-.01005-.00058c-.02149-.00083-.043-.00029-.06449-.00058-.03191-.00032-.06382-.00036-.09574.00051-.03434.0008-.06857.00217-.10288.00434l-.00473.0002.00106.00011a2.55729,2.55729,0,0,0-1.871.97515c-.27654.36934-.44217.80693-.68091,1.20111a5.36647,5.36647,0,0,1-1.86058,1.73788c-.44275.268-.90958.49928-1.32784.80316a4.98084,4.98084,0,0,0-1.83824,4.968,7.6292,7.6292,0,0,1,.42824,2.40082,4.20948,4.20948,0,0,1-.75981,1.73091,5.40735,5.40735,0,0,0-.84928,1.697,1.67609,1.67609,0,0,0,.52624,1.722,4.03754,4.03754,0,0,1,.58434.39082,1.85605,1.85605,0,0,1,.26948.4225,4.20123,4.20123,0,0,0,2.613,2.03006,1.90332,1.90332,0,0,0,.53487.05882l.01905-.00078.03554-.00146a.902.902,0,0,0,.97187-.44608,1.02112,1.02112,0,0,1,.09355-.23822.28223.28223,0,0,1,.16252-.112,1.49728,1.49728,0,0,1,.38027.14305,4.83213,4.83213,0,0,0,1.84729.52253,2.55848,2.55848,0,0,0,.32486.006,1.43634,1.43634,0,0,0,.661-.09476,1.39647,1.39647,0,0,0,.50869-.43527c.02947-.03779.05706-.07662.08451-.11552a9.26967,9.26967,0,0,1-.829,2.58416,4.71615,4.71615,0,0,0-.62546,2.25519,2.26229,2.26229,0,0,0,.253,1.19041s.01918-.04945.05844-.12709a9.55776,9.55776,0,0,0,1.24163,1.72081,12.17725,12.17725,0,0,1-.11714,2.68033,5.53368,5.53368,0,0,0,2.11781,6.10041l.70393,1.54278-2.89882.20551c-.29275-.04055-4.083-.55112-4.1013.191-.01908.772.57238,8.28451,2.53755,7.77614,1.83181-.47386,1.22695-2.66459,1.13638-2.95988.02166-.00562.04343-.0108.06484-.01746l-.0721-.01963,1.46567-1.39005a.64733.64733,0,0,0-.10971-.48169l.01432-.00785,3.53956.15878.82961,1.81821s1.41188,2.14644.26711,3.954a18.35225,18.35225,0,0,0-2.51847,6.34517,7.01991,7.01991,0,0,1-1.56529,3.23237c-.66336.22857-3.20933,1.22409-2.19335,2.73625,1.16384,1.73221,4.94156,5.02719,6.4679,4.91422s.91581-1.22385.91581-1.22385l-1.27831-1.24268a30.028,30.028,0,0,1-.13356-3.40794.79305.79305,0,0,0-.56228-.81172,8.57591,8.57591,0,0,1,1.07743-3.387c.9158-1.26151,3.854-6.81589,3.854-6.81589s.93488-.82846.725-3.295c-.0846-.99428-.132-1.86894-.1584-2.55921l3.32558.14917s3.56783-.35774,1.14476-4.17991-7.57451-7.569-7.57451-7.569l-.04553-2.36625c.23318.05863.36988.088.36988.088s-.01971-.08538-.05338-.23782l.05338.01188a51.42664,51.42664,0,0,1-.97305-5.78365l.20988.09747c2.2132,2.56066,3.70139.3954,3.70139.3954s4.67444-6.57113,4.21654-6.26987a.39347.39347,0,0,1-.30771.01846l.33928-1.07286s1.38031-2.10878-.623-3.295c-1.6356-.96845-1.59245,2.06631-1.52149,3.21322-.05163-.04328-.08117-.06887-.08117-.06887s-1.56451,2.35355-2.404,3.67154-1.54543.45188-1.54543.45188l-1.06148-1.19539a4.19454,4.19454,0,0,0,.25289-1.49632,2.53948,2.53948,0,0,0-.71776-1.94008,3.366,3.366,0,0,1-1.07081-2.24048,2.36749,2.36749,0,0,1,.21223-.9227l5.51394-2.9184s1.16384.01882,2.72835-2.39121a41.47982,41.47982,0,0,1,3.33889-4.40586s-.03165-.04673-.08867-.12467c.0571-.06571.08867-.10127.08867-.10127s-.06315-.09324-.17294-.23745l.85107-.98087a12.53577,12.53577,0,0,0-.01036,1.33129l.4396,1.48782L349.282,466.53s-.26673.79079,1.45041,1.58159c1.45385.66991,3.756,1.79849,4.4268,2.12836-.024.061-.03892.09377-.03892.09377.06868-.00565.13508-.01017.20033-.01356l.02862.01356.001-.00044c3.35689-.30045,3.24247,3.05027,3.24247,3.05027s.229,6.81589-.80133,9.18827a13.61022,13.61022,0,0,0-.87765,5.30962s.10183-.501.67832.15339l-.03687.18326c-.32855,1.64372-1.00854,5.1379-1.1379,6.55455a22.9865,22.9865,0,0,1-.74409,3.82179l-.34343,6.26987,2.146.10369-.02363.22506a.704.704,0,0,1-.36312.54667c-.73488.3983-2.46723,1.79853-2.33164,6.11068l-.07441.69462a8.717,8.717,0,0,1-1.04754,3.34755c-.04894.08708-.09264.17188-.13028.25288a.20682.20682,0,0,1,.05908-.12077s-1.11507.2312-.88612,3.24374.57238,3.53975,1.03028,3.57741,2.69019.58368,2.57572-.5272a20.25874,20.25874,0,0,1-.07632-3.954c.15264-.37657.75624-1.39156.17962-1.63632h0a8.63428,8.63428,0,0,0,.24052-2.11017,13.82643,13.82643,0,0,1,1.92664-2.42887,5.42107,5.42107,0,0,0,1.526-3.21966c.01946-.0949,2.36622-1.65728,2.02279-2.95644-.05953-.22255-.10417-.42251-.13737-.60213-.01523-.08069-.02759-.15572-.03867-.228l.04211.002.47736-2.86268v2.787l.28255.0375-.0101.22459-.11987,2.67283a4.39127,4.39127,0,0,1-.34239,1.51292,14.80161,14.80161,0,0,0-1.1839,6.73624l-.027,2.56653c-.08033.01548-1.24675.2908-1.02565,3.2.22895,3.01255.57238,3.53974,1.03028,3.5774s2.69019.58368,2.57572-.5272a20.25794,20.25794,0,0,1-.07632-3.954c.15263-.37654.41516-1.3711-.16134-1.61594a2.1312,2.1312,0,0,1,.24054-.96819c.25145-.42867,1.09052-2.46228,1.72375-4.02613a14.41957,14.41957,0,0,0,1.061-4.97773l.00162-.05731a4.67481,4.67481,0,0,1,.36577-1.677,10.89749,10.89749,0,0,0,.61067-1.84223c.01559-.07528.02831-.14857.03952-.22069l.54775.0727L369.85,497.7471a38.82271,38.82271,0,0,0,.26216-6.3704c-.01021-.08105-.02207-.15676-.03488-.22927l.11577.0101s.38159-.97908.26711-5.159.76318-5.4979.76318-5.4979c.47442-1.50312.99779-2.00639,1.303-2.17481h0a.55473.55473,0,0,1,.26155-.08459l1.41594,1.61962-.00026.00076.00187.00109.26143.299-.00121-.019.11568.13237a1.19464,1.19464,0,0,1-.00916-.20109c.75555.43832,2.50131,1.46523,3.54419,2.2018a3.22912,3.22912,0,0,0,2.91914.74786,8.00425,8.00425,0,0,0,2.349-.77159l.05984-.02829a2.90978,2.90978,0,0,0,.55261.22091s1.91747,1.62395,2.1035-1.34153S383.7966,478.84374,383.7966,478.84374Zm-49.74778,34.537a2.722,2.722,0,0,1-.56453-.23645Zm-3.00091-32.10828.00689.42127-.02968.01382C331.0341,481.56455,331.04153,481.41844,331.04791,481.27248Zm29.99813,37.593-.00173.16452C361.00842,518.97088,360.99507,518.92049,361.046,518.8655Z"
          transform="translate(-68.27659 -52.19946)"
          fill="url(#be5f500e-5c68-43e8-825c-0afbeb8a08aa)"
        />
        <rect
          x="295.63578"
          y="417.32413"
          width="3.25654"
          height="3.42498"
          fill="#ff7590"
        />
        <path
          d="M359.95361,509.07035a5.41694,5.41694,0,0,1-1.49689,3.20039,13.721,13.721,0,0,0-1.88992,2.41433c-.01909,2.3391-.6367,3.04992-.6367,3.04992l-.63671.16844h-1.57213a7.78054,7.78054,0,0,1-.33688-1.2532,1.46747,1.46747,0,0,1,.247-.69839,8.74745,8.74745,0,0,0,1.02758-3.32752l.073-.69046c-.133-4.28635,1.56633-5.6782,2.28721-6.07411a.70017.70017,0,0,0,.3562-.54341h0l.1269-1.22513,4.23013.20662a3.35463,3.35463,0,0,0,.07075,1.23524c.03257.17855.07636.37731.13475.59853C362.27473,507.423,359.9727,508.976,359.95361,509.07035Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#a05e6c"
        />
        <path
          d="M367.12586,506.11027a10.93438,10.93438,0,0,1-.599,1.83121,4.69953,4.69953,0,0,0-.3588,1.66695l-.00159.057a14.49718,14.49718,0,0,1-1.04079,4.94794c-.62116,1.55449-1.44425,3.57592-1.6909,4.002a3.30625,3.30625,0,0,0-.16844,1.909l-2.38065-.16844.04155-4.00555a14.88387,14.88387,0,0,1,1.16134-6.69593,4.414,4.414,0,0,0,.33587-1.50387l.11759-2.65683.03481-.78494s4.20879-.59853,4.56365.356A2.05915,2.05915,0,0,1,367.12586,506.11027Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#a05e6c"
        />
        <path
          d="M361.8031,505.53307l-4.42778-.21673.1269-1.22513,4.23013.20662A3.35463,3.35463,0,0,0,361.8031,505.53307Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M367.12586,506.11027l-4.58386-.6165.03481-.78494s4.20879-.59853,4.56365.356A2.05915,2.05915,0,0,1,367.12586,506.11027Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M369.53682,497.915l-1.83489,8.04815-5.4272-.72991v-2.77031l-.46826,2.84554-6.51308-.31892.33688-6.23234a23.116,23.116,0,0,0,.72991-3.79892c.1269-1.40818.79393-4.88145,1.11621-6.51533.10668-.53789.17518-.877.17518-.877s11.15533,2.32,11.88525,3.16221a1.77164,1.77164,0,0,1,.25716.85457A39.09894,39.09894,0,0,1,369.53682,497.915Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#bdd2e8"
        />
        <path
          d="M356.51028,498.43943s4.39067-2.302,5.46124-1.81543Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M358.9059,490.9157s3.64957,2.76993,3.76187,3.51856Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M357.914,500.46073s2.63893-.11229,3.48113.56147Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M362.66777,497.49794s1.25395,4.10445.71119,5.2274-1.10423-.262-1.10423-.262Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M360.90528,518.90073s-1.23524.18715-1.01065,3.18167.56147,3.51857,1.01065,3.556,2.63892.58019,2.52663-.524a20.40448,20.40448,0,0,1-.07487-3.93031c.14973-.37432.40728-1.363-.15836-1.60634l-.12237.577s-1.19781-1.10423-1.909-.29945a3.13283,3.13283,0,0,0-.14652-.57581C360.94984,519.09993,360.79471,519.0113,360.90528,518.90073Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#494457"
        />
        <path
          d="M383.51187,482.15673s-.283.15833-.69847.356a7.77979,7.77979,0,0,1-2.30428.767,3.13707,3.13707,0,0,1-2.86351-.74339c-1.023-.73216-2.7355-1.75292-3.47664-2.18862-.16058-.09433-.27624-.1617-.329-.192l-.03256-.01909.00449-.01347.61874-1.70014,2.18975-1.1645.54351.466,1.61816,1.38684a.80768.80768,0,0,0,.66029.37843c.4065-.02807,2.58277.15385,2.58277.15385l.411.06737.86579.14374Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#a05e6c"
        />
        <path
          d="M383.51187,482.15673s-.283.15833-.69847.356c-.43907-.22122-.98482-.64569-.77483-1.33855.18977-.62323.24143-1.10947.39752-1.4632l.86579.14374Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M383.21766,479.12478s2.4424-.70184,2.25993,2.24589-2.06342,1.33349-2.06342,1.33349-1.60019-.4211-1.26331-1.53S382.38949,479.39148,383.21766,479.12478Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#a05e6c"
        />
        <path
          d="M357.89525,469.57974l-2.54347,1.069-.0393.01685-.02808-.01348c-.0292-.01572-.0831-.04267-.15833-.07973-.65805-.3279-2.91629-1.44972-4.34243-2.11562-1.68442-.78606-1.42277-1.57212-1.42277-1.57212l-.24256-8.23456-.43121-1.47892s-.30432-5.01283,2.1336-6.2694c2.43791-1.2577.86129,7.261.86129,7.261l.18143,1.76926a19.00248,19.00248,0,0,0,.66806,3.34343,5.15538,5.15538,0,0,1,.19822,1.10169c.07524,1.197.63671,1.11733.63671,1.11733a7.81641,7.81641,0,0,1,2.53112.86017,6.3311,6.3311,0,0,1,.83771.53Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#a05e6c"
        />
        <path
          d="M366.954,473.51005l-2.17177-.22459a8.34422,8.34422,0,0,0,.92194-1.87869,3.19113,3.19113,0,0,0,.09545-.38741,1.29257,1.29257,0,0,0-.119-.95339c-.63559-.9354,3.781-2.24589,3.781-2.24589a10.78809,10.78809,0,0,0-.04828,1.55865,7.88593,7.88593,0,0,0,.11454,1.07916,2.67673,2.67673,0,0,0,.90733,1.76077C371.81977,473.17317,366.954,473.51005,366.954,473.51005Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#a05e6c"
        />
        <path
          d="M366.954,473.51005l-2.17177-.22459a8.34422,8.34422,0,0,0,.92194-1.87869.78036.78036,0,0,0,.68836.41886,3.21541,3.21541,0,0,0,3.13527-1.36774,2.67673,2.67673,0,0,0,.90733,1.76077C371.81977,473.17317,366.954,473.51005,366.954,473.51005Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M374.169,480.34766a1.20234,1.20234,0,0,0,.009.19989l-.338-.39191-.02807-.03256.61874-1.70014,2.18975-1.1645.54351.466C376.38678,478.01867,374.20378,478.96644,374.169,480.34766Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M357.89525,469.57974l-2.54347,1.069-.06738.00337c-.064.00337-.12914.00787-.19651.01348,0,0,.0146-.03256.03818-.09321.21223-.51543,1.19706-3.03307.77146-4.21778a6.3311,6.3311,0,0,1,.83771.53Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M369.794,491.58273c-.99044-.08872-10.89931-1.005-11.8235-2.46374a5.12439,5.12439,0,0,0-.49409-.676c.10668-.53789.17518-.877.17518-.877s11.15533,2.32,11.88525,3.16221A1.77164,1.77164,0,0,1,369.794,491.58273Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M366.3922,471.93793a3.20993,3.20993,0,0,0,3.15192-1.39416,7.28387,7.28387,0,0,0,2.50024,1.39565c.93578.1108,5.27784,5.5758,5.27784,5.5758s-3.48113,1.123-3.25654,2.91966l-1.647-1.909s-.82349-.03743-1.53469,2.24589c0,0-.86092,1.3101-.74863,5.465s-.262,5.12812-.262,5.12812-10.93-.93579-11.90322-2.47048-1.12294-.78606-1.12294-.78606a13.69483,13.69483,0,0,1,.86092-5.27785c1.01065-2.35818.78606-9.13328.78606-9.13328s.1123-3.33141-3.18167-3.03195c0,0,1.385-3.21909.74863-4.45434a16.22121,16.22121,0,0,0,3.24475.53008,5.54425,5.54425,0,0,1,2.38938.55542,2.65562,2.65562,0,0,1,.99124.74863,1.45534,1.45534,0,0,0,1.68442.48661,16.97451,16.97451,0,0,0,.97709,2.39572c.04357.08231.0879.16257.13283.23994.06538.11257.132.219.19946.31675A.79931.79931,0,0,0,366.3922,471.93793Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#ff6784"
        />
        <path
          d="M369.4133,469.37873a3.84547,3.84547,0,0,1-.39752.47725,3.91814,3.91814,0,0,1-2.81074,1.18359,4.03413,4.03413,0,0,1-.40538-.02021,1.29257,1.29257,0,0,0-.119-.95339c-.63559-.9354,3.781-2.24589,3.781-2.24589A10.78809,10.78809,0,0,0,369.4133,469.37873Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M370.13535,466.997a3.93065,3.93065,0,1,1-3.93031-3.93031A3.91577,3.91577,0,0,1,370.13535,466.997Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#a05e6c"
        />
        <path
          d="M372.08179,475.98053l.0803,2.62943s1.17365-.945,1.21108-1.84337S372.08179,475.98053,372.08179,475.98053Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M362.61162,478.61s3.0881,4.23925,4.88481,4.66971S363.28538,479.98544,362.61162,478.61Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M365.88687,479.05174s1.72185,1.94461,2.95709,2.18792Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M359.823,483.95344s3.14425,3.0881,4.941,3.27526Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M370.13535,466.997a3.91577,3.91577,0,0,1-1.11957,2.74672q-.21561-.13476-.43122-.26838a1.19226,1.19226,0,0,1-.42-.365,1.45118,1.45118,0,0,1-.08983-.81413,1.9155,1.9155,0,0,0-.59741-1.5901c-.74451-.59628-1.9382-.26613-2.6917-.85119a2.65628,2.65628,0,0,1-.47725-.53115q-.35541-.475-.70971-.95113c-.04267-.05615-.09432-.11679-.14934-.17855a3.93065,3.93065,0,0,1,6.686,2.80287Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M363.8367,461.966a7.02824,7.02824,0,0,1,1.17556-.6077c.38673-.19372.74426-.44418,1.14038-.61788a1.76512,1.76512,0,0,1,1.26117-.12608c.87989.30188,1.21172,1.53039,2.11668,1.74574.15179.03612.3093.03954.46348.06346a2.11055,2.11055,0,0,1,1.42075.99349,3.30571,3.30571,0,0,1,.452,1.70738,2.75352,2.75352,0,0,1-.14213.98112,8.80711,8.80711,0,0,1-1.39057,1.869,3.55917,3.55917,0,0,0-.65378,2.06976l-1.09555-.68171a1.18944,1.18944,0,0,1-.4205-.36507,1.45406,1.45406,0,0,1-.0898-.81362,1.91608,1.91608,0,0,0-.59664-1.59058c-.74463-.59571-1.93916-.266-2.69248-.85069a2.6662,2.6662,0,0,1-.47681-.53151l-.70988-.95045a2.78956,2.78956,0,0,1-.51629-.71538A1.82757,1.82757,0,0,1,363.8367,461.966Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#372134"
        />
        <path
          d="M368.707,469.24036a1.18932,1.18932,0,0,1-.42049-.36507,1.454,1.454,0,0,1-.08981-.81362,1.91607,1.91607,0,0,0-.59663-1.59058c-.74464-.59571-1.93916-.266-2.69248-.8507a2.66561,2.66561,0,0,1-.47682-.5315l-.70988-.95045a2.78956,2.78956,0,0,1-.51629-.71538,1.648,1.648,0,0,1,.51873-1.36012,1.75339,1.75339,0,0,0-.641,1.48242,2.78945,2.78945,0,0,0,.51628.71538l.70988.95044a2.666,2.666,0,0,0,.47682.53152c.75332.58468,1.94784.255,2.69247.85068a1.916,1.916,0,0,1,.59664,1.59059,1.45407,1.45407,0,0,0,.0898.81362,1.18944,1.18944,0,0,0,.4205.36507l1.09556.68171c-.00042-.06485.00328-.12959.00652-.19434Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M353.5615,516.08315s-1.09382.22982-.86923,3.22434.56147,3.51856,1.01065,3.556,2.63892.58019,2.52663-.524a20.40438,20.40438,0,0,1-.07487-3.9303c.14973-.37432.74183-1.38323.17619-1.62654l-.45692.59717s-1.19781-1.10423-1.909-.29945C353.96494,517.08032,353.29948,516.34517,353.5615,516.08315Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#494457"
        />
        <path
          d="M354.25315,517.94271c.237.109.45824.2497.694.3614a1.54532,1.54532,0,0,0,.75338.17752.52662.52662,0,0,0,.30793-.10629"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M361.4513,520.87568a3.84634,3.84634,0,0,0,.40749.40075,1.41839,1.41839,0,0,0,.78333.16327.24612.24612,0,0,0,.25423-.12642l.14763-.18912"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M342.99751,471.077s-.50532-4.79123,1.45983-3.61214.61116,3.27526.61116,3.27526l-.46143,1.47854Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#ffccd0"
        />
        <path
          d="M346.14176,455.76752l1.12294-1.10423s2.15231-6.19491,4.28591-4.60407-2.70443,5.61472-2.70443,5.61472l-1.282,1.49726Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#ffccd0"
        />
        <path
          d="M329.70933,480.26644l-.05615,1.27267s1.02937,1.79671,1.45983,1.92772.393-3.7993.393-3.7993Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#dce6f2"
        />
        <path
          d="M329.99007,480.491l-.05615,1.27267s1.02936,1.79671,1.45983,1.92772.393-3.7993.393-3.7993Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <polygon
          points="263.155 426.671 263.23 431.361 268.451 431.361 268.058 428.628 263.155 426.671"
          fill="#ffccd0"
        />
        <path
          d="M332.6477,490.57881l.24331,1.49726,3.05066,6.77511s1.385,2.13359.262,3.9303a18.38544,18.38544,0,0,0-2.47047,6.30721,7.32634,7.32634,0,0,1-1.66571,3.36884l3.21911,1.36625a10.07514,10.07514,0,0,1,1.12295-3.93031c.89835-1.254,3.78058-6.7751,3.78058-6.7751s.91707-.8235.7112-3.27526-.18716-4.17361-.18716-4.17361l-.31817-3.91159Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#575988"
        />
        <path
          d="M332.6477,490.57881l.24331,1.49726,3.05066,6.77511s1.385,2.13359.262,3.9303a18.38544,18.38544,0,0,0-2.47047,6.30721,7.32634,7.32634,0,0,1-1.66571,3.36884l3.21911,1.36625a10.07514,10.07514,0,0,1,1.12295-3.93031c.89835-1.254,3.78058-6.7751,3.78058-6.7751s.91707-.8235.7112-3.27526-.18716-4.17361-.18716-4.17361l-.31817-3.91159Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M332.34825,512.25165s-3.4437,1.04809-2.302,2.76993,4.84738,4.99711,6.34464,4.88482.89836-1.21653.89836-1.21653l-1.254-1.23524a30.24165,30.24165,0,0,1-.131-3.38755c.09358-.76734-1.0668-1.12294-1.21652-.67377S332.34825,512.25165,332.34825,512.25165Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#ff748e"
        />
        <path
          d="M334.51928,481.56878l-2.72994.30134a.97879.97879,0,0,0-.87158.9985,15.526,15.526,0,0,1-.1042,3.14355,5.5457,5.5457,0,0,0,2.07745,6.0639l4.06131,1.29139-6.51308.4679.20588,3.61214,1.01065-.56148,12.35239.56148s3.49985-.3556,1.123-4.1549-7.43016-7.52373-7.43016-7.52373l-.05614-2.95709-.37432-.86093Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#575988"
        />
        <path
          d="M337.90683,493.31131a3.50672,3.50672,0,0,1,2.80736,0Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M330.75741,493.81664s-4.02389-.58019-4.0426.18716.56147,8.23493,2.48919,7.7296,1.10423-2.9758,1.10423-2.9758l1.44112-1.385s.14972-.76734-.80478-.69248Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#ff748e"
        />
        <path
          d="M337.42022,472.87372l1.59084,1.81542s.69248.86093,1.516-.44918,2.35819-3.64957,2.35819-3.64957,1.70313,1.49726,2.15231,1.19781-4.13618,6.23235-4.13618,6.23235-1.45983,2.15231-3.63086-.393l-.63633-.29946Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#dce6f2"
        />
        <path
          d="M337.42022,472.81757l1.59084,1.81543s.69248.86092,1.516-.44918,2.35819-3.64957,2.35819-3.64957,1.70313,1.49726,2.15231,1.1978-4.13618,6.23235-4.13618,6.23235-1.45983,2.15231-3.63086-.393l-.63633-.29945Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <circle cx="264.27974" cy="409.98204" r="3.31269" fill="#ffccd0" />
        <path
          d="M332.55633,463.965s-2.847,1.34753-2.51012,3.70572a52.13947,52.13947,0,0,1,.393,5.334s1.29213,1.909-.42073,5.55857c0,0-1.09524,1.85286-.36533,3.2004,0,0,.80919-2.1336,2.90315-.56148a16.67262,16.67262,0,0,0,5.46279,2.302s-1.74056-7.636-.67376-8.70282c0,0,1.85285-2.75122.16844-4.49178a2.96934,2.96934,0,0,1-.84221-3.36884l5.40885-2.90094s1.14166.01872,2.67635-2.3769a41.16908,41.16908,0,0,1,3.27526-4.37948s-1.16038-1.74057-2.24589-1.87158a3.88461,3.88461,0,0,0-.72992,1.6657,8.03542,8.03542,0,0,1-2.22331,2.59563c-.69559.617-1.36787,1.2586-2.03823,1.9029-.49633.477-1.60135,1.16024-4.01082,1.54666C332.81614,463.75914,332.55633,463.965,332.55633,463.965Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M332.55633,463.74043s-2.847,1.34753-2.51012,3.70572a52.13947,52.13947,0,0,1,.393,5.334s1.29213,1.909-.42073,5.55857c0,0-1.09524,1.85286-.36533,3.2004,0,0,.80919-2.1336,2.90315-.56147a16.67274,16.67274,0,0,0,5.46279,2.302s-1.74056-7.636-.67376-8.70282c0,0,1.85285-2.75122.16844-4.49178a2.96934,2.96934,0,0,1-.84221-3.36884l5.40885-2.90094s1.14166.01872,2.67635-2.3769a41.17031,41.17031,0,0,1,3.27526-4.37948s-1.16038-1.74057-2.24589-1.87158a3.88461,3.88461,0,0,0-.72992,1.6657,8.03542,8.03542,0,0,1-2.22331,2.59563c-.69559.617-1.36787,1.2586-2.03823,1.9029-.49633.477-1.60135,1.16024-4.01082,1.54666C332.81614,463.53456,332.55633,463.74043,332.55633,463.74043Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#dce6f2"
        />
        <path
          d="M335.00589,477.8521a27.42222,27.42222,0,0,1,2.2646,3.818S336.93361,478.17027,335.00589,477.8521Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M332.10495,466.88468a2.71768,2.71768,0,0,0,3.76407.29945A4.773,4.773,0,0,1,332.10495,466.88468Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M333.299,458.71739a.98071.98071,0,0,0-.24285-.45,4.75241,4.75241,0,0,0-1.81471-1.59221,2.508,2.508,0,0,0-2.86181.81431c-.27127.36713-.43374.8021-.66793,1.19391a5.293,5.293,0,0,1-1.82513,1.72749c-.4343.26638-.89224.49629-1.30253.79835a4.98567,4.98567,0,0,0-1.80321,4.9383,7.67378,7.67378,0,0,1,.42008,2.38645,4.21218,4.21218,0,0,1-.74532,1.72056,5.40291,5.40291,0,0,0-.8331,1.68684,1.67965,1.67965,0,0,0,.51621,1.71166,3.95876,3.95876,0,0,1,.57321.38848,1.84833,1.84833,0,0,1,.26434.42,4.12975,4.12975,0,0,0,2.56316,2.01792c.48322.12609,1.13147.08037,1.307-.38717a1.02368,1.02368,0,0,1,.09176-.2368c.159-.22775.5109-.09792.757.03087a4.69285,4.69285,0,0,0,1.81209.51941,1.51057,1.51057,0,0,0,.74249-.08823,1.37486,1.37486,0,0,0,.499-.43266,5.3202,5.3202,0,0,0,.86135-2.73891,6.45913,6.45913,0,0,0-.00776-1.88669c-.19035-.99411-.79625-1.92422-.70655-2.93241.096-1.07829.97017-1.9595,1.10419-3.03372a2.31206,2.31206,0,0,0-.3944-1.593,2.25686,2.25686,0,0,1-.29916-.46924.46572.46572,0,0,1,.0889-.51567.791.791,0,0,1,.2337-.1141,1.94432,1.94432,0,0,0,1.15922-1.74093,3.59219,3.59219,0,0,1,.07783-.813C332.98958,459.63184,333.36314,459.16941,333.299,458.71739Z"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M333.07445,458.71739a.98071.98071,0,0,0-.24285-.45,4.75241,4.75241,0,0,0-1.81471-1.59221,2.508,2.508,0,0,0-2.86181.81431c-.27126.36713-.43374.8021-.66793,1.19391a5.29288,5.29288,0,0,1-1.82513,1.72749c-.4343.26638-.89224.49629-1.30253.79835a4.98567,4.98567,0,0,0-1.80321,4.9383,7.67378,7.67378,0,0,1,.42008,2.38645,4.212,4.212,0,0,1-.74532,1.72056,5.40291,5.40291,0,0,0-.8331,1.68684,1.67967,1.67967,0,0,0,.51621,1.71166,3.95876,3.95876,0,0,1,.57321.38848,1.84833,1.84833,0,0,1,.26434.42,4.12975,4.12975,0,0,0,2.56317,2.01792c.48321.12609,1.13146.08037,1.307-.38717a1.02368,1.02368,0,0,1,.09176-.2368c.159-.22775.5109-.09792.757.03087a4.69285,4.69285,0,0,0,1.81209.51941,1.51057,1.51057,0,0,0,.74249-.08823,1.37486,1.37486,0,0,0,.499-.43266,5.3202,5.3202,0,0,0,.86135-2.73891,6.45913,6.45913,0,0,0-.00776-1.88669c-.19035-.99411-.79625-1.92422-.70654-2.93241.09594-1.07829.97016-1.9595,1.10418-3.03372a2.31206,2.31206,0,0,0-.3944-1.593,2.25686,2.25686,0,0,1-.29916-.46924.46572.46572,0,0,1,.0889-.51567.791.791,0,0,1,.2337-.1141,1.9443,1.9443,0,0,0,1.15922-1.74093,3.59163,3.59163,0,0,1,.07784-.813C332.765,459.63184,333.13855,459.16941,333.07445,458.71739Z"
          transform="translate(-68.27659 -52.19946)"
          fill="#ffdfd0"
        />
        <g opacity="0.1">
          <path
            d="M326.383,475.85475a1.02315,1.02315,0,0,0-.09176.23679.7529.7529,0,0,1-.68235.43853.91446.91446,0,0,0,1.01923-.43853,1.02315,1.02315,0,0,1,.09176-.23679.27508.27508,0,0,1,.11475-.09544A.38551.38551,0,0,0,326.383,475.85475Z"
            transform="translate(-68.27659 -52.19946)"
          />
          <path
            d="M333.08067,458.71668a.98079.98079,0,0,0-.24285-.45,4.75257,4.75257,0,0,0-1.81471-1.59221,2.35266,2.35266,0,0,0-1.03368-.1544,2.29171,2.29171,0,0,1,.69679.1544,4.75242,4.75242,0,0,1,1.81471,1.59221.98081.98081,0,0,1,.24286.45c.06409.452-.30947.91445-.43291,1.32986a3.59206,3.59206,0,0,0-.07784.813,1.94432,1.94432,0,0,1-1.15922,1.74094.79064.79064,0,0,0-.2337.1141.46573.46573,0,0,0-.0889.51567,2.2572,2.2572,0,0,0,.29916.46923,2.31211,2.31211,0,0,1,.39441,1.593c-.134,1.07422-1.00825,1.95544-1.1042,3.03373-.0897,1.00819.51621,1.93829.70655,2.9324a6.45885,6.45885,0,0,1,.00776,1.8867,5.32017,5.32017,0,0,1-.86135,2.7389,1.37484,1.37484,0,0,1-.499.43267,1.11617,1.11617,0,0,1-.36677.09069,1.45936,1.45936,0,0,0,.70365-.09069,1.37468,1.37468,0,0,0,.499-.43267,5.32017,5.32017,0,0,0,.86136-2.7389,6.45885,6.45885,0,0,0-.00777-1.8867c-.19034-.99411-.79625-1.92421-.70654-2.9324.096-1.07829.97016-1.95951,1.10419-3.03373a2.312,2.312,0,0,0-.39441-1.593,2.25761,2.25761,0,0,1-.29916-.46923.46573.46573,0,0,1,.08891-.51567.79059.79059,0,0,1,.23369-.1141,1.94433,1.94433,0,0,0,1.15923-1.74094,3.59205,3.59205,0,0,1,.07783-.813C332.7712,459.63113,333.14476,459.1687,333.08067,458.71668Z"
            transform="translate(-68.27659 -52.19946)"
          />
        </g>
        <path
          d="M328.82828,498.345a1.51822,1.51822,0,0,0,1.55405.42884"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
        <path
          d="M336.02441,517.55371a.9534.9534,0,0,1-.77437.196"
          transform="translate(-68.27659 -52.19946)"
          opacity="0.1"
        />
      </svg>
      <h2
        class="bottom-text lead text-center "
        [innerHTML]="'pending.luckyYou' | translate"
      ></h2>
      <button
        class="d-flex align-items-center justify-content-center btn btn-outline-secondary mt-3"
        (click)="signOut()"
      >
        <svg
          class="logout-icon mr-1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
        >
          <path
            d="M160 96c17.7 0 32-14.3 32-32s-14.3-32-32-32H96C43 32 0 75 0 128V384c0 53 43 96 96 96h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H96c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32h64zM504.5 273.4c4.8-4.5 7.5-10.8 7.5-17.4s-2.7-12.9-7.5-17.4l-144-136c-7-6.6-17.2-8.4-26-4.6s-14.5 12.5-14.5 22v72H192c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32H320v72c0 9.6 5.7 18.2 14.5 22s19 2 26-4.6l144-136z"
          />
        </svg>
        {{ 'common.signOut' | translate }}
      </button>
    </div>
  </div>
</div>
